// This file is generated from the backend API contract. Do not edit it by hand.
export const WITHOUT_RELATION_FILTER_VALUE = "__WITHOUT_CATEGORY__";
export const FILTER_EXPRESSION_PARAMETER = "filterExpression";
export const FILTER_EXPRESSION_RECOMMENDED_MAX_LENGTH = 6000;
const resources = {
"storeMenus": {
        "key": "storeMenus",
        "method": "get",
        "endpoint": "/store/menus",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "in"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "in",
                    "contains"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "in"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "greater_than_equal",
                    "less_than_equal"
                ]
            },
            "mainType": {
                "key": "mainType",
                "wireKey": "where[main_type][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "main_type"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id"
            },
            "name": {
                "key": "name",
                "wireKey": "name"
            },
            "position": {
                "key": "position",
                "wireKey": "position"
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at"
            }
        }
    },
"storeBanners": {
        "key": "storeBanners",
        "method": "get",
        "endpoint": "/store/banners",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "in"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "in",
                    "contains"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "in"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "greater_than_equal",
                    "less_than_equal"
                ]
            },
            "type": {
                "key": "type",
                "wireKey": "where[type][equals]",
                "operators": [
                    "equals",
                    "in"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id"
            },
            "name": {
                "key": "name",
                "wireKey": "name"
            },
            "position": {
                "key": "position",
                "wireKey": "position"
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at"
            }
        }
    },
"storeRegions": {
        "key": "storeRegions",
        "method": "get",
        "endpoint": "/store/regions",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "in"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "in",
                    "contains"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "in"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "greater_than_equal",
                    "less_than_equal"
                ]
            },
            "countryId": {
                "key": "countryId",
                "wireKey": "where[country_id][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "country_id"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id"
            },
            "name": {
                "key": "name",
                "wireKey": "name"
            },
            "position": {
                "key": "position",
                "wireKey": "position"
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at"
            }
        }
    },
"storePromotions": {
        "key": "storePromotions",
        "method": "get",
        "endpoint": "/store/promotions",
        "queryFormat": "payload",
        "booleanWhere": false,
        "multiSort": false,
        "filters": {}
    },
"storeReservationServices": {
        "key": "storeReservationServices",
        "method": "get",
        "endpoint": "/store/reservation-services",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "in"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "in",
                    "contains"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "in"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "greater_than_equal",
                    "less_than_equal"
                ]
            },
            "categories": {
                "key": "categories",
                "wireKey": "where[categories][equals]",
                "operators": [
                    "equals",
                    "in"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id"
            },
            "name": {
                "key": "name",
                "wireKey": "name"
            },
            "position": {
                "key": "position",
                "wireKey": "position"
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at"
            }
        }
    },
"storeReservationPeople": {
        "key": "storeReservationPeople",
        "method": "get",
        "endpoint": "/store/reservation-people",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {}
    },
"storeTags": {
        "key": "storeTags",
        "method": "get",
        "endpoint": "/store/tags",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "showHomepage": {
                "key": "showHomepage",
                "wireKey": "where[show_homepage][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "show_homepage"
                ]
            },
            "showMenu": {
                "key": "showMenu",
                "wireKey": "where[show_menu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "show_menu"
                ]
            },
            "isNovelty": {
                "key": "isNovelty",
                "wireKey": "where[is_novelty][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_novelty"
                ]
            },
            "isPromotion": {
                "key": "isPromotion",
                "wireKey": "where[is_promotion][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_promotion"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "showHomepage": {
                "key": "showHomepage",
                "wireKey": "show_homepage",
                "legacyKeys": [
                    "show_homepage"
                ]
            },
            "showMenu": {
                "key": "showMenu",
                "wireKey": "show_menu",
                "legacyKeys": [
                    "show_menu"
                ]
            },
            "isNovelty": {
                "key": "isNovelty",
                "wireKey": "is_novelty",
                "legacyKeys": [
                    "is_novelty"
                ]
            },
            "isPromotion": {
                "key": "isPromotion",
                "wireKey": "is_promotion",
                "legacyKeys": [
                    "is_promotion"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeProductQuestions": {
        "key": "storeProductQuestions",
        "method": "get",
        "endpoint": "/store/product-questions",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "answer": {
                "key": "answer",
                "wireKey": "where[answer][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "answer"
                ]
            },
            "email": {
                "key": "email",
                "wireKey": "where[email][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "email"
                ]
            },
            "productId": {
                "key": "productId",
                "wireKey": "where[product_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "product_id"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "answer": {
                "key": "answer",
                "wireKey": "answer",
                "legacyKeys": [
                    "answer"
                ]
            },
            "email": {
                "key": "email",
                "wireKey": "email",
                "legacyKeys": [
                    "email"
                ]
            },
            "productId": {
                "key": "productId",
                "wireKey": "product_id",
                "legacyKeys": [
                    "product_id"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeProducts": {
        "key": "storeProducts",
        "method": "get",
        "endpoint": "/store/products",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "geoRadius": {
                "key": "geoRadius",
                "wireKey": "where[geo_radius][equals]",
                "operators": [
                    "equals"
                ],
                "valueType": "geoRadius"
            },
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "where[slug][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug"
                ]
            },
            "description": {
                "key": "description",
                "wireKey": "where[description][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description"
                ]
            },
            "shortDescription": {
                "key": "shortDescription",
                "wireKey": "where[short_description][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description"
                ]
            },
            "searchCategoryNames": {
                "key": "searchCategoryNames",
                "wireKey": "where[search_category_names][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "search_category_names"
                ]
            },
            "nameSk": {
                "key": "nameSk",
                "wireKey": "where[name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_sk"
                ]
            },
            "slugSk": {
                "key": "slugSk",
                "wireKey": "where[slug_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_sk"
                ]
            },
            "descriptionSk": {
                "key": "descriptionSk",
                "wireKey": "where[description_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_sk"
                ]
            },
            "shortDescriptionSk": {
                "key": "shortDescriptionSk",
                "wireKey": "where[short_description_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_sk"
                ]
            },
            "nameCs": {
                "key": "nameCs",
                "wireKey": "where[name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_cs"
                ]
            },
            "slugCs": {
                "key": "slugCs",
                "wireKey": "where[slug_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_cs"
                ]
            },
            "descriptionCs": {
                "key": "descriptionCs",
                "wireKey": "where[description_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_cs"
                ]
            },
            "shortDescriptionCs": {
                "key": "shortDescriptionCs",
                "wireKey": "where[short_description_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_cs"
                ]
            },
            "nameEn": {
                "key": "nameEn",
                "wireKey": "where[name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_en"
                ]
            },
            "slugEn": {
                "key": "slugEn",
                "wireKey": "where[slug_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_en"
                ]
            },
            "descriptionEn": {
                "key": "descriptionEn",
                "wireKey": "where[description_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_en"
                ]
            },
            "shortDescriptionEn": {
                "key": "shortDescriptionEn",
                "wireKey": "where[short_description_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_en"
                ]
            },
            "namePl": {
                "key": "namePl",
                "wireKey": "where[name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pl"
                ]
            },
            "slugPl": {
                "key": "slugPl",
                "wireKey": "where[slug_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pl"
                ]
            },
            "descriptionPl": {
                "key": "descriptionPl",
                "wireKey": "where[description_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_pl"
                ]
            },
            "shortDescriptionPl": {
                "key": "shortDescriptionPl",
                "wireKey": "where[short_description_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_pl"
                ]
            },
            "nameHu": {
                "key": "nameHu",
                "wireKey": "where[name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hu"
                ]
            },
            "slugHu": {
                "key": "slugHu",
                "wireKey": "where[slug_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hu"
                ]
            },
            "descriptionHu": {
                "key": "descriptionHu",
                "wireKey": "where[description_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_hu"
                ]
            },
            "shortDescriptionHu": {
                "key": "shortDescriptionHu",
                "wireKey": "where[short_description_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_hu"
                ]
            },
            "nameEs": {
                "key": "nameEs",
                "wireKey": "where[name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_es"
                ]
            },
            "slugEs": {
                "key": "slugEs",
                "wireKey": "where[slug_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_es"
                ]
            },
            "descriptionEs": {
                "key": "descriptionEs",
                "wireKey": "where[description_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_es"
                ]
            },
            "shortDescriptionEs": {
                "key": "shortDescriptionEs",
                "wireKey": "where[short_description_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_es"
                ]
            },
            "nameFr": {
                "key": "nameFr",
                "wireKey": "where[name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fr"
                ]
            },
            "slugFr": {
                "key": "slugFr",
                "wireKey": "where[slug_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fr"
                ]
            },
            "descriptionFr": {
                "key": "descriptionFr",
                "wireKey": "where[description_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_fr"
                ]
            },
            "shortDescriptionFr": {
                "key": "shortDescriptionFr",
                "wireKey": "where[short_description_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_fr"
                ]
            },
            "nameHr": {
                "key": "nameHr",
                "wireKey": "where[name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hr"
                ]
            },
            "slugHr": {
                "key": "slugHr",
                "wireKey": "where[slug_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hr"
                ]
            },
            "descriptionHr": {
                "key": "descriptionHr",
                "wireKey": "where[description_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_hr"
                ]
            },
            "shortDescriptionHr": {
                "key": "shortDescriptionHr",
                "wireKey": "where[short_description_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_hr"
                ]
            },
            "nameIt": {
                "key": "nameIt",
                "wireKey": "where[name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_it"
                ]
            },
            "slugIt": {
                "key": "slugIt",
                "wireKey": "where[slug_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_it"
                ]
            },
            "descriptionIt": {
                "key": "descriptionIt",
                "wireKey": "where[description_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_it"
                ]
            },
            "shortDescriptionIt": {
                "key": "shortDescriptionIt",
                "wireKey": "where[short_description_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_it"
                ]
            },
            "nameDe": {
                "key": "nameDe",
                "wireKey": "where[name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_de"
                ]
            },
            "slugDe": {
                "key": "slugDe",
                "wireKey": "where[slug_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_de"
                ]
            },
            "descriptionDe": {
                "key": "descriptionDe",
                "wireKey": "where[description_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_de"
                ]
            },
            "shortDescriptionDe": {
                "key": "shortDescriptionDe",
                "wireKey": "where[short_description_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_de"
                ]
            },
            "nameBe": {
                "key": "nameBe",
                "wireKey": "where[name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_be"
                ]
            },
            "slugBe": {
                "key": "slugBe",
                "wireKey": "where[slug_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_be"
                ]
            },
            "descriptionBe": {
                "key": "descriptionBe",
                "wireKey": "where[description_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_be"
                ]
            },
            "shortDescriptionBe": {
                "key": "shortDescriptionBe",
                "wireKey": "where[short_description_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_be"
                ]
            },
            "nameBg": {
                "key": "nameBg",
                "wireKey": "where[name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_bg"
                ]
            },
            "slugBg": {
                "key": "slugBg",
                "wireKey": "where[slug_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_bg"
                ]
            },
            "descriptionBg": {
                "key": "descriptionBg",
                "wireKey": "where[description_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_bg"
                ]
            },
            "shortDescriptionBg": {
                "key": "shortDescriptionBg",
                "wireKey": "where[short_description_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_bg"
                ]
            },
            "nameGr": {
                "key": "nameGr",
                "wireKey": "where[name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_gr"
                ]
            },
            "slugGr": {
                "key": "slugGr",
                "wireKey": "where[slug_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_gr"
                ]
            },
            "descriptionGr": {
                "key": "descriptionGr",
                "wireKey": "where[description_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_gr"
                ]
            },
            "shortDescriptionGr": {
                "key": "shortDescriptionGr",
                "wireKey": "where[short_description_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_gr"
                ]
            },
            "nameSe": {
                "key": "nameSe",
                "wireKey": "where[name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_se"
                ]
            },
            "slugSe": {
                "key": "slugSe",
                "wireKey": "where[slug_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_se"
                ]
            },
            "descriptionSe": {
                "key": "descriptionSe",
                "wireKey": "where[description_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_se"
                ]
            },
            "shortDescriptionSe": {
                "key": "shortDescriptionSe",
                "wireKey": "where[short_description_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_se"
                ]
            },
            "nameFi": {
                "key": "nameFi",
                "wireKey": "where[name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fi"
                ]
            },
            "slugFi": {
                "key": "slugFi",
                "wireKey": "where[slug_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fi"
                ]
            },
            "descriptionFi": {
                "key": "descriptionFi",
                "wireKey": "where[description_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_fi"
                ]
            },
            "shortDescriptionFi": {
                "key": "shortDescriptionFi",
                "wireKey": "where[short_description_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_fi"
                ]
            },
            "nameDk": {
                "key": "nameDk",
                "wireKey": "where[name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_dk"
                ]
            },
            "slugDk": {
                "key": "slugDk",
                "wireKey": "where[slug_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_dk"
                ]
            },
            "descriptionDk": {
                "key": "descriptionDk",
                "wireKey": "where[description_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_dk"
                ]
            },
            "shortDescriptionDk": {
                "key": "shortDescriptionDk",
                "wireKey": "where[short_description_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_dk"
                ]
            },
            "nameNr": {
                "key": "nameNr",
                "wireKey": "where[name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nr"
                ]
            },
            "slugNr": {
                "key": "slugNr",
                "wireKey": "where[slug_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nr"
                ]
            },
            "descriptionNr": {
                "key": "descriptionNr",
                "wireKey": "where[description_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_nr"
                ]
            },
            "shortDescriptionNr": {
                "key": "shortDescriptionNr",
                "wireKey": "where[short_description_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_nr"
                ]
            },
            "nameRu": {
                "key": "nameRu",
                "wireKey": "where[name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ru"
                ]
            },
            "slugRu": {
                "key": "slugRu",
                "wireKey": "where[slug_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ru"
                ]
            },
            "descriptionRu": {
                "key": "descriptionRu",
                "wireKey": "where[description_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_ru"
                ]
            },
            "shortDescriptionRu": {
                "key": "shortDescriptionRu",
                "wireKey": "where[short_description_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_ru"
                ]
            },
            "nameRo": {
                "key": "nameRo",
                "wireKey": "where[name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ro"
                ]
            },
            "slugRo": {
                "key": "slugRo",
                "wireKey": "where[slug_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ro"
                ]
            },
            "descriptionRo": {
                "key": "descriptionRo",
                "wireKey": "where[description_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_ro"
                ]
            },
            "shortDescriptionRo": {
                "key": "shortDescriptionRo",
                "wireKey": "where[short_description_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_ro"
                ]
            },
            "nameNl": {
                "key": "nameNl",
                "wireKey": "where[name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nl"
                ]
            },
            "slugNl": {
                "key": "slugNl",
                "wireKey": "where[slug_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nl"
                ]
            },
            "descriptionNl": {
                "key": "descriptionNl",
                "wireKey": "where[description_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_nl"
                ]
            },
            "shortDescriptionNl": {
                "key": "shortDescriptionNl",
                "wireKey": "where[short_description_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_nl"
                ]
            },
            "nameSi": {
                "key": "nameSi",
                "wireKey": "where[name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_si"
                ]
            },
            "slugSi": {
                "key": "slugSi",
                "wireKey": "where[slug_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_si"
                ]
            },
            "descriptionSi": {
                "key": "descriptionSi",
                "wireKey": "where[description_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_si"
                ]
            },
            "shortDescriptionSi": {
                "key": "shortDescriptionSi",
                "wireKey": "where[short_description_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_si"
                ]
            },
            "nameAt": {
                "key": "nameAt",
                "wireKey": "where[name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_at"
                ]
            },
            "slugAt": {
                "key": "slugAt",
                "wireKey": "where[slug_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_at"
                ]
            },
            "descriptionAt": {
                "key": "descriptionAt",
                "wireKey": "where[description_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_at"
                ]
            },
            "shortDescriptionAt": {
                "key": "shortDescriptionAt",
                "wireKey": "where[short_description_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_at"
                ]
            },
            "nameBr": {
                "key": "nameBr",
                "wireKey": "where[name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_br"
                ]
            },
            "slugBr": {
                "key": "slugBr",
                "wireKey": "where[slug_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_br"
                ]
            },
            "descriptionBr": {
                "key": "descriptionBr",
                "wireKey": "where[description_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_br"
                ]
            },
            "shortDescriptionBr": {
                "key": "shortDescriptionBr",
                "wireKey": "where[short_description_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_br"
                ]
            },
            "namePt": {
                "key": "namePt",
                "wireKey": "where[name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pt"
                ]
            },
            "slugPt": {
                "key": "slugPt",
                "wireKey": "where[slug_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pt"
                ]
            },
            "descriptionPt": {
                "key": "descriptionPt",
                "wireKey": "where[description_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_pt"
                ]
            },
            "shortDescriptionPt": {
                "key": "shortDescriptionPt",
                "wireKey": "where[short_description_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_pt"
                ]
            },
            "nameUa": {
                "key": "nameUa",
                "wireKey": "where[name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ua"
                ]
            },
            "slugUa": {
                "key": "slugUa",
                "wireKey": "where[slug_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ua"
                ]
            },
            "descriptionUa": {
                "key": "descriptionUa",
                "wireKey": "where[description_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_ua"
                ]
            },
            "shortDescriptionUa": {
                "key": "shortDescriptionUa",
                "wireKey": "where[short_description_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_ua"
                ]
            },
            "nameTr": {
                "key": "nameTr",
                "wireKey": "where[name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_tr"
                ]
            },
            "slugTr": {
                "key": "slugTr",
                "wireKey": "where[slug_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_tr"
                ]
            },
            "descriptionTr": {
                "key": "descriptionTr",
                "wireKey": "where[description_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_tr"
                ]
            },
            "shortDescriptionTr": {
                "key": "shortDescriptionTr",
                "wireKey": "where[short_description_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_tr"
                ]
            },
            "nameEe": {
                "key": "nameEe",
                "wireKey": "where[name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ee"
                ]
            },
            "slugEe": {
                "key": "slugEe",
                "wireKey": "where[slug_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ee"
                ]
            },
            "descriptionEe": {
                "key": "descriptionEe",
                "wireKey": "where[description_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_ee"
                ]
            },
            "shortDescriptionEe": {
                "key": "shortDescriptionEe",
                "wireKey": "where[short_description_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_ee"
                ]
            },
            "nameLv": {
                "key": "nameLv",
                "wireKey": "where[name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lv"
                ]
            },
            "slugLv": {
                "key": "slugLv",
                "wireKey": "where[slug_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lv"
                ]
            },
            "descriptionLv": {
                "key": "descriptionLv",
                "wireKey": "where[description_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_lv"
                ]
            },
            "shortDescriptionLv": {
                "key": "shortDescriptionLv",
                "wireKey": "where[short_description_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_lv"
                ]
            },
            "nameUs": {
                "key": "nameUs",
                "wireKey": "where[name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_us"
                ]
            },
            "slugUs": {
                "key": "slugUs",
                "wireKey": "where[slug_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_us"
                ]
            },
            "descriptionUs": {
                "key": "descriptionUs",
                "wireKey": "where[description_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_us"
                ]
            },
            "shortDescriptionUs": {
                "key": "shortDescriptionUs",
                "wireKey": "where[short_description_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_us"
                ]
            },
            "nameAu": {
                "key": "nameAu",
                "wireKey": "where[name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_au"
                ]
            },
            "slugAu": {
                "key": "slugAu",
                "wireKey": "where[slug_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_au"
                ]
            },
            "descriptionAu": {
                "key": "descriptionAu",
                "wireKey": "where[description_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_au"
                ]
            },
            "shortDescriptionAu": {
                "key": "shortDescriptionAu",
                "wireKey": "where[short_description_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_au"
                ]
            },
            "nameCa": {
                "key": "nameCa",
                "wireKey": "where[name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ca"
                ]
            },
            "slugCa": {
                "key": "slugCa",
                "wireKey": "where[slug_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ca"
                ]
            },
            "descriptionCa": {
                "key": "descriptionCa",
                "wireKey": "where[description_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_ca"
                ]
            },
            "shortDescriptionCa": {
                "key": "shortDescriptionCa",
                "wireKey": "where[short_description_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_ca"
                ]
            },
            "nameCh": {
                "key": "nameCh",
                "wireKey": "where[name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ch"
                ]
            },
            "slugCh": {
                "key": "slugCh",
                "wireKey": "where[slug_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ch"
                ]
            },
            "descriptionCh": {
                "key": "descriptionCh",
                "wireKey": "where[description_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_ch"
                ]
            },
            "shortDescriptionCh": {
                "key": "shortDescriptionCh",
                "wireKey": "where[short_description_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_ch"
                ]
            },
            "nameIn": {
                "key": "nameIn",
                "wireKey": "where[name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_in"
                ]
            },
            "slugIn": {
                "key": "slugIn",
                "wireKey": "where[slug_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_in"
                ]
            },
            "descriptionIn": {
                "key": "descriptionIn",
                "wireKey": "where[description_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_in"
                ]
            },
            "shortDescriptionIn": {
                "key": "shortDescriptionIn",
                "wireKey": "where[short_description_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_in"
                ]
            },
            "nameJp": {
                "key": "nameJp",
                "wireKey": "where[name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_jp"
                ]
            },
            "slugJp": {
                "key": "slugJp",
                "wireKey": "where[slug_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_jp"
                ]
            },
            "descriptionJp": {
                "key": "descriptionJp",
                "wireKey": "where[description_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_jp"
                ]
            },
            "shortDescriptionJp": {
                "key": "shortDescriptionJp",
                "wireKey": "where[short_description_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_jp"
                ]
            },
            "nameMx": {
                "key": "nameMx",
                "wireKey": "where[name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_mx"
                ]
            },
            "slugMx": {
                "key": "slugMx",
                "wireKey": "where[slug_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_mx"
                ]
            },
            "descriptionMx": {
                "key": "descriptionMx",
                "wireKey": "where[description_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_mx"
                ]
            },
            "shortDescriptionMx": {
                "key": "shortDescriptionMx",
                "wireKey": "where[short_description_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_mx"
                ]
            },
            "nameRs": {
                "key": "nameRs",
                "wireKey": "where[name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_rs"
                ]
            },
            "slugRs": {
                "key": "slugRs",
                "wireKey": "where[slug_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_rs"
                ]
            },
            "descriptionRs": {
                "key": "descriptionRs",
                "wireKey": "where[description_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_rs"
                ]
            },
            "shortDescriptionRs": {
                "key": "shortDescriptionRs",
                "wireKey": "where[short_description_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_rs"
                ]
            },
            "nameBa": {
                "key": "nameBa",
                "wireKey": "where[name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ba"
                ]
            },
            "slugBa": {
                "key": "slugBa",
                "wireKey": "where[slug_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ba"
                ]
            },
            "descriptionBa": {
                "key": "descriptionBa",
                "wireKey": "where[description_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_ba"
                ]
            },
            "shortDescriptionBa": {
                "key": "shortDescriptionBa",
                "wireKey": "where[short_description_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_ba"
                ]
            },
            "nameLt": {
                "key": "nameLt",
                "wireKey": "where[name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lt"
                ]
            },
            "slugLt": {
                "key": "slugLt",
                "wireKey": "where[slug_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lt"
                ]
            },
            "descriptionLt": {
                "key": "descriptionLt",
                "wireKey": "where[description_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "description_lt"
                ]
            },
            "shortDescriptionLt": {
                "key": "shortDescriptionLt",
                "wireKey": "where[short_description_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "short_description_lt"
                ]
            },
            "code": {
                "key": "code",
                "wireKey": "where[code][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "code"
                ]
            },
            "ean": {
                "key": "ean",
                "wireKey": "where[ean][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "ean"
                ]
            },
            "extCode": {
                "key": "extCode",
                "wireKey": "where[ext_code][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "ext_code"
                ]
            },
            "searchIdentifiers": {
                "key": "searchIdentifiers",
                "wireKey": "where[search_identifiers][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "search_identifiers"
                ]
            },
            "searchPrimaryNameTerms": {
                "key": "searchPrimaryNameTerms",
                "wireKey": "where[search_primary_name_terms][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "search_primary_name_terms"
                ]
            },
            "searchNameTokenCount": {
                "key": "searchNameTokenCount",
                "wireKey": "where[search_name_token_count][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "search_name_token_count"
                ]
            },
            "views": {
                "key": "views",
                "wireKey": "where[views][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "views"
                ]
            },
            "salesCount": {
                "key": "salesCount",
                "wireKey": "where[sales_count][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "sales_count"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "quantity": {
                "key": "quantity",
                "wireKey": "where[quantity][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "quantity"
                ]
            },
            "suppliersPricesEnabled": {
                "key": "suppliersPricesEnabled",
                "wireKey": "where[suppliers_prices_enabled][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "suppliers_prices_enabled"
                ]
            },
            "onlyAffiliate": {
                "key": "onlyAffiliate",
                "wireKey": "where[only_affiliate][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "only_affiliate"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "discounted": {
                "key": "discounted",
                "wireKey": "where[discounted][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "discounted"
                ]
            },
            "hasQuantity": {
                "key": "hasQuantity",
                "wireKey": "where[has_quantity][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "has_quantity"
                ]
            },
            "manufacturers": {
                "key": "manufacturers",
                "wireKey": "where[manufacturers][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "manufacturers"
                ]
            },
            "suppliers": {
                "key": "suppliers",
                "wireKey": "where[suppliers][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "suppliers"
                ]
            },
            "importFeedKeys": {
                "key": "importFeedKeys",
                "wireKey": "where[import_feed_keys][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "import_feed_keys"
                ]
            },
            "segmentsId": {
                "key": "segmentsId",
                "wireKey": "where[segments.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "segments.id"
                ]
            },
            "segmentsPosition": {
                "key": "segmentsPosition",
                "wireKey": "where[segments.position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "segments.position"
                ]
            },
            "availabilityId": {
                "key": "availabilityId",
                "wireKey": "where[availability_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "availability_id"
                ]
            },
            "unavailabilityId": {
                "key": "unavailabilityId",
                "wireKey": "where[unavailability_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "unavailability_id"
                ]
            },
            "tags": {
                "key": "tags",
                "wireKey": "where[tags][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tags"
                ]
            },
            "tagSettingsStoreId": {
                "key": "tagSettingsStoreId",
                "wireKey": "where[tag_settings.store_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tag_settings.store_id"
                ]
            },
            "tagSettingsTagId": {
                "key": "tagSettingsTagId",
                "wireKey": "where[tag_settings.tag_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tag_settings.tag_id"
                ]
            },
            "tagSettingsExpiresAt": {
                "key": "tagSettingsExpiresAt",
                "wireKey": "where[tag_settings.expires_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tag_settings.expires_at"
                ]
            },
            "tagSettingsCreatedAt": {
                "key": "tagSettingsCreatedAt",
                "wireKey": "where[tag_settings.created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tag_settings.created_at"
                ]
            },
            "values": {
                "key": "values",
                "wireKey": "where[values][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "values"
                ]
            },
            "availability": {
                "key": "availability",
                "wireKey": "where[availability][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "availability"
                ]
            },
            "suppliersGeo": {
                "key": "suppliersGeo",
                "wireKey": "where[suppliers_geo][exists]",
                "operators": [
                    "exists"
                ],
                "legacyKeys": [
                    "suppliers_geo"
                ]
            },
            "statusChangedAt": {
                "key": "statusChangedAt",
                "wireKey": "where[status_changed_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "status_changed_at"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "categoryIds": {
                "key": "categoryIds",
                "wireKey": "where[category_ids][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "category_ids"
                ]
            },
            "customerGroupIds": {
                "key": "customerGroupIds",
                "wireKey": "where[customer_group_ids][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "customer_group_ids"
                ]
            },
            "storeCategoryKeys": {
                "key": "storeCategoryKeys",
                "wireKey": "where[store_category_keys][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "store_category_keys"
                ]
            },
            "categoryStoreIds": {
                "key": "categoryStoreIds",
                "wireKey": "where[category_store_ids][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "category_store_ids"
                ]
            },
            "categoriesId": {
                "key": "categoriesId",
                "wireKey": "where[categories.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.id"
                ]
            },
            "categoriesNameSk": {
                "key": "categoriesNameSk",
                "wireKey": "where[categories.name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_sk"
                ]
            },
            "categoriesNameCs": {
                "key": "categoriesNameCs",
                "wireKey": "where[categories.name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_cs"
                ]
            },
            "categoriesNameEn": {
                "key": "categoriesNameEn",
                "wireKey": "where[categories.name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_en"
                ]
            },
            "categoriesNamePl": {
                "key": "categoriesNamePl",
                "wireKey": "where[categories.name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_pl"
                ]
            },
            "categoriesNameHu": {
                "key": "categoriesNameHu",
                "wireKey": "where[categories.name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_hu"
                ]
            },
            "categoriesNameEs": {
                "key": "categoriesNameEs",
                "wireKey": "where[categories.name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_es"
                ]
            },
            "categoriesNameFr": {
                "key": "categoriesNameFr",
                "wireKey": "where[categories.name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_fr"
                ]
            },
            "categoriesNameHr": {
                "key": "categoriesNameHr",
                "wireKey": "where[categories.name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_hr"
                ]
            },
            "categoriesNameIt": {
                "key": "categoriesNameIt",
                "wireKey": "where[categories.name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_it"
                ]
            },
            "categoriesNameDe": {
                "key": "categoriesNameDe",
                "wireKey": "where[categories.name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_de"
                ]
            },
            "categoriesNameBe": {
                "key": "categoriesNameBe",
                "wireKey": "where[categories.name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_be"
                ]
            },
            "categoriesNameBg": {
                "key": "categoriesNameBg",
                "wireKey": "where[categories.name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_bg"
                ]
            },
            "categoriesNameGr": {
                "key": "categoriesNameGr",
                "wireKey": "where[categories.name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_gr"
                ]
            },
            "categoriesNameSe": {
                "key": "categoriesNameSe",
                "wireKey": "where[categories.name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_se"
                ]
            },
            "categoriesNameFi": {
                "key": "categoriesNameFi",
                "wireKey": "where[categories.name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_fi"
                ]
            },
            "categoriesNameDk": {
                "key": "categoriesNameDk",
                "wireKey": "where[categories.name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_dk"
                ]
            },
            "categoriesNameNr": {
                "key": "categoriesNameNr",
                "wireKey": "where[categories.name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_nr"
                ]
            },
            "categoriesNameRu": {
                "key": "categoriesNameRu",
                "wireKey": "where[categories.name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ru"
                ]
            },
            "categoriesNameRo": {
                "key": "categoriesNameRo",
                "wireKey": "where[categories.name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ro"
                ]
            },
            "categoriesNameNl": {
                "key": "categoriesNameNl",
                "wireKey": "where[categories.name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_nl"
                ]
            },
            "categoriesNameSi": {
                "key": "categoriesNameSi",
                "wireKey": "where[categories.name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_si"
                ]
            },
            "categoriesNameAt": {
                "key": "categoriesNameAt",
                "wireKey": "where[categories.name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_at"
                ]
            },
            "categoriesNameBr": {
                "key": "categoriesNameBr",
                "wireKey": "where[categories.name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_br"
                ]
            },
            "categoriesNamePt": {
                "key": "categoriesNamePt",
                "wireKey": "where[categories.name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_pt"
                ]
            },
            "categoriesNameUa": {
                "key": "categoriesNameUa",
                "wireKey": "where[categories.name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ua"
                ]
            },
            "categoriesNameTr": {
                "key": "categoriesNameTr",
                "wireKey": "where[categories.name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_tr"
                ]
            },
            "categoriesNameEe": {
                "key": "categoriesNameEe",
                "wireKey": "where[categories.name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ee"
                ]
            },
            "categoriesNameLv": {
                "key": "categoriesNameLv",
                "wireKey": "where[categories.name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_lv"
                ]
            },
            "categoriesNameUs": {
                "key": "categoriesNameUs",
                "wireKey": "where[categories.name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_us"
                ]
            },
            "categoriesNameAu": {
                "key": "categoriesNameAu",
                "wireKey": "where[categories.name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_au"
                ]
            },
            "categoriesNameCa": {
                "key": "categoriesNameCa",
                "wireKey": "where[categories.name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ca"
                ]
            },
            "categoriesNameCh": {
                "key": "categoriesNameCh",
                "wireKey": "where[categories.name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ch"
                ]
            },
            "categoriesNameIn": {
                "key": "categoriesNameIn",
                "wireKey": "where[categories.name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_in"
                ]
            },
            "categoriesNameJp": {
                "key": "categoriesNameJp",
                "wireKey": "where[categories.name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_jp"
                ]
            },
            "categoriesNameMx": {
                "key": "categoriesNameMx",
                "wireKey": "where[categories.name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_mx"
                ]
            },
            "categoriesNameRs": {
                "key": "categoriesNameRs",
                "wireKey": "where[categories.name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_rs"
                ]
            },
            "categoriesNameBa": {
                "key": "categoriesNameBa",
                "wireKey": "where[categories.name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ba"
                ]
            },
            "categoriesNameLt": {
                "key": "categoriesNameLt",
                "wireKey": "where[categories.name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_lt"
                ]
            },
            "storeCategoriesStoreId": {
                "key": "storeCategoriesStoreId",
                "wireKey": "where[store_categories.store_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "store_categories.store_id"
                ]
            },
            "storeCategoriesDirectCategoryId": {
                "key": "storeCategoriesDirectCategoryId",
                "wireKey": "where[store_categories.direct_category_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "store_categories.direct_category_id"
                ]
            },
            "storeCategoriesCategoryIds": {
                "key": "storeCategoriesCategoryIds",
                "wireKey": "where[store_categories.category_ids][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "store_categories.category_ids"
                ]
            },
            "categoryPositionsCategoryId": {
                "key": "categoryPositionsCategoryId",
                "wireKey": "where[category_positions.category_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "category_positions.category_id"
                ]
            },
            "categoryPositionsPosition": {
                "key": "categoryPositionsPosition",
                "wireKey": "where[category_positions.position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "category_positions.position"
                ]
            },
            "categoryPositionsStoreId": {
                "key": "categoryPositionsStoreId",
                "wireKey": "where[category_positions.store_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "category_positions.store_id"
                ]
            },
            "pricesStoreId": {
                "key": "pricesStoreId",
                "wireKey": "where[prices.store_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.store_id"
                ]
            },
            "pricesPrice": {
                "key": "pricesPrice",
                "wireKey": "where[prices.price][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.price"
                ]
            },
            "pricesPriceWithVat": {
                "key": "pricesPriceWithVat",
                "wireKey": "where[prices.price_with_vat][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.price_with_vat"
                ]
            },
            "pricesWholesalePrice": {
                "key": "pricesWholesalePrice",
                "wireKey": "where[prices.wholesale_price][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.wholesale_price"
                ]
            },
            "pricesWholesalePriceWithVat": {
                "key": "pricesWholesalePriceWithVat",
                "wireKey": "where[prices.wholesale_price_with_vat][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.wholesale_price_with_vat"
                ]
            },
            "pricesAskForPrice": {
                "key": "pricesAskForPrice",
                "wireKey": "where[prices.ask_for_price][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.ask_for_price"
                ]
            },
            "storesId": {
                "key": "storesId",
                "wireKey": "where[stores.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.id"
                ]
            },
            "storesName": {
                "key": "storesName",
                "wireKey": "where[stores.name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.name"
                ]
            },
            "supplierSettingsSupplierId": {
                "key": "supplierSettingsSupplierId",
                "wireKey": "where[supplier_settings.supplier_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "supplier_settings.supplier_id"
                ]
            },
            "supplierSettingsAvailabilityId": {
                "key": "supplierSettingsAvailabilityId",
                "wireKey": "where[supplier_settings.availability_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "supplier_settings.availability_id"
                ]
            },
            "supplierSettingsQuantity": {
                "key": "supplierSettingsQuantity",
                "wireKey": "where[supplier_settings.quantity][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "supplier_settings.quantity"
                ]
            },
            "supplierSettingsUnavailabilityId": {
                "key": "supplierSettingsUnavailabilityId",
                "wireKey": "where[supplier_settings.unavailability_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "supplier_settings.unavailability_id"
                ]
            },
            "activeAvailabilityObjectId": {
                "key": "activeAvailabilityObjectId",
                "wireKey": "where[active_availability_object.id][equals]",
                "operators": [
                    "equals",
                    "in",
                    "not_equals",
                    "not_in"
                ],
                "legacyKeys": [
                    "active_availability_object.id"
                ]
            },
            "allegroMissingRequiredAttributes": {
                "key": "allegroMissingRequiredAttributes",
                "wireKey": "where[allegro_missing_required_attributes][equals]",
                "operators": [
                    "equals"
                ],
                "legacyKeys": [
                    "allegro_missing_required_attributes"
                ]
            },
            "priceFrom": {
                "key": "priceFrom",
                "wireKey": "price_from",
                "operators": [],
                "legacyKeys": [
                    "price_from"
                ]
            },
            "priceTo": {
                "key": "priceTo",
                "wireKey": "price_to",
                "operators": [],
                "legacyKeys": [
                    "price_to"
                ]
            }
        },
        "sorts": {
            "searchCategoryNames": {
                "key": "searchCategoryNames",
                "wireKey": "search_category_names",
                "legacyKeys": [
                    "search_category_names"
                ]
            },
            "categories": {
                "key": "categories",
                "wireKey": "categories",
                "legacyKeys": [
                    "categories"
                ]
            },
            "categoryPositions": {
                "key": "categoryPositions",
                "wireKey": "category_positions",
                "context": {
                    "kind": "category"
                },
                "legacyKeys": [
                    "category_positions"
                ]
            },
            "segments": {
                "key": "segments",
                "wireKey": "segments",
                "context": {
                    "kind": "segment"
                },
                "legacyKeys": [
                    "segments"
                ]
            },
            "hasQuantity": {
                "key": "hasQuantity",
                "wireKey": "has_quantity",
                "legacyKeys": [
                    "has_quantity"
                ]
            },
            "onlyAffiliate": {
                "key": "onlyAffiliate",
                "wireKey": "only_affiliate",
                "legacyKeys": [
                    "only_affiliate"
                ]
            },
            "salesCount": {
                "key": "salesCount",
                "wireKey": "sales_count",
                "legacyKeys": [
                    "sales_count"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "shortDescription": {
                "key": "shortDescription",
                "wireKey": "short_description",
                "legacyKeys": [
                    "short_description"
                ]
            },
            "description": {
                "key": "description",
                "wireKey": "description",
                "legacyKeys": [
                    "description"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "slug",
                "legacyKeys": [
                    "slug"
                ]
            },
            "views": {
                "key": "views",
                "wireKey": "views",
                "legacyKeys": [
                    "views"
                ]
            },
            "quantity": {
                "key": "quantity",
                "wireKey": "quantity",
                "legacyKeys": [
                    "quantity"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "statusChangedAt": {
                "key": "statusChangedAt",
                "wireKey": "status_changed_at",
                "legacyKeys": [
                    "status_changed_at"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "price": {
                "key": "price",
                "wireKey": "price",
                "legacyKeys": [
                    "price"
                ]
            },
            "priceWithVat": {
                "key": "priceWithVat",
                "wireKey": "price_with_vat",
                "legacyKeys": [
                    "price_with_vat"
                ]
            },
            "tagsExpiresAt": {
                "key": "tagsExpiresAt",
                "wireKey": "tags_expires_at",
                "context": {
                    "kind": "tagDate",
                    "maxIds": 100
                },
                "legacyKeys": [
                    "tags_expires_at"
                ]
            },
            "tagsCreatedAt": {
                "key": "tagsCreatedAt",
                "wireKey": "tags_created_at",
                "context": {
                    "kind": "tagDate",
                    "maxIds": 100
                },
                "legacyKeys": [
                    "tags_created_at"
                ]
            },
            "categoryPriority": {
                "key": "categoryPriority",
                "wireKey": "category_priority",
                "context": {
                    "kind": "category"
                },
                "legacyKeys": [
                    "category_priority"
                ]
            },
            "relevance": {
                "key": "relevance",
                "wireKey": "_score",
                "legacyKeys": [
                    "_score"
                ]
            },
            "stores": {
                "key": "stores",
                "wireKey": "stores",
                "legacyKeys": [
                    "stores"
                ]
            }
        }
    },
"storeDailyDeals": {
        "key": "storeDailyDeals",
        "method": "get",
        "endpoint": "/store/daily-deals",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "startsAt": {
                "key": "startsAt",
                "wireKey": "where[starts_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "starts_at"
                ]
            },
            "endsAt": {
                "key": "endsAt",
                "wireKey": "where[ends_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "ends_at"
                ]
            },
            "isRunning": {
                "key": "isRunning",
                "wireKey": "where[is_running][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_running"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "startsAt": {
                "key": "startsAt",
                "wireKey": "starts_at",
                "legacyKeys": [
                    "starts_at"
                ]
            },
            "endsAt": {
                "key": "endsAt",
                "wireKey": "ends_at",
                "legacyKeys": [
                    "ends_at"
                ]
            },
            "isRunning": {
                "key": "isRunning",
                "wireKey": "is_running",
                "legacyKeys": [
                    "is_running"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            }
        }
    },
"storeProductSegments": {
        "key": "storeProductSegments",
        "method": "get",
        "endpoint": "/store/product-segments",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "startsAt": {
                "key": "startsAt",
                "wireKey": "where[starts_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "starts_at"
                ]
            },
            "endsAt": {
                "key": "endsAt",
                "wireKey": "where[ends_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "ends_at"
                ]
            },
            "isRunning": {
                "key": "isRunning",
                "wireKey": "where[is_running][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_running"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "productSegmentTypeKey": {
                "key": "productSegmentTypeKey",
                "wireKey": "where[product_segment_type_key][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "product_segment_type_key"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "startsAt": {
                "key": "startsAt",
                "wireKey": "starts_at",
                "legacyKeys": [
                    "starts_at"
                ]
            },
            "endsAt": {
                "key": "endsAt",
                "wireKey": "ends_at",
                "legacyKeys": [
                    "ends_at"
                ]
            },
            "isRunning": {
                "key": "isRunning",
                "wireKey": "is_running",
                "legacyKeys": [
                    "is_running"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            }
        }
    },
"storeSuppliers": {
        "key": "storeSuppliers",
        "method": "get",
        "endpoint": "/store/suppliers",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "geoRadius": {
                "key": "geoRadius",
                "wireKey": "where[geo_radius][equals]",
                "operators": [
                    "equals"
                ],
                "valueType": "geoRadius"
            },
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "where[slug][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug"
                ]
            },
            "city": {
                "key": "city",
                "wireKey": "where[city][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city"
                ]
            },
            "nameSk": {
                "key": "nameSk",
                "wireKey": "where[name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_sk"
                ]
            },
            "slugSk": {
                "key": "slugSk",
                "wireKey": "where[slug_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_sk"
                ]
            },
            "citySk": {
                "key": "citySk",
                "wireKey": "where[city_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_sk"
                ]
            },
            "nameCs": {
                "key": "nameCs",
                "wireKey": "where[name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_cs"
                ]
            },
            "slugCs": {
                "key": "slugCs",
                "wireKey": "where[slug_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_cs"
                ]
            },
            "cityCs": {
                "key": "cityCs",
                "wireKey": "where[city_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_cs"
                ]
            },
            "nameEn": {
                "key": "nameEn",
                "wireKey": "where[name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_en"
                ]
            },
            "slugEn": {
                "key": "slugEn",
                "wireKey": "where[slug_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_en"
                ]
            },
            "cityEn": {
                "key": "cityEn",
                "wireKey": "where[city_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_en"
                ]
            },
            "namePl": {
                "key": "namePl",
                "wireKey": "where[name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pl"
                ]
            },
            "slugPl": {
                "key": "slugPl",
                "wireKey": "where[slug_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pl"
                ]
            },
            "cityPl": {
                "key": "cityPl",
                "wireKey": "where[city_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_pl"
                ]
            },
            "nameHu": {
                "key": "nameHu",
                "wireKey": "where[name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hu"
                ]
            },
            "slugHu": {
                "key": "slugHu",
                "wireKey": "where[slug_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hu"
                ]
            },
            "cityHu": {
                "key": "cityHu",
                "wireKey": "where[city_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_hu"
                ]
            },
            "nameEs": {
                "key": "nameEs",
                "wireKey": "where[name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_es"
                ]
            },
            "slugEs": {
                "key": "slugEs",
                "wireKey": "where[slug_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_es"
                ]
            },
            "cityEs": {
                "key": "cityEs",
                "wireKey": "where[city_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_es"
                ]
            },
            "nameFr": {
                "key": "nameFr",
                "wireKey": "where[name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fr"
                ]
            },
            "slugFr": {
                "key": "slugFr",
                "wireKey": "where[slug_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fr"
                ]
            },
            "cityFr": {
                "key": "cityFr",
                "wireKey": "where[city_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_fr"
                ]
            },
            "nameHr": {
                "key": "nameHr",
                "wireKey": "where[name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hr"
                ]
            },
            "slugHr": {
                "key": "slugHr",
                "wireKey": "where[slug_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hr"
                ]
            },
            "cityHr": {
                "key": "cityHr",
                "wireKey": "where[city_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_hr"
                ]
            },
            "nameIt": {
                "key": "nameIt",
                "wireKey": "where[name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_it"
                ]
            },
            "slugIt": {
                "key": "slugIt",
                "wireKey": "where[slug_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_it"
                ]
            },
            "cityIt": {
                "key": "cityIt",
                "wireKey": "where[city_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_it"
                ]
            },
            "nameDe": {
                "key": "nameDe",
                "wireKey": "where[name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_de"
                ]
            },
            "slugDe": {
                "key": "slugDe",
                "wireKey": "where[slug_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_de"
                ]
            },
            "cityDe": {
                "key": "cityDe",
                "wireKey": "where[city_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_de"
                ]
            },
            "nameBe": {
                "key": "nameBe",
                "wireKey": "where[name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_be"
                ]
            },
            "slugBe": {
                "key": "slugBe",
                "wireKey": "where[slug_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_be"
                ]
            },
            "cityBe": {
                "key": "cityBe",
                "wireKey": "where[city_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_be"
                ]
            },
            "nameBg": {
                "key": "nameBg",
                "wireKey": "where[name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_bg"
                ]
            },
            "slugBg": {
                "key": "slugBg",
                "wireKey": "where[slug_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_bg"
                ]
            },
            "cityBg": {
                "key": "cityBg",
                "wireKey": "where[city_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_bg"
                ]
            },
            "nameGr": {
                "key": "nameGr",
                "wireKey": "where[name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_gr"
                ]
            },
            "slugGr": {
                "key": "slugGr",
                "wireKey": "where[slug_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_gr"
                ]
            },
            "cityGr": {
                "key": "cityGr",
                "wireKey": "where[city_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_gr"
                ]
            },
            "nameSe": {
                "key": "nameSe",
                "wireKey": "where[name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_se"
                ]
            },
            "slugSe": {
                "key": "slugSe",
                "wireKey": "where[slug_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_se"
                ]
            },
            "citySe": {
                "key": "citySe",
                "wireKey": "where[city_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_se"
                ]
            },
            "nameFi": {
                "key": "nameFi",
                "wireKey": "where[name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fi"
                ]
            },
            "slugFi": {
                "key": "slugFi",
                "wireKey": "where[slug_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fi"
                ]
            },
            "cityFi": {
                "key": "cityFi",
                "wireKey": "where[city_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_fi"
                ]
            },
            "nameDk": {
                "key": "nameDk",
                "wireKey": "where[name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_dk"
                ]
            },
            "slugDk": {
                "key": "slugDk",
                "wireKey": "where[slug_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_dk"
                ]
            },
            "cityDk": {
                "key": "cityDk",
                "wireKey": "where[city_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_dk"
                ]
            },
            "nameNr": {
                "key": "nameNr",
                "wireKey": "where[name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nr"
                ]
            },
            "slugNr": {
                "key": "slugNr",
                "wireKey": "where[slug_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nr"
                ]
            },
            "cityNr": {
                "key": "cityNr",
                "wireKey": "where[city_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_nr"
                ]
            },
            "nameRu": {
                "key": "nameRu",
                "wireKey": "where[name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ru"
                ]
            },
            "slugRu": {
                "key": "slugRu",
                "wireKey": "where[slug_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ru"
                ]
            },
            "cityRu": {
                "key": "cityRu",
                "wireKey": "where[city_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_ru"
                ]
            },
            "nameRo": {
                "key": "nameRo",
                "wireKey": "where[name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ro"
                ]
            },
            "slugRo": {
                "key": "slugRo",
                "wireKey": "where[slug_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ro"
                ]
            },
            "cityRo": {
                "key": "cityRo",
                "wireKey": "where[city_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_ro"
                ]
            },
            "nameNl": {
                "key": "nameNl",
                "wireKey": "where[name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nl"
                ]
            },
            "slugNl": {
                "key": "slugNl",
                "wireKey": "where[slug_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nl"
                ]
            },
            "cityNl": {
                "key": "cityNl",
                "wireKey": "where[city_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_nl"
                ]
            },
            "nameSi": {
                "key": "nameSi",
                "wireKey": "where[name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_si"
                ]
            },
            "slugSi": {
                "key": "slugSi",
                "wireKey": "where[slug_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_si"
                ]
            },
            "citySi": {
                "key": "citySi",
                "wireKey": "where[city_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_si"
                ]
            },
            "nameAt": {
                "key": "nameAt",
                "wireKey": "where[name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_at"
                ]
            },
            "slugAt": {
                "key": "slugAt",
                "wireKey": "where[slug_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_at"
                ]
            },
            "cityAt": {
                "key": "cityAt",
                "wireKey": "where[city_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_at"
                ]
            },
            "nameBr": {
                "key": "nameBr",
                "wireKey": "where[name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_br"
                ]
            },
            "slugBr": {
                "key": "slugBr",
                "wireKey": "where[slug_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_br"
                ]
            },
            "cityBr": {
                "key": "cityBr",
                "wireKey": "where[city_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_br"
                ]
            },
            "namePt": {
                "key": "namePt",
                "wireKey": "where[name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pt"
                ]
            },
            "slugPt": {
                "key": "slugPt",
                "wireKey": "where[slug_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pt"
                ]
            },
            "cityPt": {
                "key": "cityPt",
                "wireKey": "where[city_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_pt"
                ]
            },
            "nameUa": {
                "key": "nameUa",
                "wireKey": "where[name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ua"
                ]
            },
            "slugUa": {
                "key": "slugUa",
                "wireKey": "where[slug_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ua"
                ]
            },
            "cityUa": {
                "key": "cityUa",
                "wireKey": "where[city_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_ua"
                ]
            },
            "nameTr": {
                "key": "nameTr",
                "wireKey": "where[name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_tr"
                ]
            },
            "slugTr": {
                "key": "slugTr",
                "wireKey": "where[slug_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_tr"
                ]
            },
            "cityTr": {
                "key": "cityTr",
                "wireKey": "where[city_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_tr"
                ]
            },
            "nameEe": {
                "key": "nameEe",
                "wireKey": "where[name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ee"
                ]
            },
            "slugEe": {
                "key": "slugEe",
                "wireKey": "where[slug_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ee"
                ]
            },
            "cityEe": {
                "key": "cityEe",
                "wireKey": "where[city_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_ee"
                ]
            },
            "nameLv": {
                "key": "nameLv",
                "wireKey": "where[name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lv"
                ]
            },
            "slugLv": {
                "key": "slugLv",
                "wireKey": "where[slug_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lv"
                ]
            },
            "cityLv": {
                "key": "cityLv",
                "wireKey": "where[city_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_lv"
                ]
            },
            "nameUs": {
                "key": "nameUs",
                "wireKey": "where[name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_us"
                ]
            },
            "slugUs": {
                "key": "slugUs",
                "wireKey": "where[slug_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_us"
                ]
            },
            "cityUs": {
                "key": "cityUs",
                "wireKey": "where[city_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_us"
                ]
            },
            "nameAu": {
                "key": "nameAu",
                "wireKey": "where[name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_au"
                ]
            },
            "slugAu": {
                "key": "slugAu",
                "wireKey": "where[slug_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_au"
                ]
            },
            "cityAu": {
                "key": "cityAu",
                "wireKey": "where[city_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_au"
                ]
            },
            "nameCa": {
                "key": "nameCa",
                "wireKey": "where[name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ca"
                ]
            },
            "slugCa": {
                "key": "slugCa",
                "wireKey": "where[slug_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ca"
                ]
            },
            "cityCa": {
                "key": "cityCa",
                "wireKey": "where[city_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_ca"
                ]
            },
            "nameCh": {
                "key": "nameCh",
                "wireKey": "where[name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ch"
                ]
            },
            "slugCh": {
                "key": "slugCh",
                "wireKey": "where[slug_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ch"
                ]
            },
            "cityCh": {
                "key": "cityCh",
                "wireKey": "where[city_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_ch"
                ]
            },
            "nameIn": {
                "key": "nameIn",
                "wireKey": "where[name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_in"
                ]
            },
            "slugIn": {
                "key": "slugIn",
                "wireKey": "where[slug_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_in"
                ]
            },
            "cityIn": {
                "key": "cityIn",
                "wireKey": "where[city_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_in"
                ]
            },
            "nameJp": {
                "key": "nameJp",
                "wireKey": "where[name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_jp"
                ]
            },
            "slugJp": {
                "key": "slugJp",
                "wireKey": "where[slug_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_jp"
                ]
            },
            "cityJp": {
                "key": "cityJp",
                "wireKey": "where[city_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_jp"
                ]
            },
            "nameMx": {
                "key": "nameMx",
                "wireKey": "where[name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_mx"
                ]
            },
            "slugMx": {
                "key": "slugMx",
                "wireKey": "where[slug_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_mx"
                ]
            },
            "cityMx": {
                "key": "cityMx",
                "wireKey": "where[city_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_mx"
                ]
            },
            "nameRs": {
                "key": "nameRs",
                "wireKey": "where[name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_rs"
                ]
            },
            "slugRs": {
                "key": "slugRs",
                "wireKey": "where[slug_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_rs"
                ]
            },
            "cityRs": {
                "key": "cityRs",
                "wireKey": "where[city_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_rs"
                ]
            },
            "nameBa": {
                "key": "nameBa",
                "wireKey": "where[name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ba"
                ]
            },
            "slugBa": {
                "key": "slugBa",
                "wireKey": "where[slug_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ba"
                ]
            },
            "cityBa": {
                "key": "cityBa",
                "wireKey": "where[city_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_ba"
                ]
            },
            "nameLt": {
                "key": "nameLt",
                "wireKey": "where[name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lt"
                ]
            },
            "slugLt": {
                "key": "slugLt",
                "wireKey": "where[slug_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lt"
                ]
            },
            "cityLt": {
                "key": "cityLt",
                "wireKey": "where[city_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_lt"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "geo": {
                "key": "geo",
                "wireKey": "where[_geo][exists]",
                "operators": [
                    "exists"
                ],
                "legacyKeys": [
                    "_geo"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "city": {
                "key": "city",
                "wireKey": "city",
                "legacyKeys": [
                    "city"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "relevance": {
                "key": "relevance",
                "wireKey": "_score",
                "legacyKeys": [
                    "_score"
                ]
            }
        }
    },
"storeManufacturers": {
        "key": "storeManufacturers",
        "method": "get",
        "endpoint": "/store/manufacturers",
        "queryFormat": "payload",
        "booleanWhere": false,
        "multiSort": false,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "parent": {
                "key": "parent",
                "wireKey": "where[parent][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "parent"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeCategories": {
        "key": "storeCategories",
        "method": "get",
        "endpoint": "/store/categories",
        "queryFormat": "payload",
        "booleanWhere": false,
        "multiSort": false,
        "filters": {
            "typeFlags": {
                "key": "typeFlags",
                "wireKey": "where[type_flags][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "type_flags"
                ]
            },
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "parent": {
                "key": "parent",
                "wireKey": "where[parent][equals]",
                "operators": [
                    "equals",
                    "in",
                    "exists"
                ],
                "legacyKeys": [
                    "parent"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeReviews": {
        "key": "storeReviews",
        "method": "get",
        "endpoint": "/store/reviews",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "rating": {
                "key": "rating",
                "wireKey": "where[rating][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "rating"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "hasText": {
                "key": "hasText",
                "wireKey": "where[has_text][equals]",
                "operators": [
                    "equals"
                ],
                "legacyKeys": []
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "rating": {
                "key": "rating",
                "wireKey": "rating",
                "legacyKeys": [
                    "rating"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeBlogsCategories": {
        "key": "storeBlogsCategories",
        "method": "get",
        "endpoint": "/store/blogs/categories",
        "queryFormat": "payload",
        "booleanWhere": false,
        "multiSort": false,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "parent": {
                "key": "parent",
                "wireKey": "where[parent][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "parent"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeBlogs": {
        "key": "storeBlogs",
        "method": "get",
        "endpoint": "/store/blogs",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "where[slug][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug"
                ]
            },
            "nameSk": {
                "key": "nameSk",
                "wireKey": "where[name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_sk"
                ]
            },
            "slugSk": {
                "key": "slugSk",
                "wireKey": "where[slug_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_sk"
                ]
            },
            "nameCs": {
                "key": "nameCs",
                "wireKey": "where[name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_cs"
                ]
            },
            "slugCs": {
                "key": "slugCs",
                "wireKey": "where[slug_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_cs"
                ]
            },
            "nameEn": {
                "key": "nameEn",
                "wireKey": "where[name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_en"
                ]
            },
            "slugEn": {
                "key": "slugEn",
                "wireKey": "where[slug_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_en"
                ]
            },
            "namePl": {
                "key": "namePl",
                "wireKey": "where[name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pl"
                ]
            },
            "slugPl": {
                "key": "slugPl",
                "wireKey": "where[slug_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pl"
                ]
            },
            "nameHu": {
                "key": "nameHu",
                "wireKey": "where[name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hu"
                ]
            },
            "slugHu": {
                "key": "slugHu",
                "wireKey": "where[slug_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hu"
                ]
            },
            "nameEs": {
                "key": "nameEs",
                "wireKey": "where[name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_es"
                ]
            },
            "slugEs": {
                "key": "slugEs",
                "wireKey": "where[slug_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_es"
                ]
            },
            "nameFr": {
                "key": "nameFr",
                "wireKey": "where[name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fr"
                ]
            },
            "slugFr": {
                "key": "slugFr",
                "wireKey": "where[slug_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fr"
                ]
            },
            "nameHr": {
                "key": "nameHr",
                "wireKey": "where[name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hr"
                ]
            },
            "slugHr": {
                "key": "slugHr",
                "wireKey": "where[slug_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hr"
                ]
            },
            "nameIt": {
                "key": "nameIt",
                "wireKey": "where[name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_it"
                ]
            },
            "slugIt": {
                "key": "slugIt",
                "wireKey": "where[slug_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_it"
                ]
            },
            "nameDe": {
                "key": "nameDe",
                "wireKey": "where[name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_de"
                ]
            },
            "slugDe": {
                "key": "slugDe",
                "wireKey": "where[slug_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_de"
                ]
            },
            "nameBe": {
                "key": "nameBe",
                "wireKey": "where[name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_be"
                ]
            },
            "slugBe": {
                "key": "slugBe",
                "wireKey": "where[slug_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_be"
                ]
            },
            "nameBg": {
                "key": "nameBg",
                "wireKey": "where[name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_bg"
                ]
            },
            "slugBg": {
                "key": "slugBg",
                "wireKey": "where[slug_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_bg"
                ]
            },
            "nameGr": {
                "key": "nameGr",
                "wireKey": "where[name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_gr"
                ]
            },
            "slugGr": {
                "key": "slugGr",
                "wireKey": "where[slug_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_gr"
                ]
            },
            "nameSe": {
                "key": "nameSe",
                "wireKey": "where[name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_se"
                ]
            },
            "slugSe": {
                "key": "slugSe",
                "wireKey": "where[slug_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_se"
                ]
            },
            "nameFi": {
                "key": "nameFi",
                "wireKey": "where[name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fi"
                ]
            },
            "slugFi": {
                "key": "slugFi",
                "wireKey": "where[slug_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fi"
                ]
            },
            "nameDk": {
                "key": "nameDk",
                "wireKey": "where[name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_dk"
                ]
            },
            "slugDk": {
                "key": "slugDk",
                "wireKey": "where[slug_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_dk"
                ]
            },
            "nameNr": {
                "key": "nameNr",
                "wireKey": "where[name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nr"
                ]
            },
            "slugNr": {
                "key": "slugNr",
                "wireKey": "where[slug_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nr"
                ]
            },
            "nameRu": {
                "key": "nameRu",
                "wireKey": "where[name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ru"
                ]
            },
            "slugRu": {
                "key": "slugRu",
                "wireKey": "where[slug_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ru"
                ]
            },
            "nameRo": {
                "key": "nameRo",
                "wireKey": "where[name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ro"
                ]
            },
            "slugRo": {
                "key": "slugRo",
                "wireKey": "where[slug_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ro"
                ]
            },
            "nameNl": {
                "key": "nameNl",
                "wireKey": "where[name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nl"
                ]
            },
            "slugNl": {
                "key": "slugNl",
                "wireKey": "where[slug_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nl"
                ]
            },
            "nameSi": {
                "key": "nameSi",
                "wireKey": "where[name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_si"
                ]
            },
            "slugSi": {
                "key": "slugSi",
                "wireKey": "where[slug_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_si"
                ]
            },
            "nameAt": {
                "key": "nameAt",
                "wireKey": "where[name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_at"
                ]
            },
            "slugAt": {
                "key": "slugAt",
                "wireKey": "where[slug_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_at"
                ]
            },
            "nameBr": {
                "key": "nameBr",
                "wireKey": "where[name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_br"
                ]
            },
            "slugBr": {
                "key": "slugBr",
                "wireKey": "where[slug_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_br"
                ]
            },
            "namePt": {
                "key": "namePt",
                "wireKey": "where[name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pt"
                ]
            },
            "slugPt": {
                "key": "slugPt",
                "wireKey": "where[slug_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pt"
                ]
            },
            "nameUa": {
                "key": "nameUa",
                "wireKey": "where[name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ua"
                ]
            },
            "slugUa": {
                "key": "slugUa",
                "wireKey": "where[slug_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ua"
                ]
            },
            "nameTr": {
                "key": "nameTr",
                "wireKey": "where[name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_tr"
                ]
            },
            "slugTr": {
                "key": "slugTr",
                "wireKey": "where[slug_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_tr"
                ]
            },
            "nameEe": {
                "key": "nameEe",
                "wireKey": "where[name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ee"
                ]
            },
            "slugEe": {
                "key": "slugEe",
                "wireKey": "where[slug_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ee"
                ]
            },
            "nameLv": {
                "key": "nameLv",
                "wireKey": "where[name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lv"
                ]
            },
            "slugLv": {
                "key": "slugLv",
                "wireKey": "where[slug_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lv"
                ]
            },
            "nameUs": {
                "key": "nameUs",
                "wireKey": "where[name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_us"
                ]
            },
            "slugUs": {
                "key": "slugUs",
                "wireKey": "where[slug_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_us"
                ]
            },
            "nameAu": {
                "key": "nameAu",
                "wireKey": "where[name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_au"
                ]
            },
            "slugAu": {
                "key": "slugAu",
                "wireKey": "where[slug_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_au"
                ]
            },
            "nameCa": {
                "key": "nameCa",
                "wireKey": "where[name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ca"
                ]
            },
            "slugCa": {
                "key": "slugCa",
                "wireKey": "where[slug_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ca"
                ]
            },
            "nameCh": {
                "key": "nameCh",
                "wireKey": "where[name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ch"
                ]
            },
            "slugCh": {
                "key": "slugCh",
                "wireKey": "where[slug_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ch"
                ]
            },
            "nameIn": {
                "key": "nameIn",
                "wireKey": "where[name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_in"
                ]
            },
            "slugIn": {
                "key": "slugIn",
                "wireKey": "where[slug_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_in"
                ]
            },
            "nameJp": {
                "key": "nameJp",
                "wireKey": "where[name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_jp"
                ]
            },
            "slugJp": {
                "key": "slugJp",
                "wireKey": "where[slug_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_jp"
                ]
            },
            "nameMx": {
                "key": "nameMx",
                "wireKey": "where[name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_mx"
                ]
            },
            "slugMx": {
                "key": "slugMx",
                "wireKey": "where[slug_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_mx"
                ]
            },
            "nameRs": {
                "key": "nameRs",
                "wireKey": "where[name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_rs"
                ]
            },
            "slugRs": {
                "key": "slugRs",
                "wireKey": "where[slug_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_rs"
                ]
            },
            "nameBa": {
                "key": "nameBa",
                "wireKey": "where[name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ba"
                ]
            },
            "slugBa": {
                "key": "slugBa",
                "wireKey": "where[slug_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ba"
                ]
            },
            "nameLt": {
                "key": "nameLt",
                "wireKey": "where[name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lt"
                ]
            },
            "slugLt": {
                "key": "slugLt",
                "wireKey": "where[slug_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lt"
                ]
            },
            "views": {
                "key": "views",
                "wireKey": "where[views][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "views"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "updatedAt": {
                "key": "updatedAt",
                "wireKey": "where[updated_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "updated_at"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "categories": {
                "key": "categories",
                "wireKey": "where[categories][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories"
                ]
            },
            "storesId": {
                "key": "storesId",
                "wireKey": "where[stores.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.id"
                ]
            },
            "storesName": {
                "key": "storesName",
                "wireKey": "where[stores.name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.name"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "slug",
                "legacyKeys": [
                    "slug"
                ]
            },
            "views": {
                "key": "views",
                "wireKey": "views",
                "legacyKeys": [
                    "views"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "relevance": {
                "key": "relevance",
                "wireKey": "_score",
                "legacyKeys": [
                    "_score"
                ]
            },
            "stores": {
                "key": "stores",
                "wireKey": "stores",
                "legacyKeys": [
                    "stores"
                ]
            }
        }
    },
"storeCustomers": {
        "key": "storeCustomers",
        "method": "get",
        "endpoint": "/store/customers",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "fullName": {
                "key": "fullName",
                "wireKey": "where[full_name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "full_name"
                ]
            },
            "company": {
                "key": "company",
                "wireKey": "where[company][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "company"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "surname": {
                "key": "surname",
                "wireKey": "where[surname][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "surname"
                ]
            },
            "phone": {
                "key": "phone",
                "wireKey": "where[phone][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "phone"
                ]
            },
            "email": {
                "key": "email",
                "wireKey": "where[email][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "email"
                ]
            },
            "username": {
                "key": "username",
                "wireKey": "where[username][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "username"
                ]
            },
            "address": {
                "key": "address",
                "wireKey": "where[address][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "address"
                ]
            },
            "customerType": {
                "key": "customerType",
                "wireKey": "where[customer_type][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "customer_type"
                ]
            },
            "tags": {
                "key": "tags",
                "wireKey": "where[tags][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tags"
                ]
            },
            "tagSettingsId": {
                "key": "tagSettingsId",
                "wireKey": "where[tag_settings.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tag_settings.id"
                ]
            },
            "tagSettingsUpdatedAt": {
                "key": "tagSettingsUpdatedAt",
                "wireKey": "where[tag_settings.updated_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tag_settings.updated_at"
                ]
            },
            "jobPortalData": {
                "key": "jobPortalData",
                "wireKey": "where[job_portal_data][equals]",
                "operators": [
                    "exists"
                ],
                "legacyKeys": [
                    "job_portal_data"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "acceptedMarketing": {
                "key": "acceptedMarketing",
                "wireKey": "where[accepted_marketing][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "accepted_marketing"
                ]
            },
            "isRegistered": {
                "key": "isRegistered",
                "wireKey": "where[is_registered][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_registered"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "storesId": {
                "key": "storesId",
                "wireKey": "where[stores.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.id"
                ]
            },
            "storesName": {
                "key": "storesName",
                "wireKey": "where[stores.name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.name"
                ]
            }
        },
        "sorts": {
            "fullName": {
                "key": "fullName",
                "wireKey": "full_name",
                "legacyKeys": [
                    "full_name"
                ]
            },
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "company": {
                "key": "company",
                "wireKey": "company",
                "legacyKeys": [
                    "company"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "surname": {
                "key": "surname",
                "wireKey": "surname",
                "legacyKeys": [
                    "surname"
                ]
            },
            "phone": {
                "key": "phone",
                "wireKey": "phone",
                "legacyKeys": [
                    "phone"
                ]
            },
            "email": {
                "key": "email",
                "wireKey": "email",
                "legacyKeys": [
                    "email"
                ]
            },
            "username": {
                "key": "username",
                "wireKey": "username",
                "legacyKeys": [
                    "username"
                ]
            },
            "address": {
                "key": "address",
                "wireKey": "address",
                "legacyKeys": [
                    "address"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "relevance": {
                "key": "relevance",
                "wireKey": "_score",
                "legacyKeys": [
                    "_score"
                ]
            },
            "stores": {
                "key": "stores",
                "wireKey": "stores",
                "legacyKeys": [
                    "stores"
                ]
            }
        }
    },
"storeAdvisoriesCategories": {
        "key": "storeAdvisoriesCategories",
        "method": "get",
        "endpoint": "/store/advisories/categories",
        "queryFormat": "payload",
        "booleanWhere": false,
        "multiSort": false,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "parent": {
                "key": "parent",
                "wireKey": "where[parent][equals]",
                "operators": [
                    "equals",
                    "in",
                    "exists"
                ],
                "legacyKeys": [
                    "parent"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeAdvisories": {
        "key": "storeAdvisories",
        "method": "get",
        "endpoint": "/store/advisories",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "categories": {
                "key": "categories",
                "wireKey": "where[categories][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "categories"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeReferences": {
        "key": "storeReferences",
        "method": "get",
        "endpoint": "/store/references",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "year": {
                "key": "year",
                "wireKey": "where[year][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "year"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "categories": {
                "key": "categories",
                "wireKey": "where[categories][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "categories"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "year": {
                "key": "year",
                "wireKey": "year",
                "legacyKeys": [
                    "year"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeServices": {
        "key": "storeServices",
        "method": "get",
        "endpoint": "/store/services",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "showOnFrontPage": {
                "key": "showOnFrontPage",
                "wireKey": "where[show_on_front_page][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "show_on_front_page"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "showOnFrontPage": {
                "key": "showOnFrontPage",
                "wireKey": "show_on_front_page",
                "legacyKeys": [
                    "show_on_front_page"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeCareers": {
        "key": "storeCareers",
        "method": "get",
        "endpoint": "/store/careers",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeGalleries": {
        "key": "storeGalleries",
        "method": "get",
        "endpoint": "/store/galleries",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeSubscriptionsCategories": {
        "key": "storeSubscriptionsCategories",
        "method": "get",
        "endpoint": "/store/subscriptions/categories",
        "queryFormat": "payload",
        "booleanWhere": false,
        "multiSort": false,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "parent": {
                "key": "parent",
                "wireKey": "where[parent][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "parent"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeSubscriptions": {
        "key": "storeSubscriptions",
        "method": "get",
        "endpoint": "/store/subscriptions",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "subtitle": {
                "key": "subtitle",
                "wireKey": "where[subtitle][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "subtitle"
                ]
            },
            "fleetVehicleLimitTo": {
                "key": "fleetVehicleLimitTo",
                "wireKey": "where[fleet_vehicle_limit_to][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "fleet_vehicle_limit_to"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "categories": {
                "key": "categories",
                "wireKey": "where[categories][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "categories"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "subtitle": {
                "key": "subtitle",
                "wireKey": "subtitle",
                "legacyKeys": [
                    "subtitle"
                ]
            },
            "fleetVehicleLimitTo": {
                "key": "fleetVehicleLimitTo",
                "wireKey": "fleet_vehicle_limit_to",
                "legacyKeys": [
                    "fleet_vehicle_limit_to"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeDynamicSectionsDynamics": {
        "key": "storeDynamicSectionsDynamics",
        "method": "get",
        "endpoint": "/store/dynamic-sections/dynamics",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "fieldValues": {
                "key": "fieldValues",
                "wireKey": "where[field_values][equals]",
                "operators": [
                    "equals"
                ],
                "valueType": "fieldValues"
            },
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "dynamicSectionId": {
                "key": "dynamicSectionId",
                "wireKey": "where[dynamic_section_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "dynamic_section_id"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "updatedAt": {
                "key": "updatedAt",
                "wireKey": "updated_at"
            },
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "dynamicSectionId": {
                "key": "dynamicSectionId",
                "wireKey": "dynamic_section_id",
                "legacyKeys": [
                    "dynamic_section_id"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeDynamicSections": {
        "key": "storeDynamicSections",
        "method": "get",
        "endpoint": "/store/dynamic-sections",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "where[slug][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug"
                ]
            },
            "nameSk": {
                "key": "nameSk",
                "wireKey": "where[name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_sk"
                ]
            },
            "slugSk": {
                "key": "slugSk",
                "wireKey": "where[slug_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_sk"
                ]
            },
            "nameCs": {
                "key": "nameCs",
                "wireKey": "where[name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_cs"
                ]
            },
            "slugCs": {
                "key": "slugCs",
                "wireKey": "where[slug_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_cs"
                ]
            },
            "nameEn": {
                "key": "nameEn",
                "wireKey": "where[name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_en"
                ]
            },
            "slugEn": {
                "key": "slugEn",
                "wireKey": "where[slug_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_en"
                ]
            },
            "namePl": {
                "key": "namePl",
                "wireKey": "where[name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pl"
                ]
            },
            "slugPl": {
                "key": "slugPl",
                "wireKey": "where[slug_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pl"
                ]
            },
            "nameHu": {
                "key": "nameHu",
                "wireKey": "where[name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hu"
                ]
            },
            "slugHu": {
                "key": "slugHu",
                "wireKey": "where[slug_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hu"
                ]
            },
            "nameEs": {
                "key": "nameEs",
                "wireKey": "where[name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_es"
                ]
            },
            "slugEs": {
                "key": "slugEs",
                "wireKey": "where[slug_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_es"
                ]
            },
            "nameFr": {
                "key": "nameFr",
                "wireKey": "where[name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fr"
                ]
            },
            "slugFr": {
                "key": "slugFr",
                "wireKey": "where[slug_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fr"
                ]
            },
            "nameHr": {
                "key": "nameHr",
                "wireKey": "where[name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hr"
                ]
            },
            "slugHr": {
                "key": "slugHr",
                "wireKey": "where[slug_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hr"
                ]
            },
            "nameIt": {
                "key": "nameIt",
                "wireKey": "where[name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_it"
                ]
            },
            "slugIt": {
                "key": "slugIt",
                "wireKey": "where[slug_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_it"
                ]
            },
            "nameDe": {
                "key": "nameDe",
                "wireKey": "where[name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_de"
                ]
            },
            "slugDe": {
                "key": "slugDe",
                "wireKey": "where[slug_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_de"
                ]
            },
            "nameBe": {
                "key": "nameBe",
                "wireKey": "where[name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_be"
                ]
            },
            "slugBe": {
                "key": "slugBe",
                "wireKey": "where[slug_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_be"
                ]
            },
            "nameBg": {
                "key": "nameBg",
                "wireKey": "where[name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_bg"
                ]
            },
            "slugBg": {
                "key": "slugBg",
                "wireKey": "where[slug_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_bg"
                ]
            },
            "nameGr": {
                "key": "nameGr",
                "wireKey": "where[name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_gr"
                ]
            },
            "slugGr": {
                "key": "slugGr",
                "wireKey": "where[slug_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_gr"
                ]
            },
            "nameSe": {
                "key": "nameSe",
                "wireKey": "where[name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_se"
                ]
            },
            "slugSe": {
                "key": "slugSe",
                "wireKey": "where[slug_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_se"
                ]
            },
            "nameFi": {
                "key": "nameFi",
                "wireKey": "where[name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fi"
                ]
            },
            "slugFi": {
                "key": "slugFi",
                "wireKey": "where[slug_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fi"
                ]
            },
            "nameDk": {
                "key": "nameDk",
                "wireKey": "where[name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_dk"
                ]
            },
            "slugDk": {
                "key": "slugDk",
                "wireKey": "where[slug_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_dk"
                ]
            },
            "nameNr": {
                "key": "nameNr",
                "wireKey": "where[name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nr"
                ]
            },
            "slugNr": {
                "key": "slugNr",
                "wireKey": "where[slug_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nr"
                ]
            },
            "nameRu": {
                "key": "nameRu",
                "wireKey": "where[name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ru"
                ]
            },
            "slugRu": {
                "key": "slugRu",
                "wireKey": "where[slug_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ru"
                ]
            },
            "nameRo": {
                "key": "nameRo",
                "wireKey": "where[name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ro"
                ]
            },
            "slugRo": {
                "key": "slugRo",
                "wireKey": "where[slug_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ro"
                ]
            },
            "nameNl": {
                "key": "nameNl",
                "wireKey": "where[name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nl"
                ]
            },
            "slugNl": {
                "key": "slugNl",
                "wireKey": "where[slug_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nl"
                ]
            },
            "nameSi": {
                "key": "nameSi",
                "wireKey": "where[name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_si"
                ]
            },
            "slugSi": {
                "key": "slugSi",
                "wireKey": "where[slug_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_si"
                ]
            },
            "nameAt": {
                "key": "nameAt",
                "wireKey": "where[name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_at"
                ]
            },
            "slugAt": {
                "key": "slugAt",
                "wireKey": "where[slug_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_at"
                ]
            },
            "nameBr": {
                "key": "nameBr",
                "wireKey": "where[name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_br"
                ]
            },
            "slugBr": {
                "key": "slugBr",
                "wireKey": "where[slug_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_br"
                ]
            },
            "namePt": {
                "key": "namePt",
                "wireKey": "where[name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pt"
                ]
            },
            "slugPt": {
                "key": "slugPt",
                "wireKey": "where[slug_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pt"
                ]
            },
            "nameUa": {
                "key": "nameUa",
                "wireKey": "where[name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ua"
                ]
            },
            "slugUa": {
                "key": "slugUa",
                "wireKey": "where[slug_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ua"
                ]
            },
            "nameTr": {
                "key": "nameTr",
                "wireKey": "where[name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_tr"
                ]
            },
            "slugTr": {
                "key": "slugTr",
                "wireKey": "where[slug_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_tr"
                ]
            },
            "nameEe": {
                "key": "nameEe",
                "wireKey": "where[name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ee"
                ]
            },
            "slugEe": {
                "key": "slugEe",
                "wireKey": "where[slug_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ee"
                ]
            },
            "nameLv": {
                "key": "nameLv",
                "wireKey": "where[name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lv"
                ]
            },
            "slugLv": {
                "key": "slugLv",
                "wireKey": "where[slug_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lv"
                ]
            },
            "nameUs": {
                "key": "nameUs",
                "wireKey": "where[name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_us"
                ]
            },
            "slugUs": {
                "key": "slugUs",
                "wireKey": "where[slug_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_us"
                ]
            },
            "nameAu": {
                "key": "nameAu",
                "wireKey": "where[name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_au"
                ]
            },
            "slugAu": {
                "key": "slugAu",
                "wireKey": "where[slug_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_au"
                ]
            },
            "nameCa": {
                "key": "nameCa",
                "wireKey": "where[name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ca"
                ]
            },
            "slugCa": {
                "key": "slugCa",
                "wireKey": "where[slug_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ca"
                ]
            },
            "nameCh": {
                "key": "nameCh",
                "wireKey": "where[name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ch"
                ]
            },
            "slugCh": {
                "key": "slugCh",
                "wireKey": "where[slug_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ch"
                ]
            },
            "nameIn": {
                "key": "nameIn",
                "wireKey": "where[name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_in"
                ]
            },
            "slugIn": {
                "key": "slugIn",
                "wireKey": "where[slug_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_in"
                ]
            },
            "nameJp": {
                "key": "nameJp",
                "wireKey": "where[name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_jp"
                ]
            },
            "slugJp": {
                "key": "slugJp",
                "wireKey": "where[slug_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_jp"
                ]
            },
            "nameMx": {
                "key": "nameMx",
                "wireKey": "where[name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_mx"
                ]
            },
            "slugMx": {
                "key": "slugMx",
                "wireKey": "where[slug_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_mx"
                ]
            },
            "nameRs": {
                "key": "nameRs",
                "wireKey": "where[name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_rs"
                ]
            },
            "slugRs": {
                "key": "slugRs",
                "wireKey": "where[slug_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_rs"
                ]
            },
            "nameBa": {
                "key": "nameBa",
                "wireKey": "where[name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ba"
                ]
            },
            "slugBa": {
                "key": "slugBa",
                "wireKey": "where[slug_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ba"
                ]
            },
            "nameLt": {
                "key": "nameLt",
                "wireKey": "where[name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lt"
                ]
            },
            "slugLt": {
                "key": "slugLt",
                "wireKey": "where[slug_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lt"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "storesId": {
                "key": "storesId",
                "wireKey": "where[stores.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.id"
                ]
            },
            "storesName": {
                "key": "storesName",
                "wireKey": "where[stores.name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.name"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "slug",
                "legacyKeys": [
                    "slug"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "relevance": {
                "key": "relevance",
                "wireKey": "_score",
                "legacyKeys": [
                    "_score"
                ]
            },
            "stores": {
                "key": "stores",
                "wireKey": "stores",
                "legacyKeys": [
                    "stores"
                ]
            }
        }
    },
"storeShipments": {
        "key": "storeShipments",
        "method": "get",
        "endpoint": "/store/shipments",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "type": {
                "key": "type",
                "wireKey": "where[type][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "type": {
                "key": "type",
                "wireKey": "type",
                "legacyKeys": [
                    "type"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storePaymentTypes": {
        "key": "storePaymentTypes",
        "method": "get",
        "endpoint": "/store/payment-types",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storeFaqs": {
        "key": "storeFaqs",
        "method": "get",
        "endpoint": "/store/faqs",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "flag": {
                "key": "flag",
                "wireKey": "where[flag][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "flag"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "flag": {
                "key": "flag",
                "wireKey": "flag",
                "legacyKeys": [
                    "flag"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontRealtyTypes": {
        "key": "storefrontRealtyTypes",
        "method": "get",
        "endpoint": "/realty/types",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontRealtyOfferTypes": {
        "key": "storefrontRealtyOfferTypes",
        "method": "get",
        "endpoint": "/realty/offer-types",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontRealtyTags": {
        "key": "storefrontRealtyTags",
        "method": "get",
        "endpoint": "/realty/tags",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontRealtyAttributes": {
        "key": "storefrontRealtyAttributes",
        "method": "get",
        "endpoint": "/realty/attributes",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontRealtyCities": {
        "key": "storefrontRealtyCities",
        "method": "get",
        "endpoint": "/realty/cities",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "countryId": {
                "key": "countryId",
                "wireKey": "where[country_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "country_id"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "countryId": {
                "key": "countryId",
                "wireKey": "country_id",
                "legacyKeys": [
                    "country_id"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontRealtyVillages": {
        "key": "storefrontRealtyVillages",
        "method": "get",
        "endpoint": "/realty/villages",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "cityId": {
                "key": "cityId",
                "wireKey": "where[city_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_id"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "cityId": {
                "key": "cityId",
                "wireKey": "city_id",
                "legacyKeys": [
                    "city_id"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontRealtyRealties": {
        "key": "storefrontRealtyRealties",
        "method": "get",
        "endpoint": "/realty/realties",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "underConstruction": {
                "key": "underConstruction",
                "wireKey": "where[under_construction][equals]",
                "operators": [
                    "equals"
                ],
                "legacyKeys": [
                    "under_construction"
                ]
            },
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "where[slug][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug"
                ]
            },
            "nameSk": {
                "key": "nameSk",
                "wireKey": "where[name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_sk"
                ]
            },
            "slugSk": {
                "key": "slugSk",
                "wireKey": "where[slug_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_sk"
                ]
            },
            "nameCs": {
                "key": "nameCs",
                "wireKey": "where[name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_cs"
                ]
            },
            "slugCs": {
                "key": "slugCs",
                "wireKey": "where[slug_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_cs"
                ]
            },
            "nameEn": {
                "key": "nameEn",
                "wireKey": "where[name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_en"
                ]
            },
            "slugEn": {
                "key": "slugEn",
                "wireKey": "where[slug_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_en"
                ]
            },
            "namePl": {
                "key": "namePl",
                "wireKey": "where[name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pl"
                ]
            },
            "slugPl": {
                "key": "slugPl",
                "wireKey": "where[slug_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pl"
                ]
            },
            "nameHu": {
                "key": "nameHu",
                "wireKey": "where[name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hu"
                ]
            },
            "slugHu": {
                "key": "slugHu",
                "wireKey": "where[slug_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hu"
                ]
            },
            "nameEs": {
                "key": "nameEs",
                "wireKey": "where[name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_es"
                ]
            },
            "slugEs": {
                "key": "slugEs",
                "wireKey": "where[slug_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_es"
                ]
            },
            "nameFr": {
                "key": "nameFr",
                "wireKey": "where[name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fr"
                ]
            },
            "slugFr": {
                "key": "slugFr",
                "wireKey": "where[slug_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fr"
                ]
            },
            "nameHr": {
                "key": "nameHr",
                "wireKey": "where[name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hr"
                ]
            },
            "slugHr": {
                "key": "slugHr",
                "wireKey": "where[slug_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hr"
                ]
            },
            "nameIt": {
                "key": "nameIt",
                "wireKey": "where[name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_it"
                ]
            },
            "slugIt": {
                "key": "slugIt",
                "wireKey": "where[slug_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_it"
                ]
            },
            "nameDe": {
                "key": "nameDe",
                "wireKey": "where[name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_de"
                ]
            },
            "slugDe": {
                "key": "slugDe",
                "wireKey": "where[slug_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_de"
                ]
            },
            "nameBe": {
                "key": "nameBe",
                "wireKey": "where[name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_be"
                ]
            },
            "slugBe": {
                "key": "slugBe",
                "wireKey": "where[slug_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_be"
                ]
            },
            "nameBg": {
                "key": "nameBg",
                "wireKey": "where[name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_bg"
                ]
            },
            "slugBg": {
                "key": "slugBg",
                "wireKey": "where[slug_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_bg"
                ]
            },
            "nameGr": {
                "key": "nameGr",
                "wireKey": "where[name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_gr"
                ]
            },
            "slugGr": {
                "key": "slugGr",
                "wireKey": "where[slug_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_gr"
                ]
            },
            "nameSe": {
                "key": "nameSe",
                "wireKey": "where[name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_se"
                ]
            },
            "slugSe": {
                "key": "slugSe",
                "wireKey": "where[slug_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_se"
                ]
            },
            "nameFi": {
                "key": "nameFi",
                "wireKey": "where[name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fi"
                ]
            },
            "slugFi": {
                "key": "slugFi",
                "wireKey": "where[slug_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fi"
                ]
            },
            "nameDk": {
                "key": "nameDk",
                "wireKey": "where[name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_dk"
                ]
            },
            "slugDk": {
                "key": "slugDk",
                "wireKey": "where[slug_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_dk"
                ]
            },
            "nameNr": {
                "key": "nameNr",
                "wireKey": "where[name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nr"
                ]
            },
            "slugNr": {
                "key": "slugNr",
                "wireKey": "where[slug_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nr"
                ]
            },
            "nameRu": {
                "key": "nameRu",
                "wireKey": "where[name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ru"
                ]
            },
            "slugRu": {
                "key": "slugRu",
                "wireKey": "where[slug_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ru"
                ]
            },
            "nameRo": {
                "key": "nameRo",
                "wireKey": "where[name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ro"
                ]
            },
            "slugRo": {
                "key": "slugRo",
                "wireKey": "where[slug_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ro"
                ]
            },
            "nameNl": {
                "key": "nameNl",
                "wireKey": "where[name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nl"
                ]
            },
            "slugNl": {
                "key": "slugNl",
                "wireKey": "where[slug_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nl"
                ]
            },
            "nameSi": {
                "key": "nameSi",
                "wireKey": "where[name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_si"
                ]
            },
            "slugSi": {
                "key": "slugSi",
                "wireKey": "where[slug_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_si"
                ]
            },
            "nameAt": {
                "key": "nameAt",
                "wireKey": "where[name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_at"
                ]
            },
            "slugAt": {
                "key": "slugAt",
                "wireKey": "where[slug_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_at"
                ]
            },
            "nameBr": {
                "key": "nameBr",
                "wireKey": "where[name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_br"
                ]
            },
            "slugBr": {
                "key": "slugBr",
                "wireKey": "where[slug_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_br"
                ]
            },
            "namePt": {
                "key": "namePt",
                "wireKey": "where[name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pt"
                ]
            },
            "slugPt": {
                "key": "slugPt",
                "wireKey": "where[slug_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pt"
                ]
            },
            "nameUa": {
                "key": "nameUa",
                "wireKey": "where[name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ua"
                ]
            },
            "slugUa": {
                "key": "slugUa",
                "wireKey": "where[slug_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ua"
                ]
            },
            "nameTr": {
                "key": "nameTr",
                "wireKey": "where[name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_tr"
                ]
            },
            "slugTr": {
                "key": "slugTr",
                "wireKey": "where[slug_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_tr"
                ]
            },
            "nameEe": {
                "key": "nameEe",
                "wireKey": "where[name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ee"
                ]
            },
            "slugEe": {
                "key": "slugEe",
                "wireKey": "where[slug_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ee"
                ]
            },
            "nameLv": {
                "key": "nameLv",
                "wireKey": "where[name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lv"
                ]
            },
            "slugLv": {
                "key": "slugLv",
                "wireKey": "where[slug_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lv"
                ]
            },
            "nameUs": {
                "key": "nameUs",
                "wireKey": "where[name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_us"
                ]
            },
            "slugUs": {
                "key": "slugUs",
                "wireKey": "where[slug_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_us"
                ]
            },
            "nameAu": {
                "key": "nameAu",
                "wireKey": "where[name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_au"
                ]
            },
            "slugAu": {
                "key": "slugAu",
                "wireKey": "where[slug_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_au"
                ]
            },
            "nameCa": {
                "key": "nameCa",
                "wireKey": "where[name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ca"
                ]
            },
            "slugCa": {
                "key": "slugCa",
                "wireKey": "where[slug_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ca"
                ]
            },
            "nameCh": {
                "key": "nameCh",
                "wireKey": "where[name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ch"
                ]
            },
            "slugCh": {
                "key": "slugCh",
                "wireKey": "where[slug_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ch"
                ]
            },
            "nameIn": {
                "key": "nameIn",
                "wireKey": "where[name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_in"
                ]
            },
            "slugIn": {
                "key": "slugIn",
                "wireKey": "where[slug_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_in"
                ]
            },
            "nameJp": {
                "key": "nameJp",
                "wireKey": "where[name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_jp"
                ]
            },
            "slugJp": {
                "key": "slugJp",
                "wireKey": "where[slug_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_jp"
                ]
            },
            "nameMx": {
                "key": "nameMx",
                "wireKey": "where[name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_mx"
                ]
            },
            "slugMx": {
                "key": "slugMx",
                "wireKey": "where[slug_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_mx"
                ]
            },
            "nameRs": {
                "key": "nameRs",
                "wireKey": "where[name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_rs"
                ]
            },
            "slugRs": {
                "key": "slugRs",
                "wireKey": "where[slug_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_rs"
                ]
            },
            "nameBa": {
                "key": "nameBa",
                "wireKey": "where[name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ba"
                ]
            },
            "slugBa": {
                "key": "slugBa",
                "wireKey": "where[slug_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ba"
                ]
            },
            "nameLt": {
                "key": "nameLt",
                "wireKey": "where[name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lt"
                ]
            },
            "slugLt": {
                "key": "slugLt",
                "wireKey": "where[slug_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lt"
                ]
            },
            "realtyArea": {
                "key": "realtyArea",
                "wireKey": "where[realty_area][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "realty_area"
                ]
            },
            "codeNgram": {
                "key": "codeNgram",
                "wireKey": "where[code_ngram][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "code_ngram"
                ]
            },
            "code": {
                "key": "code",
                "wireKey": "where[code][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "code"
                ]
            },
            "customerId": {
                "key": "customerId",
                "wireKey": "where[customer_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "customer_id"
                ]
            },
            "countryId": {
                "key": "countryId",
                "wireKey": "where[country_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "country_id"
                ]
            },
            "cityId": {
                "key": "cityId",
                "wireKey": "where[city_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "city_id"
                ]
            },
            "villageId": {
                "key": "villageId",
                "wireKey": "where[village_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "village_id"
                ]
            },
            "typeId": {
                "key": "typeId",
                "wireKey": "where[type.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.id"
                ]
            },
            "typeNameSk": {
                "key": "typeNameSk",
                "wireKey": "where[type.name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_sk"
                ]
            },
            "typeNameCs": {
                "key": "typeNameCs",
                "wireKey": "where[type.name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_cs"
                ]
            },
            "typeNameEn": {
                "key": "typeNameEn",
                "wireKey": "where[type.name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_en"
                ]
            },
            "typeNamePl": {
                "key": "typeNamePl",
                "wireKey": "where[type.name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_pl"
                ]
            },
            "typeNameHu": {
                "key": "typeNameHu",
                "wireKey": "where[type.name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_hu"
                ]
            },
            "typeNameEs": {
                "key": "typeNameEs",
                "wireKey": "where[type.name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_es"
                ]
            },
            "typeNameFr": {
                "key": "typeNameFr",
                "wireKey": "where[type.name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_fr"
                ]
            },
            "typeNameHr": {
                "key": "typeNameHr",
                "wireKey": "where[type.name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_hr"
                ]
            },
            "typeNameIt": {
                "key": "typeNameIt",
                "wireKey": "where[type.name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_it"
                ]
            },
            "typeNameDe": {
                "key": "typeNameDe",
                "wireKey": "where[type.name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_de"
                ]
            },
            "typeNameBe": {
                "key": "typeNameBe",
                "wireKey": "where[type.name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_be"
                ]
            },
            "typeNameBg": {
                "key": "typeNameBg",
                "wireKey": "where[type.name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_bg"
                ]
            },
            "typeNameGr": {
                "key": "typeNameGr",
                "wireKey": "where[type.name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_gr"
                ]
            },
            "typeNameSe": {
                "key": "typeNameSe",
                "wireKey": "where[type.name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_se"
                ]
            },
            "typeNameFi": {
                "key": "typeNameFi",
                "wireKey": "where[type.name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_fi"
                ]
            },
            "typeNameDk": {
                "key": "typeNameDk",
                "wireKey": "where[type.name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_dk"
                ]
            },
            "typeNameNr": {
                "key": "typeNameNr",
                "wireKey": "where[type.name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_nr"
                ]
            },
            "typeNameRu": {
                "key": "typeNameRu",
                "wireKey": "where[type.name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_ru"
                ]
            },
            "typeNameRo": {
                "key": "typeNameRo",
                "wireKey": "where[type.name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_ro"
                ]
            },
            "typeNameNl": {
                "key": "typeNameNl",
                "wireKey": "where[type.name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_nl"
                ]
            },
            "typeNameSi": {
                "key": "typeNameSi",
                "wireKey": "where[type.name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_si"
                ]
            },
            "typeNameAt": {
                "key": "typeNameAt",
                "wireKey": "where[type.name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_at"
                ]
            },
            "typeNameBr": {
                "key": "typeNameBr",
                "wireKey": "where[type.name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_br"
                ]
            },
            "typeNamePt": {
                "key": "typeNamePt",
                "wireKey": "where[type.name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_pt"
                ]
            },
            "typeNameUa": {
                "key": "typeNameUa",
                "wireKey": "where[type.name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_ua"
                ]
            },
            "typeNameTr": {
                "key": "typeNameTr",
                "wireKey": "where[type.name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_tr"
                ]
            },
            "typeNameEe": {
                "key": "typeNameEe",
                "wireKey": "where[type.name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_ee"
                ]
            },
            "typeNameLv": {
                "key": "typeNameLv",
                "wireKey": "where[type.name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_lv"
                ]
            },
            "typeNameUs": {
                "key": "typeNameUs",
                "wireKey": "where[type.name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_us"
                ]
            },
            "typeNameAu": {
                "key": "typeNameAu",
                "wireKey": "where[type.name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_au"
                ]
            },
            "typeNameCa": {
                "key": "typeNameCa",
                "wireKey": "where[type.name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_ca"
                ]
            },
            "typeNameCh": {
                "key": "typeNameCh",
                "wireKey": "where[type.name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_ch"
                ]
            },
            "typeNameIn": {
                "key": "typeNameIn",
                "wireKey": "where[type.name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_in"
                ]
            },
            "typeNameJp": {
                "key": "typeNameJp",
                "wireKey": "where[type.name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_jp"
                ]
            },
            "typeNameMx": {
                "key": "typeNameMx",
                "wireKey": "where[type.name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_mx"
                ]
            },
            "typeNameRs": {
                "key": "typeNameRs",
                "wireKey": "where[type.name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_rs"
                ]
            },
            "typeNameBa": {
                "key": "typeNameBa",
                "wireKey": "where[type.name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_ba"
                ]
            },
            "typeNameLt": {
                "key": "typeNameLt",
                "wireKey": "where[type.name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "type.name_lt"
                ]
            },
            "offerTypeId": {
                "key": "offerTypeId",
                "wireKey": "where[offer_type.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.id"
                ]
            },
            "offerTypeNameSk": {
                "key": "offerTypeNameSk",
                "wireKey": "where[offer_type.name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_sk"
                ]
            },
            "offerTypeNameCs": {
                "key": "offerTypeNameCs",
                "wireKey": "where[offer_type.name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_cs"
                ]
            },
            "offerTypeNameEn": {
                "key": "offerTypeNameEn",
                "wireKey": "where[offer_type.name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_en"
                ]
            },
            "offerTypeNamePl": {
                "key": "offerTypeNamePl",
                "wireKey": "where[offer_type.name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_pl"
                ]
            },
            "offerTypeNameHu": {
                "key": "offerTypeNameHu",
                "wireKey": "where[offer_type.name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_hu"
                ]
            },
            "offerTypeNameEs": {
                "key": "offerTypeNameEs",
                "wireKey": "where[offer_type.name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_es"
                ]
            },
            "offerTypeNameFr": {
                "key": "offerTypeNameFr",
                "wireKey": "where[offer_type.name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_fr"
                ]
            },
            "offerTypeNameHr": {
                "key": "offerTypeNameHr",
                "wireKey": "where[offer_type.name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_hr"
                ]
            },
            "offerTypeNameIt": {
                "key": "offerTypeNameIt",
                "wireKey": "where[offer_type.name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_it"
                ]
            },
            "offerTypeNameDe": {
                "key": "offerTypeNameDe",
                "wireKey": "where[offer_type.name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_de"
                ]
            },
            "offerTypeNameBe": {
                "key": "offerTypeNameBe",
                "wireKey": "where[offer_type.name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_be"
                ]
            },
            "offerTypeNameBg": {
                "key": "offerTypeNameBg",
                "wireKey": "where[offer_type.name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_bg"
                ]
            },
            "offerTypeNameGr": {
                "key": "offerTypeNameGr",
                "wireKey": "where[offer_type.name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_gr"
                ]
            },
            "offerTypeNameSe": {
                "key": "offerTypeNameSe",
                "wireKey": "where[offer_type.name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_se"
                ]
            },
            "offerTypeNameFi": {
                "key": "offerTypeNameFi",
                "wireKey": "where[offer_type.name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_fi"
                ]
            },
            "offerTypeNameDk": {
                "key": "offerTypeNameDk",
                "wireKey": "where[offer_type.name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_dk"
                ]
            },
            "offerTypeNameNr": {
                "key": "offerTypeNameNr",
                "wireKey": "where[offer_type.name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_nr"
                ]
            },
            "offerTypeNameRu": {
                "key": "offerTypeNameRu",
                "wireKey": "where[offer_type.name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_ru"
                ]
            },
            "offerTypeNameRo": {
                "key": "offerTypeNameRo",
                "wireKey": "where[offer_type.name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_ro"
                ]
            },
            "offerTypeNameNl": {
                "key": "offerTypeNameNl",
                "wireKey": "where[offer_type.name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_nl"
                ]
            },
            "offerTypeNameSi": {
                "key": "offerTypeNameSi",
                "wireKey": "where[offer_type.name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_si"
                ]
            },
            "offerTypeNameAt": {
                "key": "offerTypeNameAt",
                "wireKey": "where[offer_type.name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_at"
                ]
            },
            "offerTypeNameBr": {
                "key": "offerTypeNameBr",
                "wireKey": "where[offer_type.name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_br"
                ]
            },
            "offerTypeNamePt": {
                "key": "offerTypeNamePt",
                "wireKey": "where[offer_type.name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_pt"
                ]
            },
            "offerTypeNameUa": {
                "key": "offerTypeNameUa",
                "wireKey": "where[offer_type.name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_ua"
                ]
            },
            "offerTypeNameTr": {
                "key": "offerTypeNameTr",
                "wireKey": "where[offer_type.name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_tr"
                ]
            },
            "offerTypeNameEe": {
                "key": "offerTypeNameEe",
                "wireKey": "where[offer_type.name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_ee"
                ]
            },
            "offerTypeNameLv": {
                "key": "offerTypeNameLv",
                "wireKey": "where[offer_type.name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_lv"
                ]
            },
            "offerTypeNameUs": {
                "key": "offerTypeNameUs",
                "wireKey": "where[offer_type.name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_us"
                ]
            },
            "offerTypeNameAu": {
                "key": "offerTypeNameAu",
                "wireKey": "where[offer_type.name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_au"
                ]
            },
            "offerTypeNameCa": {
                "key": "offerTypeNameCa",
                "wireKey": "where[offer_type.name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_ca"
                ]
            },
            "offerTypeNameCh": {
                "key": "offerTypeNameCh",
                "wireKey": "where[offer_type.name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_ch"
                ]
            },
            "offerTypeNameIn": {
                "key": "offerTypeNameIn",
                "wireKey": "where[offer_type.name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_in"
                ]
            },
            "offerTypeNameJp": {
                "key": "offerTypeNameJp",
                "wireKey": "where[offer_type.name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_jp"
                ]
            },
            "offerTypeNameMx": {
                "key": "offerTypeNameMx",
                "wireKey": "where[offer_type.name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_mx"
                ]
            },
            "offerTypeNameRs": {
                "key": "offerTypeNameRs",
                "wireKey": "where[offer_type.name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_rs"
                ]
            },
            "offerTypeNameBa": {
                "key": "offerTypeNameBa",
                "wireKey": "where[offer_type.name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_ba"
                ]
            },
            "offerTypeNameLt": {
                "key": "offerTypeNameLt",
                "wireKey": "where[offer_type.name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "offer_type.name_lt"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "values": {
                "key": "values",
                "wireKey": "where[values][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "values"
                ]
            },
            "agencies": {
                "key": "agencies",
                "wireKey": "where[agencies][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "agencies"
                ]
            },
            "suppliers": {
                "key": "suppliers",
                "wireKey": "where[suppliers][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "suppliers"
                ]
            },
            "brokers": {
                "key": "brokers",
                "wireKey": "where[brokers][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "brokers"
                ]
            },
            "categories": {
                "key": "categories",
                "wireKey": "where[categories][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories"
                ]
            },
            "tags": {
                "key": "tags",
                "wireKey": "where[tags][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tags"
                ]
            },
            "destinations": {
                "key": "destinations",
                "wireKey": "where[destinations][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "destinations"
                ]
            },
            "positions": {
                "key": "positions",
                "wireKey": "where[positions][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "positions"
                ]
            },
            "roomsCount": {
                "key": "roomsCount",
                "wireKey": "where[rooms_count][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "rooms_count"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "completionDate": {
                "key": "completionDate",
                "wireKey": "where[completion_date][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "completion_date"
                ]
            },
            "pricesStoreId": {
                "key": "pricesStoreId",
                "wireKey": "where[prices.store_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.store_id"
                ]
            },
            "pricesPriceWithVat": {
                "key": "pricesPriceWithVat",
                "wireKey": "where[prices.price_with_vat][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.price_with_vat"
                ]
            },
            "storesId": {
                "key": "storesId",
                "wireKey": "where[stores.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.id"
                ]
            },
            "storesName": {
                "key": "storesName",
                "wireKey": "where[stores.name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.name"
                ]
            },
            "priceFrom": {
                "key": "priceFrom",
                "wireKey": "price_from",
                "operators": [],
                "legacyKeys": [
                    "price_from"
                ]
            },
            "priceTo": {
                "key": "priceTo",
                "wireKey": "price_to",
                "operators": [],
                "legacyKeys": [
                    "price_to"
                ]
            },
            "price": {
                "key": "price",
                "wireKey": "where[price][equals]",
                "operators": [
                    "equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal"
                ],
                "legacyKeys": []
            },
            "landArea": {
                "key": "landArea",
                "wireKey": "where[land_area][equals]",
                "operators": [
                    "equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal"
                ],
                "legacyKeys": []
            }
        },
        "sorts": {
            "type": {
                "key": "type",
                "wireKey": "type",
                "legacyKeys": [
                    "type"
                ]
            },
            "offerType": {
                "key": "offerType",
                "wireKey": "offer_type",
                "legacyKeys": [
                    "offer_type"
                ]
            },
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "slug",
                "legacyKeys": [
                    "slug"
                ]
            },
            "code": {
                "key": "code",
                "wireKey": "code",
                "legacyKeys": [
                    "code"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "price": {
                "key": "price",
                "wireKey": "price",
                "legacyKeys": [
                    "price"
                ]
            },
            "relevance": {
                "key": "relevance",
                "wireKey": "_score",
                "legacyKeys": [
                    "_score"
                ]
            },
            "stores": {
                "key": "stores",
                "wireKey": "stores",
                "legacyKeys": [
                    "stores"
                ]
            }
        }
    },
"storefrontJobPortalCategories": {
        "key": "storefrontJobPortalCategories",
        "method": "get",
        "endpoint": "/job-portal/categories",
        "queryFormat": "payload",
        "booleanWhere": false,
        "multiSort": false,
        "filters": {
            "typeFlags": {
                "key": "typeFlags",
                "wireKey": "where[type_flags][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "type_flags"
                ]
            },
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "parent": {
                "key": "parent",
                "wireKey": "where[parent][equals]",
                "operators": [
                    "equals",
                    "in",
                    "exists"
                ],
                "legacyKeys": [
                    "parent"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontJobPortalSalaryTypes": {
        "key": "storefrontJobPortalSalaryTypes",
        "method": "get",
        "endpoint": "/job-portal/salary-types",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontJobPortalTags": {
        "key": "storefrontJobPortalTags",
        "method": "get",
        "endpoint": "/job-portal/tags",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontJobPortalWorkingHours": {
        "key": "storefrontJobPortalWorkingHours",
        "method": "get",
        "endpoint": "/job-portal/working-hours",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontJobPortalWorkplaces": {
        "key": "storefrontJobPortalWorkplaces",
        "method": "get",
        "endpoint": "/job-portal/workplaces",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontJobPortalAgeRanges": {
        "key": "storefrontJobPortalAgeRanges",
        "method": "get",
        "endpoint": "/job-portal/age-ranges",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontJobPortalSchoolDisciplines": {
        "key": "storefrontJobPortalSchoolDisciplines",
        "method": "get",
        "endpoint": "/job-portal/school-disciplines",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontJobPortalSchoolTypes": {
        "key": "storefrontJobPortalSchoolTypes",
        "method": "get",
        "endpoint": "/job-portal/school-types",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontJobPortalSuitabilities": {
        "key": "storefrontJobPortalSuitabilities",
        "method": "get",
        "endpoint": "/job-portal/suitabilities",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontJobPortalPrerequisites": {
        "key": "storefrontJobPortalPrerequisites",
        "method": "get",
        "endpoint": "/job-portal/prerequisites",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontJobPortalGraduates": {
        "key": "storefrontJobPortalGraduates",
        "method": "get",
        "endpoint": "/job-portal/graduates",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontJobPortalAttributesValues": {
        "key": "storefrontJobPortalAttributesValues",
        "method": "get",
        "endpoint": "/job-portal/attributes/values",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "nameSk": {
                "key": "nameSk",
                "wireKey": "where[name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_sk"
                ]
            },
            "nameCs": {
                "key": "nameCs",
                "wireKey": "where[name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_cs"
                ]
            },
            "nameEn": {
                "key": "nameEn",
                "wireKey": "where[name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_en"
                ]
            },
            "namePl": {
                "key": "namePl",
                "wireKey": "where[name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pl"
                ]
            },
            "nameHu": {
                "key": "nameHu",
                "wireKey": "where[name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hu"
                ]
            },
            "nameEs": {
                "key": "nameEs",
                "wireKey": "where[name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_es"
                ]
            },
            "nameFr": {
                "key": "nameFr",
                "wireKey": "where[name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fr"
                ]
            },
            "nameHr": {
                "key": "nameHr",
                "wireKey": "where[name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hr"
                ]
            },
            "nameIt": {
                "key": "nameIt",
                "wireKey": "where[name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_it"
                ]
            },
            "nameDe": {
                "key": "nameDe",
                "wireKey": "where[name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_de"
                ]
            },
            "nameBe": {
                "key": "nameBe",
                "wireKey": "where[name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_be"
                ]
            },
            "nameBg": {
                "key": "nameBg",
                "wireKey": "where[name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_bg"
                ]
            },
            "nameGr": {
                "key": "nameGr",
                "wireKey": "where[name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_gr"
                ]
            },
            "nameSe": {
                "key": "nameSe",
                "wireKey": "where[name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_se"
                ]
            },
            "nameFi": {
                "key": "nameFi",
                "wireKey": "where[name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fi"
                ]
            },
            "nameDk": {
                "key": "nameDk",
                "wireKey": "where[name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_dk"
                ]
            },
            "nameNr": {
                "key": "nameNr",
                "wireKey": "where[name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nr"
                ]
            },
            "nameRu": {
                "key": "nameRu",
                "wireKey": "where[name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ru"
                ]
            },
            "nameRo": {
                "key": "nameRo",
                "wireKey": "where[name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ro"
                ]
            },
            "nameNl": {
                "key": "nameNl",
                "wireKey": "where[name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nl"
                ]
            },
            "nameSi": {
                "key": "nameSi",
                "wireKey": "where[name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_si"
                ]
            },
            "nameAt": {
                "key": "nameAt",
                "wireKey": "where[name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_at"
                ]
            },
            "nameBr": {
                "key": "nameBr",
                "wireKey": "where[name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_br"
                ]
            },
            "namePt": {
                "key": "namePt",
                "wireKey": "where[name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pt"
                ]
            },
            "nameUa": {
                "key": "nameUa",
                "wireKey": "where[name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ua"
                ]
            },
            "nameTr": {
                "key": "nameTr",
                "wireKey": "where[name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_tr"
                ]
            },
            "nameEe": {
                "key": "nameEe",
                "wireKey": "where[name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ee"
                ]
            },
            "nameLv": {
                "key": "nameLv",
                "wireKey": "where[name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lv"
                ]
            },
            "nameUs": {
                "key": "nameUs",
                "wireKey": "where[name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_us"
                ]
            },
            "nameAu": {
                "key": "nameAu",
                "wireKey": "where[name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_au"
                ]
            },
            "nameCa": {
                "key": "nameCa",
                "wireKey": "where[name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ca"
                ]
            },
            "nameCh": {
                "key": "nameCh",
                "wireKey": "where[name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ch"
                ]
            },
            "nameIn": {
                "key": "nameIn",
                "wireKey": "where[name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_in"
                ]
            },
            "nameJp": {
                "key": "nameJp",
                "wireKey": "where[name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_jp"
                ]
            },
            "nameMx": {
                "key": "nameMx",
                "wireKey": "where[name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_mx"
                ]
            },
            "nameRs": {
                "key": "nameRs",
                "wireKey": "where[name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_rs"
                ]
            },
            "nameBa": {
                "key": "nameBa",
                "wireKey": "where[name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ba"
                ]
            },
            "nameLt": {
                "key": "nameLt",
                "wireKey": "where[name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lt"
                ]
            },
            "attributeId": {
                "key": "attributeId",
                "wireKey": "where[attribute_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "attribute_id"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "relevance": {
                "key": "relevance",
                "wireKey": "_score",
                "legacyKeys": [
                    "_score"
                ]
            }
        }
    },
"storefrontJobPortalEmploymentTypes": {
        "key": "storefrontJobPortalEmploymentTypes",
        "method": "get",
        "endpoint": "/job-portal/employment-types",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontJobPortalCompaniesSizes": {
        "key": "storefrontJobPortalCompaniesSizes",
        "method": "get",
        "endpoint": "/job-portal/companies/sizes",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontJobPortalCompanies": {
        "key": "storefrontJobPortalCompanies",
        "method": "get",
        "endpoint": "/job-portal/companies",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "where[slug][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug"
                ]
            },
            "nameSk": {
                "key": "nameSk",
                "wireKey": "where[name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_sk"
                ]
            },
            "slugSk": {
                "key": "slugSk",
                "wireKey": "where[slug_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_sk"
                ]
            },
            "nameCs": {
                "key": "nameCs",
                "wireKey": "where[name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_cs"
                ]
            },
            "slugCs": {
                "key": "slugCs",
                "wireKey": "where[slug_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_cs"
                ]
            },
            "nameEn": {
                "key": "nameEn",
                "wireKey": "where[name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_en"
                ]
            },
            "slugEn": {
                "key": "slugEn",
                "wireKey": "where[slug_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_en"
                ]
            },
            "namePl": {
                "key": "namePl",
                "wireKey": "where[name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pl"
                ]
            },
            "slugPl": {
                "key": "slugPl",
                "wireKey": "where[slug_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pl"
                ]
            },
            "nameHu": {
                "key": "nameHu",
                "wireKey": "where[name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hu"
                ]
            },
            "slugHu": {
                "key": "slugHu",
                "wireKey": "where[slug_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hu"
                ]
            },
            "nameEs": {
                "key": "nameEs",
                "wireKey": "where[name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_es"
                ]
            },
            "slugEs": {
                "key": "slugEs",
                "wireKey": "where[slug_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_es"
                ]
            },
            "nameFr": {
                "key": "nameFr",
                "wireKey": "where[name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fr"
                ]
            },
            "slugFr": {
                "key": "slugFr",
                "wireKey": "where[slug_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fr"
                ]
            },
            "nameHr": {
                "key": "nameHr",
                "wireKey": "where[name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hr"
                ]
            },
            "slugHr": {
                "key": "slugHr",
                "wireKey": "where[slug_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hr"
                ]
            },
            "nameIt": {
                "key": "nameIt",
                "wireKey": "where[name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_it"
                ]
            },
            "slugIt": {
                "key": "slugIt",
                "wireKey": "where[slug_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_it"
                ]
            },
            "nameDe": {
                "key": "nameDe",
                "wireKey": "where[name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_de"
                ]
            },
            "slugDe": {
                "key": "slugDe",
                "wireKey": "where[slug_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_de"
                ]
            },
            "nameBe": {
                "key": "nameBe",
                "wireKey": "where[name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_be"
                ]
            },
            "slugBe": {
                "key": "slugBe",
                "wireKey": "where[slug_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_be"
                ]
            },
            "nameBg": {
                "key": "nameBg",
                "wireKey": "where[name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_bg"
                ]
            },
            "slugBg": {
                "key": "slugBg",
                "wireKey": "where[slug_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_bg"
                ]
            },
            "nameGr": {
                "key": "nameGr",
                "wireKey": "where[name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_gr"
                ]
            },
            "slugGr": {
                "key": "slugGr",
                "wireKey": "where[slug_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_gr"
                ]
            },
            "nameSe": {
                "key": "nameSe",
                "wireKey": "where[name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_se"
                ]
            },
            "slugSe": {
                "key": "slugSe",
                "wireKey": "where[slug_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_se"
                ]
            },
            "nameFi": {
                "key": "nameFi",
                "wireKey": "where[name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fi"
                ]
            },
            "slugFi": {
                "key": "slugFi",
                "wireKey": "where[slug_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fi"
                ]
            },
            "nameDk": {
                "key": "nameDk",
                "wireKey": "where[name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_dk"
                ]
            },
            "slugDk": {
                "key": "slugDk",
                "wireKey": "where[slug_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_dk"
                ]
            },
            "nameNr": {
                "key": "nameNr",
                "wireKey": "where[name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nr"
                ]
            },
            "slugNr": {
                "key": "slugNr",
                "wireKey": "where[slug_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nr"
                ]
            },
            "nameRu": {
                "key": "nameRu",
                "wireKey": "where[name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ru"
                ]
            },
            "slugRu": {
                "key": "slugRu",
                "wireKey": "where[slug_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ru"
                ]
            },
            "nameRo": {
                "key": "nameRo",
                "wireKey": "where[name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ro"
                ]
            },
            "slugRo": {
                "key": "slugRo",
                "wireKey": "where[slug_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ro"
                ]
            },
            "nameNl": {
                "key": "nameNl",
                "wireKey": "where[name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nl"
                ]
            },
            "slugNl": {
                "key": "slugNl",
                "wireKey": "where[slug_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nl"
                ]
            },
            "nameSi": {
                "key": "nameSi",
                "wireKey": "where[name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_si"
                ]
            },
            "slugSi": {
                "key": "slugSi",
                "wireKey": "where[slug_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_si"
                ]
            },
            "nameAt": {
                "key": "nameAt",
                "wireKey": "where[name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_at"
                ]
            },
            "slugAt": {
                "key": "slugAt",
                "wireKey": "where[slug_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_at"
                ]
            },
            "nameBr": {
                "key": "nameBr",
                "wireKey": "where[name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_br"
                ]
            },
            "slugBr": {
                "key": "slugBr",
                "wireKey": "where[slug_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_br"
                ]
            },
            "namePt": {
                "key": "namePt",
                "wireKey": "where[name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pt"
                ]
            },
            "slugPt": {
                "key": "slugPt",
                "wireKey": "where[slug_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pt"
                ]
            },
            "nameUa": {
                "key": "nameUa",
                "wireKey": "where[name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ua"
                ]
            },
            "slugUa": {
                "key": "slugUa",
                "wireKey": "where[slug_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ua"
                ]
            },
            "nameTr": {
                "key": "nameTr",
                "wireKey": "where[name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_tr"
                ]
            },
            "slugTr": {
                "key": "slugTr",
                "wireKey": "where[slug_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_tr"
                ]
            },
            "nameEe": {
                "key": "nameEe",
                "wireKey": "where[name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ee"
                ]
            },
            "slugEe": {
                "key": "slugEe",
                "wireKey": "where[slug_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ee"
                ]
            },
            "nameLv": {
                "key": "nameLv",
                "wireKey": "where[name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lv"
                ]
            },
            "slugLv": {
                "key": "slugLv",
                "wireKey": "where[slug_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lv"
                ]
            },
            "nameUs": {
                "key": "nameUs",
                "wireKey": "where[name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_us"
                ]
            },
            "slugUs": {
                "key": "slugUs",
                "wireKey": "where[slug_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_us"
                ]
            },
            "nameAu": {
                "key": "nameAu",
                "wireKey": "where[name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_au"
                ]
            },
            "slugAu": {
                "key": "slugAu",
                "wireKey": "where[slug_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_au"
                ]
            },
            "nameCa": {
                "key": "nameCa",
                "wireKey": "where[name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ca"
                ]
            },
            "slugCa": {
                "key": "slugCa",
                "wireKey": "where[slug_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ca"
                ]
            },
            "nameCh": {
                "key": "nameCh",
                "wireKey": "where[name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ch"
                ]
            },
            "slugCh": {
                "key": "slugCh",
                "wireKey": "where[slug_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ch"
                ]
            },
            "nameIn": {
                "key": "nameIn",
                "wireKey": "where[name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_in"
                ]
            },
            "slugIn": {
                "key": "slugIn",
                "wireKey": "where[slug_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_in"
                ]
            },
            "nameJp": {
                "key": "nameJp",
                "wireKey": "where[name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_jp"
                ]
            },
            "slugJp": {
                "key": "slugJp",
                "wireKey": "where[slug_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_jp"
                ]
            },
            "nameMx": {
                "key": "nameMx",
                "wireKey": "where[name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_mx"
                ]
            },
            "slugMx": {
                "key": "slugMx",
                "wireKey": "where[slug_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_mx"
                ]
            },
            "nameRs": {
                "key": "nameRs",
                "wireKey": "where[name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_rs"
                ]
            },
            "slugRs": {
                "key": "slugRs",
                "wireKey": "where[slug_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_rs"
                ]
            },
            "nameBa": {
                "key": "nameBa",
                "wireKey": "where[name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ba"
                ]
            },
            "slugBa": {
                "key": "slugBa",
                "wireKey": "where[slug_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ba"
                ]
            },
            "nameLt": {
                "key": "nameLt",
                "wireKey": "where[name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lt"
                ]
            },
            "slugLt": {
                "key": "slugLt",
                "wireKey": "where[slug_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lt"
                ]
            },
            "addressFull": {
                "key": "addressFull",
                "wireKey": "where[address_full][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "address_full"
                ]
            },
            "operationAddressFull": {
                "key": "operationAddressFull",
                "wireKey": "where[operation_address_full][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "operation_address_full"
                ]
            },
            "companySizeId": {
                "key": "companySizeId",
                "wireKey": "where[company_size_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "company_size_id"
                ]
            },
            "companyGeo": {
                "key": "companyGeo",
                "wireKey": "where[company_geo][exists]",
                "operators": [
                    "exists"
                ],
                "legacyKeys": [
                    "company_geo"
                ]
            },
            "categories": {
                "key": "categories",
                "wireKey": "where[categories][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories"
                ]
            },
            "tags": {
                "key": "tags",
                "wireKey": "where[tags][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tags"
                ]
            },
            "practiceForStudents": {
                "key": "practiceForStudents",
                "wireKey": "where[practice_for_students][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "practice_for_students"
                ]
            },
            "cooperationWithSchools": {
                "key": "cooperationWithSchools",
                "wireKey": "where[cooperation_with_schools][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "cooperation_with_schools"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "slug",
                "legacyKeys": [
                    "slug"
                ]
            },
            "addressFull": {
                "key": "addressFull",
                "wireKey": "address_full",
                "legacyKeys": [
                    "address_full"
                ]
            },
            "operationAddressFull": {
                "key": "operationAddressFull",
                "wireKey": "operation_address_full",
                "legacyKeys": [
                    "operation_address_full"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "relevance": {
                "key": "relevance",
                "wireKey": "_score",
                "legacyKeys": [
                    "_score"
                ]
            }
        }
    },
"storefrontJobPortalSchools": {
        "key": "storefrontJobPortalSchools",
        "method": "get",
        "endpoint": "/job-portal/schools",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "where[slug][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug"
                ]
            },
            "nameSk": {
                "key": "nameSk",
                "wireKey": "where[name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_sk"
                ]
            },
            "slugSk": {
                "key": "slugSk",
                "wireKey": "where[slug_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_sk"
                ]
            },
            "nameCs": {
                "key": "nameCs",
                "wireKey": "where[name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_cs"
                ]
            },
            "slugCs": {
                "key": "slugCs",
                "wireKey": "where[slug_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_cs"
                ]
            },
            "nameEn": {
                "key": "nameEn",
                "wireKey": "where[name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_en"
                ]
            },
            "slugEn": {
                "key": "slugEn",
                "wireKey": "where[slug_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_en"
                ]
            },
            "namePl": {
                "key": "namePl",
                "wireKey": "where[name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pl"
                ]
            },
            "slugPl": {
                "key": "slugPl",
                "wireKey": "where[slug_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pl"
                ]
            },
            "nameHu": {
                "key": "nameHu",
                "wireKey": "where[name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hu"
                ]
            },
            "slugHu": {
                "key": "slugHu",
                "wireKey": "where[slug_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hu"
                ]
            },
            "nameEs": {
                "key": "nameEs",
                "wireKey": "where[name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_es"
                ]
            },
            "slugEs": {
                "key": "slugEs",
                "wireKey": "where[slug_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_es"
                ]
            },
            "nameFr": {
                "key": "nameFr",
                "wireKey": "where[name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fr"
                ]
            },
            "slugFr": {
                "key": "slugFr",
                "wireKey": "where[slug_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fr"
                ]
            },
            "nameHr": {
                "key": "nameHr",
                "wireKey": "where[name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hr"
                ]
            },
            "slugHr": {
                "key": "slugHr",
                "wireKey": "where[slug_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hr"
                ]
            },
            "nameIt": {
                "key": "nameIt",
                "wireKey": "where[name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_it"
                ]
            },
            "slugIt": {
                "key": "slugIt",
                "wireKey": "where[slug_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_it"
                ]
            },
            "nameDe": {
                "key": "nameDe",
                "wireKey": "where[name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_de"
                ]
            },
            "slugDe": {
                "key": "slugDe",
                "wireKey": "where[slug_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_de"
                ]
            },
            "nameBe": {
                "key": "nameBe",
                "wireKey": "where[name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_be"
                ]
            },
            "slugBe": {
                "key": "slugBe",
                "wireKey": "where[slug_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_be"
                ]
            },
            "nameBg": {
                "key": "nameBg",
                "wireKey": "where[name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_bg"
                ]
            },
            "slugBg": {
                "key": "slugBg",
                "wireKey": "where[slug_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_bg"
                ]
            },
            "nameGr": {
                "key": "nameGr",
                "wireKey": "where[name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_gr"
                ]
            },
            "slugGr": {
                "key": "slugGr",
                "wireKey": "where[slug_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_gr"
                ]
            },
            "nameSe": {
                "key": "nameSe",
                "wireKey": "where[name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_se"
                ]
            },
            "slugSe": {
                "key": "slugSe",
                "wireKey": "where[slug_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_se"
                ]
            },
            "nameFi": {
                "key": "nameFi",
                "wireKey": "where[name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fi"
                ]
            },
            "slugFi": {
                "key": "slugFi",
                "wireKey": "where[slug_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fi"
                ]
            },
            "nameDk": {
                "key": "nameDk",
                "wireKey": "where[name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_dk"
                ]
            },
            "slugDk": {
                "key": "slugDk",
                "wireKey": "where[slug_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_dk"
                ]
            },
            "nameNr": {
                "key": "nameNr",
                "wireKey": "where[name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nr"
                ]
            },
            "slugNr": {
                "key": "slugNr",
                "wireKey": "where[slug_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nr"
                ]
            },
            "nameRu": {
                "key": "nameRu",
                "wireKey": "where[name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ru"
                ]
            },
            "slugRu": {
                "key": "slugRu",
                "wireKey": "where[slug_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ru"
                ]
            },
            "nameRo": {
                "key": "nameRo",
                "wireKey": "where[name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ro"
                ]
            },
            "slugRo": {
                "key": "slugRo",
                "wireKey": "where[slug_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ro"
                ]
            },
            "nameNl": {
                "key": "nameNl",
                "wireKey": "where[name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nl"
                ]
            },
            "slugNl": {
                "key": "slugNl",
                "wireKey": "where[slug_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nl"
                ]
            },
            "nameSi": {
                "key": "nameSi",
                "wireKey": "where[name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_si"
                ]
            },
            "slugSi": {
                "key": "slugSi",
                "wireKey": "where[slug_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_si"
                ]
            },
            "nameAt": {
                "key": "nameAt",
                "wireKey": "where[name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_at"
                ]
            },
            "slugAt": {
                "key": "slugAt",
                "wireKey": "where[slug_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_at"
                ]
            },
            "nameBr": {
                "key": "nameBr",
                "wireKey": "where[name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_br"
                ]
            },
            "slugBr": {
                "key": "slugBr",
                "wireKey": "where[slug_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_br"
                ]
            },
            "namePt": {
                "key": "namePt",
                "wireKey": "where[name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pt"
                ]
            },
            "slugPt": {
                "key": "slugPt",
                "wireKey": "where[slug_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pt"
                ]
            },
            "nameUa": {
                "key": "nameUa",
                "wireKey": "where[name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ua"
                ]
            },
            "slugUa": {
                "key": "slugUa",
                "wireKey": "where[slug_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ua"
                ]
            },
            "nameTr": {
                "key": "nameTr",
                "wireKey": "where[name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_tr"
                ]
            },
            "slugTr": {
                "key": "slugTr",
                "wireKey": "where[slug_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_tr"
                ]
            },
            "nameEe": {
                "key": "nameEe",
                "wireKey": "where[name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ee"
                ]
            },
            "slugEe": {
                "key": "slugEe",
                "wireKey": "where[slug_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ee"
                ]
            },
            "nameLv": {
                "key": "nameLv",
                "wireKey": "where[name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lv"
                ]
            },
            "slugLv": {
                "key": "slugLv",
                "wireKey": "where[slug_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lv"
                ]
            },
            "nameUs": {
                "key": "nameUs",
                "wireKey": "where[name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_us"
                ]
            },
            "slugUs": {
                "key": "slugUs",
                "wireKey": "where[slug_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_us"
                ]
            },
            "nameAu": {
                "key": "nameAu",
                "wireKey": "where[name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_au"
                ]
            },
            "slugAu": {
                "key": "slugAu",
                "wireKey": "where[slug_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_au"
                ]
            },
            "nameCa": {
                "key": "nameCa",
                "wireKey": "where[name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ca"
                ]
            },
            "slugCa": {
                "key": "slugCa",
                "wireKey": "where[slug_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ca"
                ]
            },
            "nameCh": {
                "key": "nameCh",
                "wireKey": "where[name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ch"
                ]
            },
            "slugCh": {
                "key": "slugCh",
                "wireKey": "where[slug_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ch"
                ]
            },
            "nameIn": {
                "key": "nameIn",
                "wireKey": "where[name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_in"
                ]
            },
            "slugIn": {
                "key": "slugIn",
                "wireKey": "where[slug_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_in"
                ]
            },
            "nameJp": {
                "key": "nameJp",
                "wireKey": "where[name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_jp"
                ]
            },
            "slugJp": {
                "key": "slugJp",
                "wireKey": "where[slug_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_jp"
                ]
            },
            "nameMx": {
                "key": "nameMx",
                "wireKey": "where[name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_mx"
                ]
            },
            "slugMx": {
                "key": "slugMx",
                "wireKey": "where[slug_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_mx"
                ]
            },
            "nameRs": {
                "key": "nameRs",
                "wireKey": "where[name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_rs"
                ]
            },
            "slugRs": {
                "key": "slugRs",
                "wireKey": "where[slug_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_rs"
                ]
            },
            "nameBa": {
                "key": "nameBa",
                "wireKey": "where[name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ba"
                ]
            },
            "slugBa": {
                "key": "slugBa",
                "wireKey": "where[slug_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ba"
                ]
            },
            "nameLt": {
                "key": "nameLt",
                "wireKey": "where[name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lt"
                ]
            },
            "slugLt": {
                "key": "slugLt",
                "wireKey": "where[slug_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lt"
                ]
            },
            "addressFull": {
                "key": "addressFull",
                "wireKey": "where[address_full][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "address_full"
                ]
            },
            "schoolGeo": {
                "key": "schoolGeo",
                "wireKey": "where[school_geo][exists]",
                "operators": [
                    "exists"
                ],
                "legacyKeys": [
                    "school_geo"
                ]
            },
            "disciplines": {
                "key": "disciplines",
                "wireKey": "where[disciplines][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "disciplines"
                ]
            },
            "schoolTypeId": {
                "key": "schoolTypeId",
                "wireKey": "where[school_type_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "school_type_id"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "slug",
                "legacyKeys": [
                    "slug"
                ]
            },
            "addressFull": {
                "key": "addressFull",
                "wireKey": "address_full",
                "legacyKeys": [
                    "address_full"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "relevance": {
                "key": "relevance",
                "wireKey": "_score",
                "legacyKeys": [
                    "_score"
                ]
            }
        }
    },
"storefrontJobPortalOffers": {
        "key": "storefrontJobPortalOffers",
        "method": "get",
        "endpoint": "/job-portal/offers",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "where[slug][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug"
                ]
            },
            "nameSk": {
                "key": "nameSk",
                "wireKey": "where[name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_sk"
                ]
            },
            "slugSk": {
                "key": "slugSk",
                "wireKey": "where[slug_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_sk"
                ]
            },
            "nameCs": {
                "key": "nameCs",
                "wireKey": "where[name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_cs"
                ]
            },
            "slugCs": {
                "key": "slugCs",
                "wireKey": "where[slug_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_cs"
                ]
            },
            "nameEn": {
                "key": "nameEn",
                "wireKey": "where[name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_en"
                ]
            },
            "slugEn": {
                "key": "slugEn",
                "wireKey": "where[slug_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_en"
                ]
            },
            "namePl": {
                "key": "namePl",
                "wireKey": "where[name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pl"
                ]
            },
            "slugPl": {
                "key": "slugPl",
                "wireKey": "where[slug_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pl"
                ]
            },
            "nameHu": {
                "key": "nameHu",
                "wireKey": "where[name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hu"
                ]
            },
            "slugHu": {
                "key": "slugHu",
                "wireKey": "where[slug_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hu"
                ]
            },
            "nameEs": {
                "key": "nameEs",
                "wireKey": "where[name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_es"
                ]
            },
            "slugEs": {
                "key": "slugEs",
                "wireKey": "where[slug_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_es"
                ]
            },
            "nameFr": {
                "key": "nameFr",
                "wireKey": "where[name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fr"
                ]
            },
            "slugFr": {
                "key": "slugFr",
                "wireKey": "where[slug_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fr"
                ]
            },
            "nameHr": {
                "key": "nameHr",
                "wireKey": "where[name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hr"
                ]
            },
            "slugHr": {
                "key": "slugHr",
                "wireKey": "where[slug_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hr"
                ]
            },
            "nameIt": {
                "key": "nameIt",
                "wireKey": "where[name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_it"
                ]
            },
            "slugIt": {
                "key": "slugIt",
                "wireKey": "where[slug_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_it"
                ]
            },
            "nameDe": {
                "key": "nameDe",
                "wireKey": "where[name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_de"
                ]
            },
            "slugDe": {
                "key": "slugDe",
                "wireKey": "where[slug_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_de"
                ]
            },
            "nameBe": {
                "key": "nameBe",
                "wireKey": "where[name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_be"
                ]
            },
            "slugBe": {
                "key": "slugBe",
                "wireKey": "where[slug_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_be"
                ]
            },
            "nameBg": {
                "key": "nameBg",
                "wireKey": "where[name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_bg"
                ]
            },
            "slugBg": {
                "key": "slugBg",
                "wireKey": "where[slug_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_bg"
                ]
            },
            "nameGr": {
                "key": "nameGr",
                "wireKey": "where[name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_gr"
                ]
            },
            "slugGr": {
                "key": "slugGr",
                "wireKey": "where[slug_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_gr"
                ]
            },
            "nameSe": {
                "key": "nameSe",
                "wireKey": "where[name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_se"
                ]
            },
            "slugSe": {
                "key": "slugSe",
                "wireKey": "where[slug_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_se"
                ]
            },
            "nameFi": {
                "key": "nameFi",
                "wireKey": "where[name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fi"
                ]
            },
            "slugFi": {
                "key": "slugFi",
                "wireKey": "where[slug_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fi"
                ]
            },
            "nameDk": {
                "key": "nameDk",
                "wireKey": "where[name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_dk"
                ]
            },
            "slugDk": {
                "key": "slugDk",
                "wireKey": "where[slug_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_dk"
                ]
            },
            "nameNr": {
                "key": "nameNr",
                "wireKey": "where[name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nr"
                ]
            },
            "slugNr": {
                "key": "slugNr",
                "wireKey": "where[slug_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nr"
                ]
            },
            "nameRu": {
                "key": "nameRu",
                "wireKey": "where[name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ru"
                ]
            },
            "slugRu": {
                "key": "slugRu",
                "wireKey": "where[slug_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ru"
                ]
            },
            "nameRo": {
                "key": "nameRo",
                "wireKey": "where[name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ro"
                ]
            },
            "slugRo": {
                "key": "slugRo",
                "wireKey": "where[slug_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ro"
                ]
            },
            "nameNl": {
                "key": "nameNl",
                "wireKey": "where[name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nl"
                ]
            },
            "slugNl": {
                "key": "slugNl",
                "wireKey": "where[slug_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nl"
                ]
            },
            "nameSi": {
                "key": "nameSi",
                "wireKey": "where[name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_si"
                ]
            },
            "slugSi": {
                "key": "slugSi",
                "wireKey": "where[slug_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_si"
                ]
            },
            "nameAt": {
                "key": "nameAt",
                "wireKey": "where[name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_at"
                ]
            },
            "slugAt": {
                "key": "slugAt",
                "wireKey": "where[slug_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_at"
                ]
            },
            "nameBr": {
                "key": "nameBr",
                "wireKey": "where[name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_br"
                ]
            },
            "slugBr": {
                "key": "slugBr",
                "wireKey": "where[slug_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_br"
                ]
            },
            "namePt": {
                "key": "namePt",
                "wireKey": "where[name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pt"
                ]
            },
            "slugPt": {
                "key": "slugPt",
                "wireKey": "where[slug_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pt"
                ]
            },
            "nameUa": {
                "key": "nameUa",
                "wireKey": "where[name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ua"
                ]
            },
            "slugUa": {
                "key": "slugUa",
                "wireKey": "where[slug_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ua"
                ]
            },
            "nameTr": {
                "key": "nameTr",
                "wireKey": "where[name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_tr"
                ]
            },
            "slugTr": {
                "key": "slugTr",
                "wireKey": "where[slug_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_tr"
                ]
            },
            "nameEe": {
                "key": "nameEe",
                "wireKey": "where[name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ee"
                ]
            },
            "slugEe": {
                "key": "slugEe",
                "wireKey": "where[slug_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ee"
                ]
            },
            "nameLv": {
                "key": "nameLv",
                "wireKey": "where[name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lv"
                ]
            },
            "slugLv": {
                "key": "slugLv",
                "wireKey": "where[slug_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lv"
                ]
            },
            "nameUs": {
                "key": "nameUs",
                "wireKey": "where[name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_us"
                ]
            },
            "slugUs": {
                "key": "slugUs",
                "wireKey": "where[slug_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_us"
                ]
            },
            "nameAu": {
                "key": "nameAu",
                "wireKey": "where[name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_au"
                ]
            },
            "slugAu": {
                "key": "slugAu",
                "wireKey": "where[slug_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_au"
                ]
            },
            "nameCa": {
                "key": "nameCa",
                "wireKey": "where[name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ca"
                ]
            },
            "slugCa": {
                "key": "slugCa",
                "wireKey": "where[slug_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ca"
                ]
            },
            "nameCh": {
                "key": "nameCh",
                "wireKey": "where[name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ch"
                ]
            },
            "slugCh": {
                "key": "slugCh",
                "wireKey": "where[slug_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ch"
                ]
            },
            "nameIn": {
                "key": "nameIn",
                "wireKey": "where[name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_in"
                ]
            },
            "slugIn": {
                "key": "slugIn",
                "wireKey": "where[slug_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_in"
                ]
            },
            "nameJp": {
                "key": "nameJp",
                "wireKey": "where[name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_jp"
                ]
            },
            "slugJp": {
                "key": "slugJp",
                "wireKey": "where[slug_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_jp"
                ]
            },
            "nameMx": {
                "key": "nameMx",
                "wireKey": "where[name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_mx"
                ]
            },
            "slugMx": {
                "key": "slugMx",
                "wireKey": "where[slug_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_mx"
                ]
            },
            "nameRs": {
                "key": "nameRs",
                "wireKey": "where[name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_rs"
                ]
            },
            "slugRs": {
                "key": "slugRs",
                "wireKey": "where[slug_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_rs"
                ]
            },
            "nameBa": {
                "key": "nameBa",
                "wireKey": "where[name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ba"
                ]
            },
            "slugBa": {
                "key": "slugBa",
                "wireKey": "where[slug_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ba"
                ]
            },
            "nameLt": {
                "key": "nameLt",
                "wireKey": "where[name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lt"
                ]
            },
            "slugLt": {
                "key": "slugLt",
                "wireKey": "where[slug_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lt"
                ]
            },
            "offerGeo": {
                "key": "offerGeo",
                "wireKey": "where[offer_geo][exists]",
                "operators": [
                    "exists"
                ],
                "legacyKeys": [
                    "offer_geo"
                ]
            },
            "employmentTypeId": {
                "key": "employmentTypeId",
                "wireKey": "where[employment_type_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "employment_type_id"
                ]
            },
            "companyId": {
                "key": "companyId",
                "wireKey": "where[company_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "company_id"
                ]
            },
            "countryId": {
                "key": "countryId",
                "wireKey": "where[country_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "country_id"
                ]
            },
            "status": {
                "key": "status",
                "wireKey": "where[status][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "status"
                ]
            },
            "addressFull": {
                "key": "addressFull",
                "wireKey": "where[address_full][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "address_full"
                ]
            },
            "workingHours": {
                "key": "workingHours",
                "wireKey": "where[working_hours][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "working_hours"
                ]
            },
            "categories": {
                "key": "categories",
                "wireKey": "where[categories][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories"
                ]
            },
            "drivingLicences": {
                "key": "drivingLicences",
                "wireKey": "where[driving_licences][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "driving_licences"
                ]
            },
            "languages": {
                "key": "languages",
                "wireKey": "where[languages][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages"
                ]
            },
            "tags": {
                "key": "tags",
                "wireKey": "where[tags][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tags"
                ]
            },
            "isPaid": {
                "key": "isPaid",
                "wireKey": "where[is_paid][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_paid"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "expiresAt": {
                "key": "expiresAt",
                "wireKey": "where[expires_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "expires_at"
                ]
            },
            "paidAt": {
                "key": "paidAt",
                "wireKey": "where[paid_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "paid_at"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "toppedUpTo": {
                "key": "toppedUpTo",
                "wireKey": "where[topped_up_to][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "topped_up_to"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "salariesStoreId": {
                "key": "salariesStoreId",
                "wireKey": "where[salaries.store_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "salaries.store_id"
                ]
            },
            "salariesSalaryTypeId": {
                "key": "salariesSalaryTypeId",
                "wireKey": "where[salaries.salary_type_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "salaries.salary_type_id"
                ]
            },
            "salariesMinSalary": {
                "key": "salariesMinSalary",
                "wireKey": "where[salaries.min_salary][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "salaries.min_salary"
                ]
            },
            "salariesMaxSalary": {
                "key": "salariesMaxSalary",
                "wireKey": "where[salaries.max_salary][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "salaries.max_salary"
                ]
            },
            "storesId": {
                "key": "storesId",
                "wireKey": "where[stores.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.id"
                ]
            },
            "storesName": {
                "key": "storesName",
                "wireKey": "where[stores.name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.name"
                ]
            },
            "salaryFrom": {
                "key": "salaryFrom",
                "wireKey": "salary_from",
                "operators": [],
                "legacyKeys": [
                    "salary_from"
                ]
            },
            "salaryTo": {
                "key": "salaryTo",
                "wireKey": "salary_to",
                "operators": [],
                "legacyKeys": [
                    "salary_to"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "slug",
                "legacyKeys": [
                    "slug"
                ]
            },
            "addressFull": {
                "key": "addressFull",
                "wireKey": "address_full",
                "legacyKeys": [
                    "address_full"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "toppedUpTo": {
                "key": "toppedUpTo",
                "wireKey": "topped_up_to",
                "legacyKeys": [
                    "topped_up_to"
                ]
            },
            "expiresAt": {
                "key": "expiresAt",
                "wireKey": "expires_at",
                "legacyKeys": [
                    "expires_at"
                ]
            },
            "paidAt": {
                "key": "paidAt",
                "wireKey": "paid_at",
                "legacyKeys": [
                    "paid_at"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "publishedAt": {
                "key": "publishedAt",
                "wireKey": "published_at",
                "legacyKeys": [
                    "published_at"
                ]
            },
            "minSalary": {
                "key": "minSalary",
                "wireKey": "min_salary",
                "legacyKeys": [
                    "min_salary"
                ]
            },
            "maxSalary": {
                "key": "maxSalary",
                "wireKey": "max_salary",
                "legacyKeys": [
                    "max_salary"
                ]
            },
            "relevance": {
                "key": "relevance",
                "wireKey": "_score",
                "legacyKeys": [
                    "_score"
                ]
            },
            "stores": {
                "key": "stores",
                "wireKey": "stores",
                "legacyKeys": [
                    "stores"
                ]
            }
        }
    },
"storefrontJobPortalCurriculumVitaes": {
        "key": "storefrontJobPortalCurriculumVitaes",
        "method": "get",
        "endpoint": "/job-portal/curriculum-vitaes",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "where[slug][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug"
                ]
            },
            "slugSk": {
                "key": "slugSk",
                "wireKey": "where[slug_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_sk"
                ]
            },
            "slugCs": {
                "key": "slugCs",
                "wireKey": "where[slug_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_cs"
                ]
            },
            "slugEn": {
                "key": "slugEn",
                "wireKey": "where[slug_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_en"
                ]
            },
            "slugPl": {
                "key": "slugPl",
                "wireKey": "where[slug_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pl"
                ]
            },
            "slugHu": {
                "key": "slugHu",
                "wireKey": "where[slug_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hu"
                ]
            },
            "slugEs": {
                "key": "slugEs",
                "wireKey": "where[slug_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_es"
                ]
            },
            "slugFr": {
                "key": "slugFr",
                "wireKey": "where[slug_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fr"
                ]
            },
            "slugHr": {
                "key": "slugHr",
                "wireKey": "where[slug_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hr"
                ]
            },
            "slugIt": {
                "key": "slugIt",
                "wireKey": "where[slug_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_it"
                ]
            },
            "slugDe": {
                "key": "slugDe",
                "wireKey": "where[slug_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_de"
                ]
            },
            "slugBe": {
                "key": "slugBe",
                "wireKey": "where[slug_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_be"
                ]
            },
            "slugBg": {
                "key": "slugBg",
                "wireKey": "where[slug_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_bg"
                ]
            },
            "slugGr": {
                "key": "slugGr",
                "wireKey": "where[slug_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_gr"
                ]
            },
            "slugSe": {
                "key": "slugSe",
                "wireKey": "where[slug_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_se"
                ]
            },
            "slugFi": {
                "key": "slugFi",
                "wireKey": "where[slug_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fi"
                ]
            },
            "slugDk": {
                "key": "slugDk",
                "wireKey": "where[slug_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_dk"
                ]
            },
            "slugNr": {
                "key": "slugNr",
                "wireKey": "where[slug_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nr"
                ]
            },
            "slugRu": {
                "key": "slugRu",
                "wireKey": "where[slug_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ru"
                ]
            },
            "slugRo": {
                "key": "slugRo",
                "wireKey": "where[slug_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ro"
                ]
            },
            "slugNl": {
                "key": "slugNl",
                "wireKey": "where[slug_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nl"
                ]
            },
            "slugSi": {
                "key": "slugSi",
                "wireKey": "where[slug_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_si"
                ]
            },
            "slugAt": {
                "key": "slugAt",
                "wireKey": "where[slug_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_at"
                ]
            },
            "slugBr": {
                "key": "slugBr",
                "wireKey": "where[slug_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_br"
                ]
            },
            "slugPt": {
                "key": "slugPt",
                "wireKey": "where[slug_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pt"
                ]
            },
            "slugUa": {
                "key": "slugUa",
                "wireKey": "where[slug_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ua"
                ]
            },
            "slugTr": {
                "key": "slugTr",
                "wireKey": "where[slug_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_tr"
                ]
            },
            "slugEe": {
                "key": "slugEe",
                "wireKey": "where[slug_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ee"
                ]
            },
            "slugLv": {
                "key": "slugLv",
                "wireKey": "where[slug_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lv"
                ]
            },
            "slugUs": {
                "key": "slugUs",
                "wireKey": "where[slug_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_us"
                ]
            },
            "slugAu": {
                "key": "slugAu",
                "wireKey": "where[slug_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_au"
                ]
            },
            "slugCa": {
                "key": "slugCa",
                "wireKey": "where[slug_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ca"
                ]
            },
            "slugCh": {
                "key": "slugCh",
                "wireKey": "where[slug_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ch"
                ]
            },
            "slugIn": {
                "key": "slugIn",
                "wireKey": "where[slug_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_in"
                ]
            },
            "slugJp": {
                "key": "slugJp",
                "wireKey": "where[slug_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_jp"
                ]
            },
            "slugMx": {
                "key": "slugMx",
                "wireKey": "where[slug_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_mx"
                ]
            },
            "slugRs": {
                "key": "slugRs",
                "wireKey": "where[slug_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_rs"
                ]
            },
            "slugBa": {
                "key": "slugBa",
                "wireKey": "where[slug_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ba"
                ]
            },
            "slugLt": {
                "key": "slugLt",
                "wireKey": "where[slug_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lt"
                ]
            },
            "fullName": {
                "key": "fullName",
                "wireKey": "where[full_name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "full_name"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "surname": {
                "key": "surname",
                "wireKey": "where[surname][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "surname"
                ]
            },
            "phone": {
                "key": "phone",
                "wireKey": "where[phone][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "phone"
                ]
            },
            "email": {
                "key": "email",
                "wireKey": "where[email][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "email"
                ]
            },
            "statusId": {
                "key": "statusId",
                "wireKey": "where[status_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "status_id"
                ]
            },
            "genderId": {
                "key": "genderId",
                "wireKey": "where[gender_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "gender_id"
                ]
            },
            "countryId": {
                "key": "countryId",
                "wireKey": "where[country_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "country_id"
                ]
            },
            "showInIndex": {
                "key": "showInIndex",
                "wireKey": "where[show_in_index][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "show_in_index"
                ]
            },
            "categoriesId": {
                "key": "categoriesId",
                "wireKey": "where[categories.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.id"
                ]
            },
            "categoriesNameSk": {
                "key": "categoriesNameSk",
                "wireKey": "where[categories.name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_sk"
                ]
            },
            "categoriesNameCs": {
                "key": "categoriesNameCs",
                "wireKey": "where[categories.name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_cs"
                ]
            },
            "categoriesNameEn": {
                "key": "categoriesNameEn",
                "wireKey": "where[categories.name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_en"
                ]
            },
            "categoriesNamePl": {
                "key": "categoriesNamePl",
                "wireKey": "where[categories.name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_pl"
                ]
            },
            "categoriesNameHu": {
                "key": "categoriesNameHu",
                "wireKey": "where[categories.name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_hu"
                ]
            },
            "categoriesNameEs": {
                "key": "categoriesNameEs",
                "wireKey": "where[categories.name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_es"
                ]
            },
            "categoriesNameFr": {
                "key": "categoriesNameFr",
                "wireKey": "where[categories.name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_fr"
                ]
            },
            "categoriesNameHr": {
                "key": "categoriesNameHr",
                "wireKey": "where[categories.name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_hr"
                ]
            },
            "categoriesNameIt": {
                "key": "categoriesNameIt",
                "wireKey": "where[categories.name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_it"
                ]
            },
            "categoriesNameDe": {
                "key": "categoriesNameDe",
                "wireKey": "where[categories.name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_de"
                ]
            },
            "categoriesNameBe": {
                "key": "categoriesNameBe",
                "wireKey": "where[categories.name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_be"
                ]
            },
            "categoriesNameBg": {
                "key": "categoriesNameBg",
                "wireKey": "where[categories.name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_bg"
                ]
            },
            "categoriesNameGr": {
                "key": "categoriesNameGr",
                "wireKey": "where[categories.name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_gr"
                ]
            },
            "categoriesNameSe": {
                "key": "categoriesNameSe",
                "wireKey": "where[categories.name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_se"
                ]
            },
            "categoriesNameFi": {
                "key": "categoriesNameFi",
                "wireKey": "where[categories.name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_fi"
                ]
            },
            "categoriesNameDk": {
                "key": "categoriesNameDk",
                "wireKey": "where[categories.name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_dk"
                ]
            },
            "categoriesNameNr": {
                "key": "categoriesNameNr",
                "wireKey": "where[categories.name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_nr"
                ]
            },
            "categoriesNameRu": {
                "key": "categoriesNameRu",
                "wireKey": "where[categories.name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ru"
                ]
            },
            "categoriesNameRo": {
                "key": "categoriesNameRo",
                "wireKey": "where[categories.name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ro"
                ]
            },
            "categoriesNameNl": {
                "key": "categoriesNameNl",
                "wireKey": "where[categories.name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_nl"
                ]
            },
            "categoriesNameSi": {
                "key": "categoriesNameSi",
                "wireKey": "where[categories.name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_si"
                ]
            },
            "categoriesNameAt": {
                "key": "categoriesNameAt",
                "wireKey": "where[categories.name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_at"
                ]
            },
            "categoriesNameBr": {
                "key": "categoriesNameBr",
                "wireKey": "where[categories.name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_br"
                ]
            },
            "categoriesNamePt": {
                "key": "categoriesNamePt",
                "wireKey": "where[categories.name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_pt"
                ]
            },
            "categoriesNameUa": {
                "key": "categoriesNameUa",
                "wireKey": "where[categories.name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ua"
                ]
            },
            "categoriesNameTr": {
                "key": "categoriesNameTr",
                "wireKey": "where[categories.name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_tr"
                ]
            },
            "categoriesNameEe": {
                "key": "categoriesNameEe",
                "wireKey": "where[categories.name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ee"
                ]
            },
            "categoriesNameLv": {
                "key": "categoriesNameLv",
                "wireKey": "where[categories.name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_lv"
                ]
            },
            "categoriesNameUs": {
                "key": "categoriesNameUs",
                "wireKey": "where[categories.name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_us"
                ]
            },
            "categoriesNameAu": {
                "key": "categoriesNameAu",
                "wireKey": "where[categories.name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_au"
                ]
            },
            "categoriesNameCa": {
                "key": "categoriesNameCa",
                "wireKey": "where[categories.name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ca"
                ]
            },
            "categoriesNameCh": {
                "key": "categoriesNameCh",
                "wireKey": "where[categories.name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ch"
                ]
            },
            "categoriesNameIn": {
                "key": "categoriesNameIn",
                "wireKey": "where[categories.name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_in"
                ]
            },
            "categoriesNameJp": {
                "key": "categoriesNameJp",
                "wireKey": "where[categories.name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_jp"
                ]
            },
            "categoriesNameMx": {
                "key": "categoriesNameMx",
                "wireKey": "where[categories.name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_mx"
                ]
            },
            "categoriesNameRs": {
                "key": "categoriesNameRs",
                "wireKey": "where[categories.name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_rs"
                ]
            },
            "categoriesNameBa": {
                "key": "categoriesNameBa",
                "wireKey": "where[categories.name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ba"
                ]
            },
            "categoriesNameLt": {
                "key": "categoriesNameLt",
                "wireKey": "where[categories.name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_lt"
                ]
            },
            "languagesId": {
                "key": "languagesId",
                "wireKey": "where[languages.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.id"
                ]
            },
            "languagesNameSk": {
                "key": "languagesNameSk",
                "wireKey": "where[languages.name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_sk"
                ]
            },
            "languagesNameCs": {
                "key": "languagesNameCs",
                "wireKey": "where[languages.name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_cs"
                ]
            },
            "languagesNameEn": {
                "key": "languagesNameEn",
                "wireKey": "where[languages.name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_en"
                ]
            },
            "languagesNamePl": {
                "key": "languagesNamePl",
                "wireKey": "where[languages.name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_pl"
                ]
            },
            "languagesNameHu": {
                "key": "languagesNameHu",
                "wireKey": "where[languages.name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_hu"
                ]
            },
            "languagesNameEs": {
                "key": "languagesNameEs",
                "wireKey": "where[languages.name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_es"
                ]
            },
            "languagesNameFr": {
                "key": "languagesNameFr",
                "wireKey": "where[languages.name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_fr"
                ]
            },
            "languagesNameHr": {
                "key": "languagesNameHr",
                "wireKey": "where[languages.name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_hr"
                ]
            },
            "languagesNameIt": {
                "key": "languagesNameIt",
                "wireKey": "where[languages.name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_it"
                ]
            },
            "languagesNameDe": {
                "key": "languagesNameDe",
                "wireKey": "where[languages.name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_de"
                ]
            },
            "languagesNameBe": {
                "key": "languagesNameBe",
                "wireKey": "where[languages.name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_be"
                ]
            },
            "languagesNameBg": {
                "key": "languagesNameBg",
                "wireKey": "where[languages.name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_bg"
                ]
            },
            "languagesNameGr": {
                "key": "languagesNameGr",
                "wireKey": "where[languages.name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_gr"
                ]
            },
            "languagesNameSe": {
                "key": "languagesNameSe",
                "wireKey": "where[languages.name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_se"
                ]
            },
            "languagesNameFi": {
                "key": "languagesNameFi",
                "wireKey": "where[languages.name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_fi"
                ]
            },
            "languagesNameDk": {
                "key": "languagesNameDk",
                "wireKey": "where[languages.name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_dk"
                ]
            },
            "languagesNameNr": {
                "key": "languagesNameNr",
                "wireKey": "where[languages.name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_nr"
                ]
            },
            "languagesNameRu": {
                "key": "languagesNameRu",
                "wireKey": "where[languages.name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_ru"
                ]
            },
            "languagesNameRo": {
                "key": "languagesNameRo",
                "wireKey": "where[languages.name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_ro"
                ]
            },
            "languagesNameNl": {
                "key": "languagesNameNl",
                "wireKey": "where[languages.name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_nl"
                ]
            },
            "languagesNameSi": {
                "key": "languagesNameSi",
                "wireKey": "where[languages.name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_si"
                ]
            },
            "languagesNameAt": {
                "key": "languagesNameAt",
                "wireKey": "where[languages.name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_at"
                ]
            },
            "languagesNameBr": {
                "key": "languagesNameBr",
                "wireKey": "where[languages.name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_br"
                ]
            },
            "languagesNamePt": {
                "key": "languagesNamePt",
                "wireKey": "where[languages.name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_pt"
                ]
            },
            "languagesNameUa": {
                "key": "languagesNameUa",
                "wireKey": "where[languages.name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_ua"
                ]
            },
            "languagesNameTr": {
                "key": "languagesNameTr",
                "wireKey": "where[languages.name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_tr"
                ]
            },
            "languagesNameEe": {
                "key": "languagesNameEe",
                "wireKey": "where[languages.name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_ee"
                ]
            },
            "languagesNameLv": {
                "key": "languagesNameLv",
                "wireKey": "where[languages.name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_lv"
                ]
            },
            "languagesNameUs": {
                "key": "languagesNameUs",
                "wireKey": "where[languages.name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_us"
                ]
            },
            "languagesNameAu": {
                "key": "languagesNameAu",
                "wireKey": "where[languages.name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_au"
                ]
            },
            "languagesNameCa": {
                "key": "languagesNameCa",
                "wireKey": "where[languages.name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_ca"
                ]
            },
            "languagesNameCh": {
                "key": "languagesNameCh",
                "wireKey": "where[languages.name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_ch"
                ]
            },
            "languagesNameIn": {
                "key": "languagesNameIn",
                "wireKey": "where[languages.name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_in"
                ]
            },
            "languagesNameJp": {
                "key": "languagesNameJp",
                "wireKey": "where[languages.name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_jp"
                ]
            },
            "languagesNameMx": {
                "key": "languagesNameMx",
                "wireKey": "where[languages.name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_mx"
                ]
            },
            "languagesNameRs": {
                "key": "languagesNameRs",
                "wireKey": "where[languages.name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_rs"
                ]
            },
            "languagesNameBa": {
                "key": "languagesNameBa",
                "wireKey": "where[languages.name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_ba"
                ]
            },
            "languagesNameLt": {
                "key": "languagesNameLt",
                "wireKey": "where[languages.name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "languages.name_lt"
                ]
            },
            "disciplines": {
                "key": "disciplines",
                "wireKey": "where[disciplines][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "disciplines"
                ]
            },
            "drivingLicences": {
                "key": "drivingLicences",
                "wireKey": "where[driving_licences][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "driving_licences"
                ]
            },
            "employmentTypes": {
                "key": "employmentTypes",
                "wireKey": "where[employment_types][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "employment_types"
                ]
            },
            "curriculumVitaeGeo": {
                "key": "curriculumVitaeGeo",
                "wireKey": "where[curriculum_vitae_geo][exists]",
                "operators": [
                    "exists"
                ],
                "legacyKeys": [
                    "curriculum_vitae_geo"
                ]
            },
            "salariesStoreId": {
                "key": "salariesStoreId",
                "wireKey": "where[salaries.store_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "salaries.store_id"
                ]
            },
            "salariesMinSalary": {
                "key": "salariesMinSalary",
                "wireKey": "where[salaries.min_salary][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "salaries.min_salary"
                ]
            },
            "salariesMaxSalary": {
                "key": "salariesMaxSalary",
                "wireKey": "where[salaries.max_salary][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "salaries.max_salary"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "toppedUpTo": {
                "key": "toppedUpTo",
                "wireKey": "where[topped_up_to][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "topped_up_to"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "storesId": {
                "key": "storesId",
                "wireKey": "where[stores.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.id"
                ]
            },
            "storesName": {
                "key": "storesName",
                "wireKey": "where[stores.name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.name"
                ]
            },
            "salaryFrom": {
                "key": "salaryFrom",
                "wireKey": "salary_from",
                "operators": [],
                "legacyKeys": [
                    "salary_from"
                ]
            },
            "salaryTo": {
                "key": "salaryTo",
                "wireKey": "salary_to",
                "operators": [],
                "legacyKeys": [
                    "salary_to"
                ]
            }
        },
        "sorts": {
            "languages": {
                "key": "languages",
                "wireKey": "languages",
                "legacyKeys": [
                    "languages"
                ]
            },
            "categories": {
                "key": "categories",
                "wireKey": "categories",
                "legacyKeys": [
                    "categories"
                ]
            },
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "slug",
                "legacyKeys": [
                    "slug"
                ]
            },
            "fullName": {
                "key": "fullName",
                "wireKey": "full_name",
                "legacyKeys": [
                    "full_name"
                ]
            },
            "phone": {
                "key": "phone",
                "wireKey": "phone",
                "legacyKeys": [
                    "phone"
                ]
            },
            "email": {
                "key": "email",
                "wireKey": "email",
                "legacyKeys": [
                    "email"
                ]
            },
            "toppedUpTo": {
                "key": "toppedUpTo",
                "wireKey": "topped_up_to",
                "legacyKeys": [
                    "topped_up_to"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "relevance": {
                "key": "relevance",
                "wireKey": "_score",
                "legacyKeys": [
                    "_score"
                ]
            },
            "stores": {
                "key": "stores",
                "wireKey": "stores",
                "legacyKeys": [
                    "stores"
                ]
            }
        }
    },
"storefrontCourseTypes": {
        "key": "storefrontCourseTypes",
        "method": "get",
        "endpoint": "/course/types",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "subscriptionOnly": {
                "key": "subscriptionOnly",
                "wireKey": "where[subscription_only][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "subscription_only"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "subscriptionOnly": {
                "key": "subscriptionOnly",
                "wireKey": "subscription_only",
                "legacyKeys": [
                    "subscription_only"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontCourseLevels": {
        "key": "storefrontCourseLevels",
        "method": "get",
        "endpoint": "/course/levels",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontCourseRooms": {
        "key": "storefrontCourseRooms",
        "method": "get",
        "endpoint": "/course/rooms",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontCourseCategories": {
        "key": "storefrontCourseCategories",
        "method": "get",
        "endpoint": "/course/categories",
        "queryFormat": "payload",
        "booleanWhere": false,
        "multiSort": false,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "parent": {
                "key": "parent",
                "wireKey": "where[parent][equals]",
                "operators": [
                    "equals",
                    "in",
                    "exists"
                ],
                "legacyKeys": [
                    "parent"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontCourseLecturers": {
        "key": "storefrontCourseLecturers",
        "method": "get",
        "endpoint": "/course/lecturers",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontCourseEvents": {
        "key": "storefrontCourseEvents",
        "method": "get",
        "endpoint": "/course/events",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontCourseCourses": {
        "key": "storefrontCourseCourses",
        "method": "get",
        "endpoint": "/course/courses",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "where[slug][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug"
                ]
            },
            "nameSk": {
                "key": "nameSk",
                "wireKey": "where[name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_sk"
                ]
            },
            "slugSk": {
                "key": "slugSk",
                "wireKey": "where[slug_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_sk"
                ]
            },
            "nameCs": {
                "key": "nameCs",
                "wireKey": "where[name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_cs"
                ]
            },
            "slugCs": {
                "key": "slugCs",
                "wireKey": "where[slug_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_cs"
                ]
            },
            "nameEn": {
                "key": "nameEn",
                "wireKey": "where[name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_en"
                ]
            },
            "slugEn": {
                "key": "slugEn",
                "wireKey": "where[slug_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_en"
                ]
            },
            "namePl": {
                "key": "namePl",
                "wireKey": "where[name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pl"
                ]
            },
            "slugPl": {
                "key": "slugPl",
                "wireKey": "where[slug_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pl"
                ]
            },
            "nameHu": {
                "key": "nameHu",
                "wireKey": "where[name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hu"
                ]
            },
            "slugHu": {
                "key": "slugHu",
                "wireKey": "where[slug_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hu"
                ]
            },
            "nameEs": {
                "key": "nameEs",
                "wireKey": "where[name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_es"
                ]
            },
            "slugEs": {
                "key": "slugEs",
                "wireKey": "where[slug_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_es"
                ]
            },
            "nameFr": {
                "key": "nameFr",
                "wireKey": "where[name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fr"
                ]
            },
            "slugFr": {
                "key": "slugFr",
                "wireKey": "where[slug_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fr"
                ]
            },
            "nameHr": {
                "key": "nameHr",
                "wireKey": "where[name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hr"
                ]
            },
            "slugHr": {
                "key": "slugHr",
                "wireKey": "where[slug_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hr"
                ]
            },
            "nameIt": {
                "key": "nameIt",
                "wireKey": "where[name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_it"
                ]
            },
            "slugIt": {
                "key": "slugIt",
                "wireKey": "where[slug_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_it"
                ]
            },
            "nameDe": {
                "key": "nameDe",
                "wireKey": "where[name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_de"
                ]
            },
            "slugDe": {
                "key": "slugDe",
                "wireKey": "where[slug_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_de"
                ]
            },
            "nameBe": {
                "key": "nameBe",
                "wireKey": "where[name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_be"
                ]
            },
            "slugBe": {
                "key": "slugBe",
                "wireKey": "where[slug_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_be"
                ]
            },
            "nameBg": {
                "key": "nameBg",
                "wireKey": "where[name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_bg"
                ]
            },
            "slugBg": {
                "key": "slugBg",
                "wireKey": "where[slug_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_bg"
                ]
            },
            "nameGr": {
                "key": "nameGr",
                "wireKey": "where[name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_gr"
                ]
            },
            "slugGr": {
                "key": "slugGr",
                "wireKey": "where[slug_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_gr"
                ]
            },
            "nameSe": {
                "key": "nameSe",
                "wireKey": "where[name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_se"
                ]
            },
            "slugSe": {
                "key": "slugSe",
                "wireKey": "where[slug_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_se"
                ]
            },
            "nameFi": {
                "key": "nameFi",
                "wireKey": "where[name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fi"
                ]
            },
            "slugFi": {
                "key": "slugFi",
                "wireKey": "where[slug_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fi"
                ]
            },
            "nameDk": {
                "key": "nameDk",
                "wireKey": "where[name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_dk"
                ]
            },
            "slugDk": {
                "key": "slugDk",
                "wireKey": "where[slug_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_dk"
                ]
            },
            "nameNr": {
                "key": "nameNr",
                "wireKey": "where[name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nr"
                ]
            },
            "slugNr": {
                "key": "slugNr",
                "wireKey": "where[slug_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nr"
                ]
            },
            "nameRu": {
                "key": "nameRu",
                "wireKey": "where[name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ru"
                ]
            },
            "slugRu": {
                "key": "slugRu",
                "wireKey": "where[slug_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ru"
                ]
            },
            "nameRo": {
                "key": "nameRo",
                "wireKey": "where[name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ro"
                ]
            },
            "slugRo": {
                "key": "slugRo",
                "wireKey": "where[slug_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ro"
                ]
            },
            "nameNl": {
                "key": "nameNl",
                "wireKey": "where[name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nl"
                ]
            },
            "slugNl": {
                "key": "slugNl",
                "wireKey": "where[slug_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nl"
                ]
            },
            "nameSi": {
                "key": "nameSi",
                "wireKey": "where[name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_si"
                ]
            },
            "slugSi": {
                "key": "slugSi",
                "wireKey": "where[slug_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_si"
                ]
            },
            "nameAt": {
                "key": "nameAt",
                "wireKey": "where[name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_at"
                ]
            },
            "slugAt": {
                "key": "slugAt",
                "wireKey": "where[slug_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_at"
                ]
            },
            "nameBr": {
                "key": "nameBr",
                "wireKey": "where[name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_br"
                ]
            },
            "slugBr": {
                "key": "slugBr",
                "wireKey": "where[slug_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_br"
                ]
            },
            "namePt": {
                "key": "namePt",
                "wireKey": "where[name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pt"
                ]
            },
            "slugPt": {
                "key": "slugPt",
                "wireKey": "where[slug_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pt"
                ]
            },
            "nameUa": {
                "key": "nameUa",
                "wireKey": "where[name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ua"
                ]
            },
            "slugUa": {
                "key": "slugUa",
                "wireKey": "where[slug_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ua"
                ]
            },
            "nameTr": {
                "key": "nameTr",
                "wireKey": "where[name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_tr"
                ]
            },
            "slugTr": {
                "key": "slugTr",
                "wireKey": "where[slug_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_tr"
                ]
            },
            "nameEe": {
                "key": "nameEe",
                "wireKey": "where[name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ee"
                ]
            },
            "slugEe": {
                "key": "slugEe",
                "wireKey": "where[slug_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ee"
                ]
            },
            "nameLv": {
                "key": "nameLv",
                "wireKey": "where[name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lv"
                ]
            },
            "slugLv": {
                "key": "slugLv",
                "wireKey": "where[slug_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lv"
                ]
            },
            "nameUs": {
                "key": "nameUs",
                "wireKey": "where[name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_us"
                ]
            },
            "slugUs": {
                "key": "slugUs",
                "wireKey": "where[slug_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_us"
                ]
            },
            "nameAu": {
                "key": "nameAu",
                "wireKey": "where[name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_au"
                ]
            },
            "slugAu": {
                "key": "slugAu",
                "wireKey": "where[slug_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_au"
                ]
            },
            "nameCa": {
                "key": "nameCa",
                "wireKey": "where[name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ca"
                ]
            },
            "slugCa": {
                "key": "slugCa",
                "wireKey": "where[slug_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ca"
                ]
            },
            "nameCh": {
                "key": "nameCh",
                "wireKey": "where[name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ch"
                ]
            },
            "slugCh": {
                "key": "slugCh",
                "wireKey": "where[slug_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ch"
                ]
            },
            "nameIn": {
                "key": "nameIn",
                "wireKey": "where[name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_in"
                ]
            },
            "slugIn": {
                "key": "slugIn",
                "wireKey": "where[slug_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_in"
                ]
            },
            "nameJp": {
                "key": "nameJp",
                "wireKey": "where[name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_jp"
                ]
            },
            "slugJp": {
                "key": "slugJp",
                "wireKey": "where[slug_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_jp"
                ]
            },
            "nameMx": {
                "key": "nameMx",
                "wireKey": "where[name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_mx"
                ]
            },
            "slugMx": {
                "key": "slugMx",
                "wireKey": "where[slug_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_mx"
                ]
            },
            "nameRs": {
                "key": "nameRs",
                "wireKey": "where[name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_rs"
                ]
            },
            "slugRs": {
                "key": "slugRs",
                "wireKey": "where[slug_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_rs"
                ]
            },
            "nameBa": {
                "key": "nameBa",
                "wireKey": "where[name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ba"
                ]
            },
            "slugBa": {
                "key": "slugBa",
                "wireKey": "where[slug_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ba"
                ]
            },
            "nameLt": {
                "key": "nameLt",
                "wireKey": "where[name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lt"
                ]
            },
            "slugLt": {
                "key": "slugLt",
                "wireKey": "where[slug_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lt"
                ]
            },
            "duration": {
                "key": "duration",
                "wireKey": "where[duration][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "duration"
                ]
            },
            "roomId": {
                "key": "roomId",
                "wireKey": "where[room_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "room_id"
                ]
            },
            "customerId": {
                "key": "customerId",
                "wireKey": "where[customer_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "customer_id"
                ]
            },
            "courseTypeId": {
                "key": "courseTypeId",
                "wireKey": "where[course_type_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "course_type_id"
                ]
            },
            "events": {
                "key": "events",
                "wireKey": "where[events][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "events"
                ]
            },
            "lecturers": {
                "key": "lecturers",
                "wireKey": "where[lecturers][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "lecturers"
                ]
            },
            "levels": {
                "key": "levels",
                "wireKey": "where[levels][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "levels"
                ]
            },
            "toppedUpTo": {
                "key": "toppedUpTo",
                "wireKey": "where[topped_up_to][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "topped_up_to"
                ]
            },
            "expiresAt": {
                "key": "expiresAt",
                "wireKey": "where[expires_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "expires_at"
                ]
            },
            "isPaid": {
                "key": "isPaid",
                "wireKey": "where[is_paid][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_paid"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "categoriesId": {
                "key": "categoriesId",
                "wireKey": "where[categories.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.id"
                ]
            },
            "categoriesNameSk": {
                "key": "categoriesNameSk",
                "wireKey": "where[categories.name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_sk"
                ]
            },
            "categoriesNameCs": {
                "key": "categoriesNameCs",
                "wireKey": "where[categories.name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_cs"
                ]
            },
            "categoriesNameEn": {
                "key": "categoriesNameEn",
                "wireKey": "where[categories.name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_en"
                ]
            },
            "categoriesNamePl": {
                "key": "categoriesNamePl",
                "wireKey": "where[categories.name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_pl"
                ]
            },
            "categoriesNameHu": {
                "key": "categoriesNameHu",
                "wireKey": "where[categories.name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_hu"
                ]
            },
            "categoriesNameEs": {
                "key": "categoriesNameEs",
                "wireKey": "where[categories.name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_es"
                ]
            },
            "categoriesNameFr": {
                "key": "categoriesNameFr",
                "wireKey": "where[categories.name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_fr"
                ]
            },
            "categoriesNameHr": {
                "key": "categoriesNameHr",
                "wireKey": "where[categories.name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_hr"
                ]
            },
            "categoriesNameIt": {
                "key": "categoriesNameIt",
                "wireKey": "where[categories.name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_it"
                ]
            },
            "categoriesNameDe": {
                "key": "categoriesNameDe",
                "wireKey": "where[categories.name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_de"
                ]
            },
            "categoriesNameBe": {
                "key": "categoriesNameBe",
                "wireKey": "where[categories.name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_be"
                ]
            },
            "categoriesNameBg": {
                "key": "categoriesNameBg",
                "wireKey": "where[categories.name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_bg"
                ]
            },
            "categoriesNameGr": {
                "key": "categoriesNameGr",
                "wireKey": "where[categories.name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_gr"
                ]
            },
            "categoriesNameSe": {
                "key": "categoriesNameSe",
                "wireKey": "where[categories.name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_se"
                ]
            },
            "categoriesNameFi": {
                "key": "categoriesNameFi",
                "wireKey": "where[categories.name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_fi"
                ]
            },
            "categoriesNameDk": {
                "key": "categoriesNameDk",
                "wireKey": "where[categories.name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_dk"
                ]
            },
            "categoriesNameNr": {
                "key": "categoriesNameNr",
                "wireKey": "where[categories.name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_nr"
                ]
            },
            "categoriesNameRu": {
                "key": "categoriesNameRu",
                "wireKey": "where[categories.name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ru"
                ]
            },
            "categoriesNameRo": {
                "key": "categoriesNameRo",
                "wireKey": "where[categories.name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ro"
                ]
            },
            "categoriesNameNl": {
                "key": "categoriesNameNl",
                "wireKey": "where[categories.name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_nl"
                ]
            },
            "categoriesNameSi": {
                "key": "categoriesNameSi",
                "wireKey": "where[categories.name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_si"
                ]
            },
            "categoriesNameAt": {
                "key": "categoriesNameAt",
                "wireKey": "where[categories.name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_at"
                ]
            },
            "categoriesNameBr": {
                "key": "categoriesNameBr",
                "wireKey": "where[categories.name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_br"
                ]
            },
            "categoriesNamePt": {
                "key": "categoriesNamePt",
                "wireKey": "where[categories.name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_pt"
                ]
            },
            "categoriesNameUa": {
                "key": "categoriesNameUa",
                "wireKey": "where[categories.name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ua"
                ]
            },
            "categoriesNameTr": {
                "key": "categoriesNameTr",
                "wireKey": "where[categories.name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_tr"
                ]
            },
            "categoriesNameEe": {
                "key": "categoriesNameEe",
                "wireKey": "where[categories.name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ee"
                ]
            },
            "categoriesNameLv": {
                "key": "categoriesNameLv",
                "wireKey": "where[categories.name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_lv"
                ]
            },
            "categoriesNameUs": {
                "key": "categoriesNameUs",
                "wireKey": "where[categories.name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_us"
                ]
            },
            "categoriesNameAu": {
                "key": "categoriesNameAu",
                "wireKey": "where[categories.name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_au"
                ]
            },
            "categoriesNameCa": {
                "key": "categoriesNameCa",
                "wireKey": "where[categories.name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ca"
                ]
            },
            "categoriesNameCh": {
                "key": "categoriesNameCh",
                "wireKey": "where[categories.name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ch"
                ]
            },
            "categoriesNameIn": {
                "key": "categoriesNameIn",
                "wireKey": "where[categories.name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_in"
                ]
            },
            "categoriesNameJp": {
                "key": "categoriesNameJp",
                "wireKey": "where[categories.name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_jp"
                ]
            },
            "categoriesNameMx": {
                "key": "categoriesNameMx",
                "wireKey": "where[categories.name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_mx"
                ]
            },
            "categoriesNameRs": {
                "key": "categoriesNameRs",
                "wireKey": "where[categories.name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_rs"
                ]
            },
            "categoriesNameBa": {
                "key": "categoriesNameBa",
                "wireKey": "where[categories.name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_ba"
                ]
            },
            "categoriesNameLt": {
                "key": "categoriesNameLt",
                "wireKey": "where[categories.name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories.name_lt"
                ]
            },
            "pricesStoreId": {
                "key": "pricesStoreId",
                "wireKey": "where[prices.store_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.store_id"
                ]
            },
            "pricesPrice": {
                "key": "pricesPrice",
                "wireKey": "where[prices.price][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.price"
                ]
            },
            "pricesPriceWithVat": {
                "key": "pricesPriceWithVat",
                "wireKey": "where[prices.price_with_vat][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.price_with_vat"
                ]
            },
            "storesId": {
                "key": "storesId",
                "wireKey": "where[stores.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.id"
                ]
            },
            "storesName": {
                "key": "storesName",
                "wireKey": "where[stores.name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.name"
                ]
            },
            "priceFrom": {
                "key": "priceFrom",
                "wireKey": "price_from",
                "operators": [],
                "legacyKeys": [
                    "price_from"
                ]
            },
            "priceTo": {
                "key": "priceTo",
                "wireKey": "price_to",
                "operators": [],
                "legacyKeys": [
                    "price_to"
                ]
            }
        },
        "sorts": {
            "categories": {
                "key": "categories",
                "wireKey": "categories",
                "legacyKeys": [
                    "categories"
                ]
            },
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "slug",
                "legacyKeys": [
                    "slug"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "toppedUpTo": {
                "key": "toppedUpTo",
                "wireKey": "topped_up_to",
                "legacyKeys": [
                    "topped_up_to"
                ]
            },
            "expiresAt": {
                "key": "expiresAt",
                "wireKey": "expires_at",
                "legacyKeys": [
                    "expires_at"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "price": {
                "key": "price",
                "wireKey": "price",
                "legacyKeys": [
                    "price"
                ]
            },
            "priceWithVat": {
                "key": "priceWithVat",
                "wireKey": "price_with_vat",
                "legacyKeys": [
                    "price_with_vat"
                ]
            },
            "relevance": {
                "key": "relevance",
                "wireKey": "_score",
                "legacyKeys": [
                    "_score"
                ]
            },
            "stores": {
                "key": "stores",
                "wireKey": "stores",
                "legacyKeys": [
                    "stores"
                ]
            }
        }
    },
"storefrontTravelAgencyStatuses": {
        "key": "storefrontTravelAgencyStatuses",
        "method": "get",
        "endpoint": "/travel-agency/statuses",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontTravelAgencyTextFields": {
        "key": "storefrontTravelAgencyTextFields",
        "method": "get",
        "endpoint": "/travel-agency/text-fields",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontTravelAgencyTags": {
        "key": "storefrontTravelAgencyTags",
        "method": "get",
        "endpoint": "/travel-agency/tags",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontTravelAgencyCategories": {
        "key": "storefrontTravelAgencyCategories",
        "method": "get",
        "endpoint": "/travel-agency/categories",
        "queryFormat": "payload",
        "booleanWhere": false,
        "multiSort": false,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "in"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "parent": {
                "key": "parent",
                "wireKey": "where[parent][equals]",
                "operators": [
                    "equals",
                    "in",
                    "exists"
                ],
                "legacyKeys": [
                    "parent"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontTravelAgencyAttributes": {
        "key": "storefrontTravelAgencyAttributes",
        "method": "get",
        "endpoint": "/travel-agency/attributes",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    },
"storefrontTravelAgencyAttributesValues": {
        "key": "storefrontTravelAgencyAttributesValues",
        "method": "get",
        "endpoint": "/travel-agency/attributes/values",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "nameSk": {
                "key": "nameSk",
                "wireKey": "where[name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_sk"
                ]
            },
            "nameCs": {
                "key": "nameCs",
                "wireKey": "where[name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_cs"
                ]
            },
            "nameEn": {
                "key": "nameEn",
                "wireKey": "where[name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_en"
                ]
            },
            "namePl": {
                "key": "namePl",
                "wireKey": "where[name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pl"
                ]
            },
            "nameHu": {
                "key": "nameHu",
                "wireKey": "where[name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hu"
                ]
            },
            "nameEs": {
                "key": "nameEs",
                "wireKey": "where[name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_es"
                ]
            },
            "nameFr": {
                "key": "nameFr",
                "wireKey": "where[name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fr"
                ]
            },
            "nameHr": {
                "key": "nameHr",
                "wireKey": "where[name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hr"
                ]
            },
            "nameIt": {
                "key": "nameIt",
                "wireKey": "where[name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_it"
                ]
            },
            "nameDe": {
                "key": "nameDe",
                "wireKey": "where[name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_de"
                ]
            },
            "nameBe": {
                "key": "nameBe",
                "wireKey": "where[name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_be"
                ]
            },
            "nameBg": {
                "key": "nameBg",
                "wireKey": "where[name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_bg"
                ]
            },
            "nameGr": {
                "key": "nameGr",
                "wireKey": "where[name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_gr"
                ]
            },
            "nameSe": {
                "key": "nameSe",
                "wireKey": "where[name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_se"
                ]
            },
            "nameFi": {
                "key": "nameFi",
                "wireKey": "where[name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fi"
                ]
            },
            "nameDk": {
                "key": "nameDk",
                "wireKey": "where[name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_dk"
                ]
            },
            "nameNr": {
                "key": "nameNr",
                "wireKey": "where[name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nr"
                ]
            },
            "nameRu": {
                "key": "nameRu",
                "wireKey": "where[name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ru"
                ]
            },
            "nameRo": {
                "key": "nameRo",
                "wireKey": "where[name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ro"
                ]
            },
            "nameNl": {
                "key": "nameNl",
                "wireKey": "where[name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nl"
                ]
            },
            "nameSi": {
                "key": "nameSi",
                "wireKey": "where[name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_si"
                ]
            },
            "nameAt": {
                "key": "nameAt",
                "wireKey": "where[name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_at"
                ]
            },
            "nameBr": {
                "key": "nameBr",
                "wireKey": "where[name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_br"
                ]
            },
            "namePt": {
                "key": "namePt",
                "wireKey": "where[name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pt"
                ]
            },
            "nameUa": {
                "key": "nameUa",
                "wireKey": "where[name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ua"
                ]
            },
            "nameTr": {
                "key": "nameTr",
                "wireKey": "where[name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_tr"
                ]
            },
            "nameEe": {
                "key": "nameEe",
                "wireKey": "where[name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ee"
                ]
            },
            "nameLv": {
                "key": "nameLv",
                "wireKey": "where[name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lv"
                ]
            },
            "nameUs": {
                "key": "nameUs",
                "wireKey": "where[name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_us"
                ]
            },
            "nameAu": {
                "key": "nameAu",
                "wireKey": "where[name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_au"
                ]
            },
            "nameCa": {
                "key": "nameCa",
                "wireKey": "where[name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ca"
                ]
            },
            "nameCh": {
                "key": "nameCh",
                "wireKey": "where[name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ch"
                ]
            },
            "nameIn": {
                "key": "nameIn",
                "wireKey": "where[name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_in"
                ]
            },
            "nameJp": {
                "key": "nameJp",
                "wireKey": "where[name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_jp"
                ]
            },
            "nameMx": {
                "key": "nameMx",
                "wireKey": "where[name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_mx"
                ]
            },
            "nameRs": {
                "key": "nameRs",
                "wireKey": "where[name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_rs"
                ]
            },
            "nameBa": {
                "key": "nameBa",
                "wireKey": "where[name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ba"
                ]
            },
            "nameLt": {
                "key": "nameLt",
                "wireKey": "where[name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lt"
                ]
            },
            "attributeId": {
                "key": "attributeId",
                "wireKey": "where[attribute_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "attribute_id"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "relevance": {
                "key": "relevance",
                "wireKey": "_score",
                "legacyKeys": [
                    "_score"
                ]
            }
        }
    },
"storefrontTravelAgencyTourDates": {
        "key": "storefrontTravelAgencyTourDates",
        "method": "get",
        "endpoint": "/travel-agency/tour-dates",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "dateStart": {
                "key": "dateStart",
                "wireKey": "where[date_start][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "date_start"
                ]
            },
            "dateStop": {
                "key": "dateStop",
                "wireKey": "where[date_stop][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "date_stop"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "dateStart": {
                "key": "dateStart",
                "wireKey": "date_start",
                "legacyKeys": [
                    "date_start"
                ]
            },
            "dateStop": {
                "key": "dateStop",
                "wireKey": "date_stop",
                "legacyKeys": [
                    "date_stop"
                ]
            }
        }
    },
"storefrontTravelAgencyTours": {
        "key": "storefrontTravelAgencyTours",
        "method": "get",
        "endpoint": "/travel-agency/tours",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "where[name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "where[slug][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug"
                ]
            },
            "nameSk": {
                "key": "nameSk",
                "wireKey": "where[name_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_sk"
                ]
            },
            "slugSk": {
                "key": "slugSk",
                "wireKey": "where[slug_sk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_sk"
                ]
            },
            "nameCs": {
                "key": "nameCs",
                "wireKey": "where[name_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_cs"
                ]
            },
            "slugCs": {
                "key": "slugCs",
                "wireKey": "where[slug_cs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_cs"
                ]
            },
            "nameEn": {
                "key": "nameEn",
                "wireKey": "where[name_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_en"
                ]
            },
            "slugEn": {
                "key": "slugEn",
                "wireKey": "where[slug_en][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_en"
                ]
            },
            "namePl": {
                "key": "namePl",
                "wireKey": "where[name_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pl"
                ]
            },
            "slugPl": {
                "key": "slugPl",
                "wireKey": "where[slug_pl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pl"
                ]
            },
            "nameHu": {
                "key": "nameHu",
                "wireKey": "where[name_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hu"
                ]
            },
            "slugHu": {
                "key": "slugHu",
                "wireKey": "where[slug_hu][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hu"
                ]
            },
            "nameEs": {
                "key": "nameEs",
                "wireKey": "where[name_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_es"
                ]
            },
            "slugEs": {
                "key": "slugEs",
                "wireKey": "where[slug_es][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_es"
                ]
            },
            "nameFr": {
                "key": "nameFr",
                "wireKey": "where[name_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fr"
                ]
            },
            "slugFr": {
                "key": "slugFr",
                "wireKey": "where[slug_fr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fr"
                ]
            },
            "nameHr": {
                "key": "nameHr",
                "wireKey": "where[name_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_hr"
                ]
            },
            "slugHr": {
                "key": "slugHr",
                "wireKey": "where[slug_hr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_hr"
                ]
            },
            "nameIt": {
                "key": "nameIt",
                "wireKey": "where[name_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_it"
                ]
            },
            "slugIt": {
                "key": "slugIt",
                "wireKey": "where[slug_it][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_it"
                ]
            },
            "nameDe": {
                "key": "nameDe",
                "wireKey": "where[name_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_de"
                ]
            },
            "slugDe": {
                "key": "slugDe",
                "wireKey": "where[slug_de][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_de"
                ]
            },
            "nameBe": {
                "key": "nameBe",
                "wireKey": "where[name_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_be"
                ]
            },
            "slugBe": {
                "key": "slugBe",
                "wireKey": "where[slug_be][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_be"
                ]
            },
            "nameBg": {
                "key": "nameBg",
                "wireKey": "where[name_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_bg"
                ]
            },
            "slugBg": {
                "key": "slugBg",
                "wireKey": "where[slug_bg][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_bg"
                ]
            },
            "nameGr": {
                "key": "nameGr",
                "wireKey": "where[name_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_gr"
                ]
            },
            "slugGr": {
                "key": "slugGr",
                "wireKey": "where[slug_gr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_gr"
                ]
            },
            "nameSe": {
                "key": "nameSe",
                "wireKey": "where[name_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_se"
                ]
            },
            "slugSe": {
                "key": "slugSe",
                "wireKey": "where[slug_se][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_se"
                ]
            },
            "nameFi": {
                "key": "nameFi",
                "wireKey": "where[name_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_fi"
                ]
            },
            "slugFi": {
                "key": "slugFi",
                "wireKey": "where[slug_fi][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_fi"
                ]
            },
            "nameDk": {
                "key": "nameDk",
                "wireKey": "where[name_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_dk"
                ]
            },
            "slugDk": {
                "key": "slugDk",
                "wireKey": "where[slug_dk][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_dk"
                ]
            },
            "nameNr": {
                "key": "nameNr",
                "wireKey": "where[name_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nr"
                ]
            },
            "slugNr": {
                "key": "slugNr",
                "wireKey": "where[slug_nr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nr"
                ]
            },
            "nameRu": {
                "key": "nameRu",
                "wireKey": "where[name_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ru"
                ]
            },
            "slugRu": {
                "key": "slugRu",
                "wireKey": "where[slug_ru][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ru"
                ]
            },
            "nameRo": {
                "key": "nameRo",
                "wireKey": "where[name_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ro"
                ]
            },
            "slugRo": {
                "key": "slugRo",
                "wireKey": "where[slug_ro][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ro"
                ]
            },
            "nameNl": {
                "key": "nameNl",
                "wireKey": "where[name_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_nl"
                ]
            },
            "slugNl": {
                "key": "slugNl",
                "wireKey": "where[slug_nl][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_nl"
                ]
            },
            "nameSi": {
                "key": "nameSi",
                "wireKey": "where[name_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_si"
                ]
            },
            "slugSi": {
                "key": "slugSi",
                "wireKey": "where[slug_si][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_si"
                ]
            },
            "nameAt": {
                "key": "nameAt",
                "wireKey": "where[name_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_at"
                ]
            },
            "slugAt": {
                "key": "slugAt",
                "wireKey": "where[slug_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_at"
                ]
            },
            "nameBr": {
                "key": "nameBr",
                "wireKey": "where[name_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_br"
                ]
            },
            "slugBr": {
                "key": "slugBr",
                "wireKey": "where[slug_br][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_br"
                ]
            },
            "namePt": {
                "key": "namePt",
                "wireKey": "where[name_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_pt"
                ]
            },
            "slugPt": {
                "key": "slugPt",
                "wireKey": "where[slug_pt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_pt"
                ]
            },
            "nameUa": {
                "key": "nameUa",
                "wireKey": "where[name_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ua"
                ]
            },
            "slugUa": {
                "key": "slugUa",
                "wireKey": "where[slug_ua][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ua"
                ]
            },
            "nameTr": {
                "key": "nameTr",
                "wireKey": "where[name_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_tr"
                ]
            },
            "slugTr": {
                "key": "slugTr",
                "wireKey": "where[slug_tr][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_tr"
                ]
            },
            "nameEe": {
                "key": "nameEe",
                "wireKey": "where[name_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ee"
                ]
            },
            "slugEe": {
                "key": "slugEe",
                "wireKey": "where[slug_ee][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ee"
                ]
            },
            "nameLv": {
                "key": "nameLv",
                "wireKey": "where[name_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lv"
                ]
            },
            "slugLv": {
                "key": "slugLv",
                "wireKey": "where[slug_lv][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lv"
                ]
            },
            "nameUs": {
                "key": "nameUs",
                "wireKey": "where[name_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_us"
                ]
            },
            "slugUs": {
                "key": "slugUs",
                "wireKey": "where[slug_us][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_us"
                ]
            },
            "nameAu": {
                "key": "nameAu",
                "wireKey": "where[name_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_au"
                ]
            },
            "slugAu": {
                "key": "slugAu",
                "wireKey": "where[slug_au][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_au"
                ]
            },
            "nameCa": {
                "key": "nameCa",
                "wireKey": "where[name_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ca"
                ]
            },
            "slugCa": {
                "key": "slugCa",
                "wireKey": "where[slug_ca][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ca"
                ]
            },
            "nameCh": {
                "key": "nameCh",
                "wireKey": "where[name_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ch"
                ]
            },
            "slugCh": {
                "key": "slugCh",
                "wireKey": "where[slug_ch][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ch"
                ]
            },
            "nameIn": {
                "key": "nameIn",
                "wireKey": "where[name_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_in"
                ]
            },
            "slugIn": {
                "key": "slugIn",
                "wireKey": "where[slug_in][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_in"
                ]
            },
            "nameJp": {
                "key": "nameJp",
                "wireKey": "where[name_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_jp"
                ]
            },
            "slugJp": {
                "key": "slugJp",
                "wireKey": "where[slug_jp][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_jp"
                ]
            },
            "nameMx": {
                "key": "nameMx",
                "wireKey": "where[name_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_mx"
                ]
            },
            "slugMx": {
                "key": "slugMx",
                "wireKey": "where[slug_mx][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_mx"
                ]
            },
            "nameRs": {
                "key": "nameRs",
                "wireKey": "where[name_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_rs"
                ]
            },
            "slugRs": {
                "key": "slugRs",
                "wireKey": "where[slug_rs][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_rs"
                ]
            },
            "nameBa": {
                "key": "nameBa",
                "wireKey": "where[name_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_ba"
                ]
            },
            "slugBa": {
                "key": "slugBa",
                "wireKey": "where[slug_ba][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_ba"
                ]
            },
            "nameLt": {
                "key": "nameLt",
                "wireKey": "where[name_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "name_lt"
                ]
            },
            "slugLt": {
                "key": "slugLt",
                "wireKey": "where[slug_lt][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "slug_lt"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "where[position][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "where[is_active][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            },
            "tags": {
                "key": "tags",
                "wireKey": "where[tags][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tags"
                ]
            },
            "categories": {
                "key": "categories",
                "wireKey": "where[categories][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "categories"
                ]
            },
            "values": {
                "key": "values",
                "wireKey": "where[values][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "values"
                ]
            },
            "pricesStoreId": {
                "key": "pricesStoreId",
                "wireKey": "where[prices.store_id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.store_id"
                ]
            },
            "pricesPriceBeforeDiscount": {
                "key": "pricesPriceBeforeDiscount",
                "wireKey": "where[prices.price_before_discount][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.price_before_discount"
                ]
            },
            "pricesPriceWithVatBeforeDiscount": {
                "key": "pricesPriceWithVatBeforeDiscount",
                "wireKey": "where[prices.price_with_vat_before_discount][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.price_with_vat_before_discount"
                ]
            },
            "pricesPrice": {
                "key": "pricesPrice",
                "wireKey": "where[prices.price][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.price"
                ]
            },
            "pricesPriceWithVat": {
                "key": "pricesPriceWithVat",
                "wireKey": "where[prices.price_with_vat][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "prices.price_with_vat"
                ]
            },
            "tourDatesDateStart": {
                "key": "tourDatesDateStart",
                "wireKey": "where[tour_dates.date_start][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tour_dates.date_start"
                ]
            },
            "tourDatesDateStop": {
                "key": "tourDatesDateStop",
                "wireKey": "where[tour_dates.date_stop][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tour_dates.date_stop"
                ]
            },
            "tourDatesDaysCount": {
                "key": "tourDatesDaysCount",
                "wireKey": "where[tour_dates.days_count][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tour_dates.days_count"
                ]
            },
            "tourDatesNightsCount": {
                "key": "tourDatesNightsCount",
                "wireKey": "where[tour_dates.nights_count][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "tour_dates.nights_count"
                ]
            },
            "storesId": {
                "key": "storesId",
                "wireKey": "where[stores.id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.id"
                ]
            },
            "storesName": {
                "key": "storesName",
                "wireKey": "where[stores.name][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "stores.name"
                ]
            },
            "priceFrom": {
                "key": "priceFrom",
                "wireKey": "price_from",
                "operators": [],
                "legacyKeys": [
                    "price_from"
                ]
            },
            "priceTo": {
                "key": "priceTo",
                "wireKey": "price_to",
                "operators": [],
                "legacyKeys": [
                    "price_to"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "name": {
                "key": "name",
                "wireKey": "name",
                "legacyKeys": [
                    "name"
                ]
            },
            "slug": {
                "key": "slug",
                "wireKey": "slug",
                "legacyKeys": [
                    "slug"
                ]
            },
            "position": {
                "key": "position",
                "wireKey": "position",
                "legacyKeys": [
                    "position"
                ]
            },
            "active": {
                "key": "active",
                "wireKey": "is_active",
                "legacyKeys": [
                    "is_active"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "price": {
                "key": "price",
                "wireKey": "price",
                "legacyKeys": [
                    "price"
                ]
            },
            "nearestTourDate": {
                "key": "nearestTourDate",
                "wireKey": "nearest_tour_date",
                "legacyKeys": [
                    "nearest_tour_date"
                ]
            },
            "relevance": {
                "key": "relevance",
                "wireKey": "_score",
                "legacyKeys": [
                    "_score"
                ]
            },
            "stores": {
                "key": "stores",
                "wireKey": "stores",
                "legacyKeys": [
                    "stores"
                ]
            }
        }
    },
"storefrontJobPortalCustomerOffers": {
        "key": "storefrontJobPortalCustomerOffers",
        "method": "get",
        "endpoint": "/job-portal/customer/offers",
        "queryFormat": "payload",
        "booleanWhere": false,
        "multiSort": true,
        "filters": {},
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            },
            "paidAt": {
                "key": "paidAt",
                "wireKey": "paid_at",
                "legacyKeys": [
                    "paid_at"
                ]
            },
            "publishedAt": {
                "key": "publishedAt",
                "wireKey": "published_at",
                "legacyKeys": [
                    "published_at"
                ]
            },
            "toppedUpTo": {
                "key": "toppedUpTo",
                "wireKey": "topped_up_to",
                "legacyKeys": [
                    "topped_up_to"
                ]
            },
            "expiresAt": {
                "key": "expiresAt",
                "wireKey": "expires_at",
                "legacyKeys": [
                    "expires_at"
                ]
            }
        }
    },
"storeTagsProducts": {
        "key": "storeTagsProducts",
        "method": "get",
        "endpoint": "/store/tags/products",
        "queryFormat": "payload",
        "booleanWhere": false,
        "multiSort": false,
        "filters": {}
    },
"storeCategoriesProducts": {
        "key": "storeCategoriesProducts",
        "method": "get",
        "endpoint": "/store/categories/products",
        "queryFormat": "payload",
        "booleanWhere": false,
        "multiSort": false,
        "filters": {}
    },
"storefrontCourseCustomerPurchased": {
        "key": "storefrontCourseCustomerPurchased",
        "method": "get",
        "endpoint": "/course/customer/purchased",
        "queryFormat": "payload",
        "booleanWhere": false,
        "multiSort": false,
        "filters": {}
    },
"storefrontJobPortalCustomerContactStatistics": {
        "key": "storefrontJobPortalCustomerContactStatistics",
        "method": "get",
        "endpoint": "/job-portal/customer/contact-statistics",
        "queryFormat": "payload",
        "booleanWhere": false,
        "multiSort": false,
        "filters": {}
    },
"storeNotifications": {
        "key": "storeNotifications",
        "method": "get",
        "endpoint": "/store/notifications",
        "queryFormat": "payload",
        "booleanWhere": true,
        "multiSort": true,
        "filters": {
            "id": {
                "key": "id",
                "wireKey": "where[id][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "id"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "where[created_at][equals]",
                "operators": [
                    "equals",
                    "not_equals",
                    "greater_than",
                    "greater_than_equal",
                    "less_than",
                    "less_than_equal",
                    "like",
                    "contains",
                    "in",
                    "not_in",
                    "exists"
                ],
                "legacyKeys": [
                    "created_at"
                ]
            }
        },
        "sorts": {
            "id": {
                "key": "id",
                "wireKey": "id",
                "legacyKeys": [
                    "id"
                ]
            },
            "createdAt": {
                "key": "createdAt",
                "wireKey": "created_at",
                "legacyKeys": [
                    "created_at"
                ]
            }
        }
    }
};
export const storeApiResources = resources;
export { storeApiResources as apiResources };
const valuesOf = (record) => record ? Object.values(record) : [];
const matchesKey = (input, contract) => input === contract.key || input === contract.wireKey || contract.legacyKeys?.includes(input);
export const inferStableFilterKey = (wireKey) => {
    if (!wireKey.includes("[") && !/\s[<>]=?$/.test(wireKey))
        return wireKey;
    const fieldPath = wireKey.replace(/\[(?:and|or)\]\[\d+\]/g, "");
    const segments = fieldPath.match(/[A-Za-z0-9_.-]+/g)?.filter((segment) => !["where", "and", "or"].includes(segment.toLowerCase())) ?? [];
    if (segments[segments.length - 1]?.toLowerCase() === "equals")
        segments.pop();
    if (segments.length === 1 && segments[0].toLowerCase() === "is_active")
        return "active";
    if (segments.some((segment) => /^\d+$/.test(segment))) {
        throw new Error("Numeric filter paths require an explicit public key.");
    }
    const words = segments.flatMap((segment) => segment.toLowerCase().split(/[_.-]+/).filter(Boolean));
    return words.reduce((key, word, index) => index === 0 ? word : `${key}${word[0]?.toUpperCase() ?? ""}${word.slice(1)}`, "filter");
};
export const resolveFilter = (resource, key) => valuesOf(resource?.filters).find((filter) => matchesKey(key, filter));
export const resolveFilterWireKey = (resource, key) => resolveFilter(resource, key)?.wireKey ?? key;
export const resolveSort = (resource, key) => valuesOf(resource?.sorts).find((sort) => matchesKey(key, sort));
export const normalizeSortKey = (resource, key) => resolveSort(resource, key)?.key ?? key;
export const resolveSortWireKey = (resource, key) => resolveSort(resource, key)?.wireKey ?? key;
export const normalizeFilters = (filters, resource) => {
    const normalized = Object.values(filters ?? {}).reduce((result, item) => {
        if (!item || typeof item.id !== "string" || /^group\d+/.test(item.id))
            return result;
        const id = resolveFilter(resource, item.id)?.key ?? item.id;
        result[id] = { ...item, id };
        return result;
    }, {});
    return normalized;
};
const isEmptyValue = (value) => value === undefined || value === null ||
    (typeof value === "string" && value.length === 0) ||
    (Array.isArray(value) && value.length === 0);
const scalarValue = (value) => typeof value === "object" && value !== null && "id" in value
    ? value.id
    : value;
export const serializeFilters = (filters, resource) => {
    const parts = [];
    Object.values(filters ?? {}).forEach((item) => {
        if (!item || isEmptyValue(item.value))
            return;
        if (/^group\d+/.test(item.id))
            throw new Error(`Unknown filter [${item.id}].`);
        const contract = resolveFilter(resource, item.id);
        if (contract?.valueType) {
            throw new Error(`Filter [${contract.key}] requires a structured value; use the where builder option.`);
        }
        if (item.value === WITHOUT_RELATION_FILTER_VALUE && contract?.withoutRelationWireKey) {
            parts.push(`${contract.key}=${WITHOUT_RELATION_FILTER_VALUE}`);
            return;
        }
        const publicKey = contract?.key ?? item.id;
        if (Array.isArray(item.value)) {
            item.value.forEach((value, index) => {
                parts.push(`${publicKey}[${index}]=${encodeURIComponent(String(scalarValue(value)))}`);
            });
            return;
        }
        parts.push(`${publicKey}=${encodeURIComponent(String(scalarValue(item.value)))}`);
    });
    return parts.join("&");
};
const normalizeExpressionValue = (value) => {
    if (Array.isArray(value))
        return value.map(normalizeExpressionValue);
    return scalarValue(value);
};
// Object values are accepted only for explicitly declared virtual filters.
// Copy validated values so callers cannot mutate a descriptor after construction.
const normalizeStructuredValue = (contract, value) => {
    if (!value || typeof value !== "object" || Array.isArray(value)) {
        throw new Error(`Filter [${contract.key}] requires a valid ${contract.valueType} object.`);
    }
    const input = value;
    const finite = (item) => typeof item === "number" && Number.isFinite(item);
    const exactKeys = (keys) => Object.keys(input).length === keys.length
        && keys.every(key => Object.prototype.hasOwnProperty.call(input, key));
    if (contract.valueType === "geoRadius" && exactKeys(["latitude", "longitude", "radiusMeters"])
        && finite(input.latitude) && Math.abs(input.latitude) <= 90
        && finite(input.longitude) && Math.abs(input.longitude) <= 180
        && finite(input.radiusMeters) && input.radiusMeters >= 0) {
        return { latitude: input.latitude, longitude: input.longitude, radiusMeters: input.radiusMeters };
    }
    if (contract.valueType === "fieldValues" && exactKeys(["fieldId", "values"])
        && Number.isSafeInteger(input.fieldId) && input.fieldId > 0
        && Array.isArray(input.values) && Array.from(input.values).every(item => typeof item === "string" || finite(item))) {
        return { fieldId: input.fieldId, values: [...input.values] };
    }
    throw new Error(`Filter [${contract.key}] requires a valid ${contract.valueType} object.`);
};
const normalizeWhere = (where, resource, depth = 0) => {
    if (depth > 20 || typeof where !== "object" || where === null || Array.isArray(where)) {
        throw new Error("The where query is invalid or too deeply nested.");
    }
    const nodes = [];
    Object.entries(where).forEach(([key, condition]) => {
        if (key === "and" || key === "or") {
            if (resource.booleanWhere === false) {
                throw new Error(`Resource [${resource.key}] does not support boolean groups.`);
            }
            if (!Array.isArray(condition) || condition.length === 0) {
                throw new Error(`The [${key}] group must be a non-empty array.`);
            }
            nodes.push([
                key === "and" ? "a" : "o",
                ...condition.map((child) => normalizeWhere(child, resource, depth + 1)),
            ]);
            return;
        }
        const contract = resolveFilter(resource, key);
        if (!contract)
            throw new Error(`Unknown filter [${key}].`);
        if (!contract.wireKey.startsWith("where[") || contract.operators.length === 0) {
            throw new Error(`Filter [${contract.key}] cannot be used inside a where query.`);
        }
        if (typeof condition !== "object" || condition === null || Array.isArray(condition)) {
            throw new Error(`Filter [${contract.key}] requires a Payload-style operator object.`);
        }
        Object.entries(condition).forEach(([operator, value]) => {
            if (!contract.operators.includes(operator)) {
                throw new Error(`Operator [${operator}] is not allowed for filter [${contract.key}].`);
            }
            if (contract.valueType) {
                nodes.push(["f", contract.key, operator, normalizeStructuredValue(contract, value)]);
                return;
            }
            const normalizedValue = normalizeExpressionValue(value);
            const values = Array.isArray(normalizedValue) ? normalizedValue : [normalizedValue];
            if (values.some(item => item === undefined || item === null || (typeof item === "object" && !(item instanceof Date)))) {
                throw new Error("Filter values must be scalars; use exists for missing values.");
            }
            if (Array.isArray(value) && !value.length)
                throw new Error("Empty filter arrays must be omitted.");
            nodes.push(["f", contract.key, operator, normalizedValue]);
        });
    });
    if (nodes.length === 0)
        throw new Error("The where query must contain at least one condition.");
    return nodes.length === 1 ? nodes[0] : ["a", ...nodes];
};
export const buildWhereParams = (where, resource) => {
    const value = JSON.stringify(normalizeWhere(where, resource));
    if (encodeURIComponent(value).length > FILTER_EXPRESSION_RECOMMENDED_MAX_LENGTH) {
        throw new Error("The filter expression is too long for a safe GET request; use a POST search endpoint.");
    }
    return { [FILTER_EXPRESSION_PARAMETER]: value };
};
export const serializeWhere = (where, resource) => {
    if (!where)
        return "";
    if (!resource)
        throw new Error("The API resource is required for a where query.");
    return Object.entries(buildWhereParams(where, resource))
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&");
};
const normalizeSortValues = (sort, resource) => (Array.isArray(sort) ? sort : [sort]).map((value) => {
    const descending = value.startsWith("-");
    const key = descending ? value.slice(1) : value;
    const contract = resolveSort(resource, key);
    if (!contract)
        throw new Error(`Unknown sort [${key}].`);
    return descending ? `-${contract.key}` : contract.key;
});
export const createSort = (resource, key, direction = "asc") => {
    const contract = resolveSort(resource, key);
    if (!contract)
        throw new Error(`Unknown sort [${key}].`);
    if (direction !== "asc" && direction !== "desc") {
        throw new Error(`Unknown sort direction [${direction}].`);
    }
    return `${direction === "desc" ? "-" : ""}${contract.key}`;
};
export const serializeSort = (sort, resource) => {
    if (!sort)
        return "";
    if (!resource)
        throw new Error("The API resource is required for sorting.");
    const values = normalizeSortValues(sort, resource);
    if (resource.multiSort === false && values.length > 1)
        throw new Error("This resource accepts only one sort.");
    return `sort=${encodeURIComponent(normalizeSortValues(sort, resource).join(","))}`;
};
/** Validate supplied contexts; the current backend also requires context for every selected contextual sort. */
export const serializeSortContext = (context, sort, resource) => {
    if (context === undefined)
        return "";
    if (!resource || !sort || !context || typeof context !== "object" || Array.isArray(context)) {
        throw new Error("A sorting context requires a resource, explicit sort and context object.");
    }
    const keys = normalizeSortValues(sort, resource).map(value => value.replace(/^-/, ""));
    const supplied = context;
    const entries = [];
    const id = (value) => Number.isSafeInteger(value) && Number(value) > 0;
    for (const key of Object.keys(supplied)) {
        if (!keys.includes(key) || !resource.sorts?.[key]?.context) {
            throw new Error(`Sorting context [${key}] does not belong to a selected contextual sort.`);
        }
    }
    for (const key of keys) {
        const definition = resource.sorts?.[key]?.context;
        if (!definition)
            continue;
        const value = supplied[key];
        if (keys.filter(candidate => candidate === key).length !== 1 || !value || typeof value !== "object" || Array.isArray(value)) {
            throw new Error(`Sorting context [${key}] is missing or duplicated.`);
        }
        const input = value;
        const allowed = definition.kind === "tagDate" ? ["tagIds", "dateSelection"]
            : [definition.kind === "segment" ? "segmentId" : "categoryId"];
        if (Object.keys(input).some(field => !allowed.includes(field))) {
            throw new Error(`Sorting context [${key}] contains an unknown property.`);
        }
        const prefix = `sortContext[${key}]`;
        if (definition.kind === "tagDate") {
            const ids = input.tagIds;
            if (!Array.isArray(ids) || !ids.length || ids.length > definition.maxIds || !ids.every(id)
                || new Set(ids).size !== ids.length || (input.dateSelection !== "earliest" && input.dateSelection !== "latest")) {
                throw new Error(`Sorting context [${key}] requires distinct positive tag IDs and earliest/latest date selection.`);
            }
            [...ids].sort((a, b) => a - b).forEach((value, index) => entries.push([`${prefix}[tagIds][${index}]`, String(value)]));
            entries.push([`${prefix}[dateSelection]`, String(input.dateSelection)]);
        }
        else {
            const field = allowed[0];
            if (!id(input[field]))
                throw new Error(`Sorting context [${key}] requires a positive ${field}.`);
            entries.push([`${prefix}[${field}]`, String(input[field])]);
        }
    }
    return entries.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&");
};
export const appendQueryString = (base, ...parts) => {
    const trimmedBase = base.trim();
    const normalizedBase = trimmedBase
        ? trimmedBase.startsWith("?") ? trimmedBase : `?${trimmedBase}`
        : "";
    return parts.reduce((result, part) => {
        const normalizedPart = part.replace(/^\?/, "").trim();
        if (!normalizedPart)
            return result;
        return `${result}${result.includes("?") ? "&" : "?"}${normalizedPart}`;
    }, normalizedBase);
};
const assertPublicTransport = (endpoint, apiParams, params) => {
    const keys = [...new URL(endpoint, "https://contract.invalid").searchParams.keys(),
        ...new URLSearchParams(apiParams.replace(/^\?/, "")).keys(), ...Object.keys(params)];
    if (keys.some(key => /^(filter|orderByFilter|where|orderBy|order)(\[|$)/.test(key))) {
        throw new Error("Retired listing parameters are forbidden. Use public filters, where and sort builder options.");
    }
};
export const buildListRequest = ({ resource, fallbackEndpoint, apiParams = "", filters, where, params = {}, orderBy, sort, sortContext, }) => {
    if (Object.keys(params).some(key => key === "sortContext" || key.startsWith("sortContext["))) {
        throw new Error("Pass sorting context through the typed sortContext option.");
    }
    const queryKeys = [...new URLSearchParams(apiParams.replace(/^\?/, "")).keys()];
    const isContextKey = (key) => key === "sortContext" || key.startsWith("sortContext[");
    if (queryKeys.some(isContextKey)) {
        throw new Error("Pass sorting context through the typed sortContext option.");
    }
    const isSortKey = (key) => /^(sort|orderBy|order)(\[|$)/.test(key);
    if (sortContext !== undefined && (Object.keys(params).some(isSortKey) || queryKeys.some(isSortKey))) {
        throw new Error("An explicit sorting context cannot be combined with raw sorting parameters.");
    }
    if (orderBy !== undefined)
        throw new Error("Retired orderBy option is forbidden. Use sort.");
    const endpoint = resolveRequestEndpoint(resource, fallbackEndpoint, resource?.endpoint);
    if (!endpoint)
        throw new Error("The API resource or fallback endpoint is required.");
    assertPublicTransport(endpoint, apiParams, params);
    return {
        method: resource?.method ?? "get",
        url: `${endpoint}${appendQueryString(apiParams, serializeFilters(filters, resource), serializeWhere(where, resource), serializeSort(sort, resource), serializeSortContext(sortContext, sort, resource))}`,
        params: { ...params },
    };
};
export const buildReorderRequest = ({ resource, fallbackEndpoint, apiParams = "", filters, where, params = {}, orderBy, sort, }) => {
    if (orderBy !== undefined)
        throw new Error("Retired orderBy option is forbidden. Use sort.");
    const listEndpoint = resolveRequestEndpoint(resource, fallbackEndpoint, resource?.endpoint);
    const endpoint = resource?.reorder
        ? resolveRequestEndpoint(resource, fallbackEndpoint, resource.reorder.endpoint)
        : (listEndpoint ? `${listEndpoint}/reorder` : "");
    if (!endpoint)
        throw new Error("The API resource or fallback endpoint is required.");
    assertPublicTransport(endpoint, apiParams, params);
    return {
        method: resource?.reorder?.method ?? "put",
        url: `${endpoint}${appendQueryString(apiParams, serializeFilters(filters, resource), serializeWhere(where, resource), serializeSort(sort, resource))}`,
        params: { ...params },
    };
};
const endpointPath = (endpoint) => {
    const withoutQuery = endpoint.split(/[?#]/, 1)[0] ?? "";
    try {
        const path = /^[a-z][a-z\d+.-]*:\/\//i.test(withoutQuery)
            ? new URL(withoutQuery).pathname
            : withoutQuery;
        const normalized = path.startsWith("/api/") ? path.slice(4) : path;
        return `/${normalized.replace(/^\/+|\/+$/g, "")}`;
    }
    catch {
        return `/${withoutQuery.replace(/^\/+|\/+$/g, "")}`;
    }
};
const endpointSegments = (endpoint) => endpointPath(endpoint).split("/").filter(Boolean);
const matchesEndpointTemplate = (template, endpoint) => {
    const templateParts = endpointSegments(template);
    const endpointParts = endpointSegments(endpoint);
    const requiredParts = templateParts.filter((part) => !/^\{[^}]+\?\}$/.test(part));
    if (endpointParts.length < requiredParts.length || endpointParts.length > templateParts.length)
        return false;
    return endpointParts.every((part, index) => {
        const templatePart = templateParts[index];
        return !!templatePart && (/^\{[^}]+\??\}$/.test(templatePart) || templatePart === part);
    });
};
const endpointTemplates = (resource) => [
    resource.endpoint,
    ...(resource.legacyEndpoints ?? []),
    ...(resource.reorder ? [resource.reorder.endpoint] : []),
];
const remapEndpointTemplate = (input, sourceTemplate, targetTemplate) => {
    const inputParts = endpointSegments(input);
    const sourceParts = endpointSegments(sourceTemplate);
    const values = sourceParts.flatMap((part, index) => /^\{[^}]+\??\}$/.test(part) ? [inputParts[index]] : []);
    const namedValues = sourceParts.reduce((result, part, index) => {
        const match = part.match(/^\{([^}?]+)\??\}$/);
        if (match)
            result[match[1]] = inputParts[index];
        return result;
    }, {});
    let valueIndex = 0;
    const targetPath = `/${endpointSegments(targetTemplate).map((part) => {
        const match = part.match(/^\{([^}?]+)\??\}$/);
        if (!match)
            return part;
        const fallbackValue = values[valueIndex++];
        return namedValues[match[1]] ?? fallbackValue ?? "";
    }).filter(Boolean).join("/")}`;
    if (!/^[a-z][a-z\d+.-]*:\/\//i.test(input))
        return targetPath;
    const absolute = new URL(input);
    absolute.pathname = targetPath;
    absolute.search = "";
    absolute.hash = "";
    return absolute.toString();
};
function resolveRequestEndpoint(resource, fallbackEndpoint, targetEndpoint) {
    if (!fallbackEndpoint)
        return targetEndpoint;
    if (!resource || !targetEndpoint)
        return fallbackEndpoint;
    const queryIndex = fallbackEndpoint.indexOf("?");
    const hashIndex = fallbackEndpoint.indexOf("#");
    const pathEnd = [queryIndex, hashIndex]
        .filter((index) => index >= 0)
        .sort((a, b) => a - b)[0] ?? fallbackEndpoint.length;
    const originalPath = fallbackEndpoint.slice(0, pathEnd);
    const suffix = fallbackEndpoint.slice(pathEnd);
    const sourceTemplate = endpointTemplates(resource).find((template) => matchesEndpointTemplate(template, originalPath));
    if (!sourceTemplate)
        return fallbackEndpoint;
    const targetPath = remapEndpointTemplate(originalPath, sourceTemplate, targetEndpoint);
    const queryEnd = suffix.indexOf("#");
    const query = queryEnd === -1 ? suffix : suffix.slice(0, queryEnd);
    const hash = queryEnd === -1 ? "" : suffix.slice(queryEnd);
    return `${targetPath}${remapQueryString(query, resource)}${hash}`;
}
export const findApiResourceByEndpoint = (endpoint) => valuesOf(resources).find((resource) => endpointTemplates(resource).some((template) => matchesEndpointTemplate(template, endpoint)));
const remapSerializedFilterKey = (resource, inputKey) => {
    for (const filter of valuesOf(resource.filters)) {
        for (const candidate of [filter.key, filter.wireKey, ...(filter.legacyKeys ?? [])]) {
            if (inputKey === candidate)
                return filter.key;
            if (inputKey.startsWith(`${candidate}[`) && /^\[\d+\]/.test(inputKey.slice(candidate.length))) {
                return `${filter.key}${inputKey.slice(candidate.length)}`;
            }
        }
    }
    return inputKey;
};
export const remapQueryString = (query, resource) => {
    if (!resource || !query)
        return query;
    const prefix = query.startsWith("?") ? "?" : "";
    const input = query.replace(/^\?/, "");
    if (!input)
        return prefix;
    const parts = input.split("&");
    const decodedPart = (part) => {
        const separator = part.indexOf("=");
        const rawKey = separator === -1 ? part : part.slice(0, separator);
        const rawValue = separator === -1 ? "" : part.slice(separator + 1);
        let key = rawKey;
        let value = rawValue;
        try {
            key = decodeURIComponent(rawKey);
        }
        catch { /* Keep malformed input unchanged. */ }
        try {
            value = decodeURIComponent(rawValue);
        }
        catch { /* Keep malformed input unchanged. */ }
        return [key, value];
    };
    const decoded = parts.map(decodedPart);
    const hasPayloadSort = decoded.some(([key]) => key === "sort");
    const legacySortFields = decoded.filter(([key]) => key === "orderBy")
        .flatMap(([, value]) => value.split(",").map((item) => item.trim()).filter(Boolean));
    const legacySortDirections = decoded.filter(([key]) => key === "order")
        .flatMap(([, value]) => value.split(",").map((item) => item.trim()).filter(Boolean));
    const canConvertLegacySort = legacySortFields.length > 0 && legacySortFields.every((field) => !!resolveSort(resource, field));
    const mapped = parts.filter((part, index) => {
        const [key] = decoded[index];
        return !(hasPayloadSort || canConvertLegacySort) || (key !== "orderBy" && key !== "order");
    }).map((part) => {
        const separator = part.indexOf("=");
        const rawKey = separator === -1 ? part : part.slice(0, separator);
        const value = separator === -1 ? "" : part.slice(separator);
        let decodedKey = rawKey;
        try {
            decodedKey = decodeURIComponent(rawKey);
        }
        catch { /* Keep malformed input unchanged. */ }
        if (decodedKey === "orderBy" && value.startsWith("=")) {
            let decodedValue = value.slice(1);
            try {
                decodedValue = decodeURIComponent(decodedValue);
            }
            catch { /* Keep malformed input unchanged. */ }
            return `${rawKey}=${normalizeSortKey(resource, decodedValue)}`;
        }
        return `${remapSerializedFilterKey(resource, decodedKey)}${value}`;
    });
    if (!hasPayloadSort && canConvertLegacySort) {
        const sort = legacySortFields.map((field, index) => createSort(resource, field, legacySortDirections[index] === "desc" ? "desc" : "asc"));
        mapped.push(`sort=${encodeURIComponent(sort.join(","))}`);
    }
    return `${prefix}${mapped.join("&")}`;
};
export const remapRequestUrl = (url) => {
    const resource = findApiResourceByEndpoint(url);
    if (!resource)
        return url;
    const queryIndex = url.indexOf("?");
    const hashIndex = url.indexOf("#");
    const pathEnd = [queryIndex, hashIndex].filter((index) => index >= 0).sort((a, b) => a - b)[0] ?? url.length;
    const originalPath = url.slice(0, pathEnd);
    const suffix = url.slice(pathEnd);
    const queryEnd = suffix.indexOf("#");
    const query = queryEnd === -1 ? suffix : suffix.slice(0, queryEnd);
    const hash = queryEnd === -1 ? "" : suffix.slice(queryEnd);
    const legacyTemplate = resource.legacyEndpoints?.find((template) => matchesEndpointTemplate(template, originalPath));
    const targetPath = legacyTemplate
        ? remapEndpointTemplate(originalPath, legacyTemplate, resource.endpoint)
        : originalPath;
    return `${targetPath}${remapQueryString(query, resource)}${hash}`;
};
export const remapRequestParams = (params, endpoint) => {
    const resource = findApiResourceByEndpoint(endpoint);
    if (!resource || !params)
        return params;
    const hasPayloadSort = Object.prototype.hasOwnProperty.call(params, "sort");
    const rawSortFields = Array.isArray(params.orderBy) ? params.orderBy : [params.orderBy];
    const sortFields = rawSortFields.filter((item) => typeof item === "string");
    const rawSortDirections = Array.isArray(params.order) ? params.order : [params.order];
    const sortDirections = rawSortDirections.filter((item) => typeof item === "string");
    const canConvertLegacySort = sortFields.length > 0 && sortFields.every((field) => !!resolveSort(resource, field));
    return Object.entries(params).reduce((result, [key, value]) => {
        if ((hasPayloadSort || canConvertLegacySort) && (key === "orderBy" || key === "order")) {
            return result;
        }
        if (key === "orderBy" && typeof value === "string") {
            result[key] = normalizeSortKey(resource, value);
        }
        else if (key === "orderBy" && Array.isArray(value)) {
            result[key] = value.map((item) => typeof item === "string" ? normalizeSortKey(resource, item) : item);
        }
        else {
            result[remapSerializedFilterKey(resource, key)] = value;
        }
        return result;
    }, canConvertLegacySort && !hasPayloadSort ? {
        sort: sortFields.map((field, index) => createSort(resource, field, sortDirections[index] === "desc" ? "desc" : "asc")),
    } : {});
};
